webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/danxiag-one.916246d.png";

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/even-map.386cdac.png";

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAeCAYAAAAy2w7YAAAAAXNSR0IArs4c6QAAAb9JREFUSA21lksoBWEUx4frcb1SKOWxYSGKLGQhOzsLpbvTjStSsrGysbBVSlnYWLOytGUhGynvIguPUspGFoo84nfyTU1z57vz+ubUrzNzvnP+//lu803XsiyrDToh0Uih/gWb0ArH6p6UTEwg+wvnMJyMxb9qBUl2I2Y/sA0dkEiMoypGNq9cL0EtGA3Z1SnYRna+ppaBYjAWOZRsA3feYa3blFMlQmcFzN5YW4Y6iB2TKLh3476/pScLcjwih+xKXnO3uNf9Ln19kZ0YnApoJObvsAaNEDqqmLgAr13oao/0T0MZhAoZ0okWqh8wNxjGqZrmy4hmn8xtQAsEihm6Cj2939oz8wuQ9jvtcT8/9Zh0QTloQ5ruwe+pdev7zA5o1R0L8xFNHpjLQSn4hvxkN6B7Wq+6fJ5WoAECxyydXmK6mnxwewKrq0Y5rEFf6yt6R6FIzYZKQT6qLyguQk0oZUdzmusT0P1E36xtQTvEijGmdSZHrA3FUlfD8joegtvoidocyG6NRAYVp8kH9+vQZERdiaTIcpJtoz2u+9Wa0TSiTO7IWSgxqq7ERFQO3CoY+dOhdPNSM5XevKrhwh+/LPCwBtOf8gAAAABJRU5ErkJggg=="

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(773),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title-header.e09a4ef.png";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(754),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var urls = "http://cp.66nao.com/nao-personal";
var urlApi = 'http://njc.66nao.com/nao-doctor/api';
var urlReport = 'http://njc.66nao.com/nao-doctor';
/* harmony default export */ __webpack_exports__["a"] = ({
	urltest: urls,
	urlApi: urlApi,
	urlReport: urlReport
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(362);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);



var state = {
	navCount: 0,
	tyleCount: 1,
	comboCount: 1
};
var actions = {
	changeIndex: function changeIndex(_ref, navInd) {
		var commit = _ref.commit,
		    state = _ref.state;

		commit("changeIndex", navInd);
	},
	getCurrentTyle: function getCurrentTyle(_ref2, tyleInd) {
		var commit = _ref2.commit,
		    state = _ref2.state;

		commit("getCurrentTyle", tyleInd);
	},
	getCurrentCombo: function getCurrentCombo(_ref3, comboInd) {
		var commit = _ref3.commit,
		    state = _ref3.state;

		commit("getCurrentCombo", comboInd);
	}
};
var mutations = {
	changeIndex: function changeIndex(state, navInd) {
		state.navCount = navInd;
		console.log(navInd);
	},
	getCurrentTyle: function getCurrentTyle(state, tyleInd) {
		state.tyleCount = tyleInd;
	},
	getCurrentCombo: function getCurrentCombo(state, comboInd) {
		state.comboCount = comboInd;
	}
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: __WEBPACK_IMPORTED_MODULE_2__getters__

}));

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/childTitle-three-one.cd9cc83.png";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/childTitle-three.8ce513d.png";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/childTitle.595e6e2.png";

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAKFJREFUOBGNk1kOgzAMRF3u/0HLD8txulwLZlCCplGwHWkUh/gNmMRmZj/oBT2g7GDuBH0JEN6hFcqYMGcrzIj5hJbyIDJRmMz1QgaRicKzwojP4ZmEsGeShu9M6g/rfnaF2lnL4QndwkNLylr3NJaUftjWHJ3On0sLc63luPekB1f30MSDQ5MM7Jqwq9yjqnSZtRw2on0gdhU3soO5T+h9AK28PU67BZj6AAAAAElFTkSuQmCC"

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/QR-code.c73930f.jpg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/houji-two.957bf3c.png";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/postscript.0b09460.png";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/read-guid.841a5b6.png";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/read-prin.52f0223.png";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/report-corver.c1190c3.png";

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/report-size.7181540.png";

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Group.52c3ed7.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mind.5716b8b.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brain.e576405.png";

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAABINJREFUSA2dVl1oHFUUPvfemf1JtjFJSWOJ0VAJ2aZ1I/gDFordBIqlJMYKii8i+CIi4n8bn/ZFoa5W0AcfrFq0IBT8XYsRKd0GBR+qtkk2tTYxbZJam59NxG52d+7cez13NrO72W2z2R7YmTNnzjnf+b2zDKokpRRBovF4XFVjSiopH/huuIGAGQYCDwKorVKqjdoGwZL4/AeyQ1ylT77Te+/8Wr5uCPTCV7/Xez3e5yghT1PG2ghloKR0fitAQFhOJgWfxkw/zqbgvXcf24YBlNN1gfZ/PbKDeswPmOkJCW6BFHa5ZZEEAwFmekHw7Jid4c9G94VOFb122DKg/bHRXmoYn1FCb7ERpBrCwLCa8hrn2aeifV1fFNuuAhqIDT8AzDOI/aiT9tpZFDsp5ikz8FGlbJvvjfYVMqOuku6JIuwwpfSmQbQvXWbsZy0l7MOBL885g6PleSAvY8+bXn+nLpfCwbWlAj2/1fwcGzTQfTX9/nZpyJc0iCandJHBRGOawzBltEXYAvweBns7m2FTwJvTWud1PmXB8cQ/kLIEMINhduKq4CL09r6uWV1QyNjQY3g8LbaVBY4jfP/mRrivtWGd7gtqdzTUwMy/GTg1PgdEABheXzPI9G7UOOoASSW7DZqrooGRjF/4Cw6f/QVrna9swdsanBISkrVNYPgaseYKy4UFYzScB0JBUAkMAUkDTUxOw+DQCVxIJw5Hvp6LntQ7d+6CW7uasE82SIk+lQrihZBjxxQ77U/8ZhhmSNgcFGZRu3QFapIz2MEqM8KypzfeBqn6zUCQ16OOU3jOnyZ3G2NjcULvacoHbHMBoW3t0N/VnZdVwxxPXIET4/PgYfkgyULgEqGRSNhWRC3hKZn3JzGam6Vi21yP1dL7e/ZYOVhFzuvzqhKJVBLSMyOOmn1tAfnRHP/fHGQuJ5DXW1cgXH58IH9iEmolPxJXuKAu5RTcp8I9PT0MyaFP8DgTkJ46A8mfjqBvCcuTv0Ly508dvtRWgYxrD85YUeb50bYyVzGrZoJO5uYW8FWrfr+KAsFdEOjYgUEy2NDZAxu27nQGpi70ENSFulGXwezsLFBiOKthZzMLhmkMaif5xhyIJd40ff4BjsfH4kQCWhcT0HZ7a26X3GRRGz+umAT2sITXVbs0NQUX6zqgsT0EJp7kVmb50MHe7S9roPyicDAOqczy43jUb6lvC8L5TAZOJy47jrViJVJYwkBTG7Rs6QRKCVjZ9JSkJOra5TPSgtdiZ3sY88aQ9TsR41e1GnIyRUCMLiu59cjBvtD3rv0qIC189dvRJ3B5P8IK+QXnrt667swwdQWzNs8+g9+iI8VGK1NXEEX7tn9uC6sfp3DC9NVgjypnpfdF6+L/hovSsh4tBdHeyzJyIV//ZqRZmcYrGOGTmOEmLddnl7sG+C8Ij5hcEDbn87gqRwWn0bceDv7t+ii+3xDIVXoxdqbFR327cR/CGHEHhp37fhC6SEBdwH7EGRc/vNF/17Rrc717RaBSo8jJSZ+WRcJtWSyIO/ilamXP/wMqh9wYjRjhFwAAAABJRU5ErkJggg=="

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/carried-out.0ce9149.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jia-one.090d68e.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jiagong-two.2a3956e.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/linhuo-talent.5804c4a.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lj-talent.5965eea.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/luoji-talent.69ed221.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/memory-talent.1ad57c4.png";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoj-1.2ffdda4.png";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoj-2.753649c.png";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoj-3.724ac88.png";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoj-4.4ab27f8.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naol-1.6768c20.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naol-2.cabdb04.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naol-3.162e973.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naol-4.6a40cad.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoq-1.c91a862.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoq-2.a9d4b90.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoq-3.4998e72.png";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoq-4.d9852b5.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoz-1.de89af8.png";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoz-2.5040478.png";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoz-3.a27fcf2.png";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/naoz-4.eb74fa2.png";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qingjign-one.825893b.png";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qingjing-one-one.84028ae.png";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scene.c1a61a6.png";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/speed.add1521.png";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/table-co.1ceb7d5.png";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title-left.fd12ab9.png";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tuxin-tw.cd54c38.png";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tuxing-one.1aac54f.png";

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZwAAAACCAYAAABsWmq+AAAAAXNSR0IArs4c6QAAAEdJREFUSA1jfPfuHf/379+9GEbBaAiMhsBoCIyGwGgI0CgEuLm5d7D8+/ePh5GR0ZdGdowaOxoCoyEwGgKjITAaAgzAjs1xAMfkDemR8dJJAAAAAElFTkSuQmCC"

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yanyu-talent.5e8eeae.png";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/you-know.068ff14.png";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/youknow-two.8a83e3d.png";

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhixing-one.16d0dc0.png";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(771),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mockjs__);


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock('http://g.cn', {

          'name': '@name',

          'age|1-100': 100,

          'color': '@color'

}));

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guide__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_guide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_setinfo__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_setinfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_setinfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mybaogao__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mybaogao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_mybaogao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ordermanagement__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ordermanagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ordermanagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_payment__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_successfulpayment__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_successfulpayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_successfulpayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_startTest__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_startTest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_startTest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_gamelist__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_gamelist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_gamelist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_gameover__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_gameover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_gameover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_viewreport__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_viewreport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_viewreport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_reportpage__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_reportpage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_reportpage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pay__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_pay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_carrypay__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_carrypay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_carrypay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_print__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_payQuest__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_payQuest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_payQuest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_payWeChat__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_payWeChat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_payWeChat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_cardSucc__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_cardSucc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_cardSucc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_setpassword__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_setpassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_setpassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_mechanismPrin__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_mechanismPrin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_mechanismPrin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_mechanismCard__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_mechanismCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_mechanismCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__phonecomponents_pindex__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__phonecomponents_pindex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__phonecomponents_pindex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__phonecomponents_home__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__phonecomponents_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__phonecomponents_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__phonecomponents_mybaogao__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__phonecomponents_mybaogao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__phonecomponents_mybaogao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__phonecomponents_payment__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__phonecomponents_payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__phonecomponents_payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__phonecomponents_ordermanagement__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__phonecomponents_ordermanagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__phonecomponents_ordermanagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__phonecomponents_setinfo__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__phonecomponents_setinfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__phonecomponents_setinfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__phonecomponents_report__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__phonecomponents_report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__phonecomponents_report__);































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var CW = document.body.clientWidth;
var routerArr = null;

if (CW <= 500) {
      routerArr = [{
            path: '/',
            name: 'pindex',
            component: __WEBPACK_IMPORTED_MODULE_23__phonecomponents_pindex___default.a,
            children: [{
                  path: '/',
                  component: __WEBPACK_IMPORTED_MODULE_24__phonecomponents_home___default.a
            }, {
                  path: '/pmybaogao',
                  component: __WEBPACK_IMPORTED_MODULE_25__phonecomponents_mybaogao___default.a
            }, {
                  path: '/ppayment',
                  component: __WEBPACK_IMPORTED_MODULE_26__phonecomponents_payment___default.a
            }, {
                  path: '/pordermanagement',
                  component: __WEBPACK_IMPORTED_MODULE_27__phonecomponents_ordermanagement___default.a
            }, {
                  path: "/psetinfo",
                  component: __WEBPACK_IMPORTED_MODULE_28__phonecomponents_setinfo___default.a
            }, {
                  path: "/report",
                  component: __WEBPACK_IMPORTED_MODULE_29__phonecomponents_report___default.a
            }]
      }];
} else {
      routerArr = [{
            path: '/',
            name: 'index',
            component: __WEBPACK_IMPORTED_MODULE_2__components_index___default.a,
            children: [{
                  path: '/',
                  component: __WEBPACK_IMPORTED_MODULE_3__components_guide___default.a
            }, {
                  path: '/mybaogao',
                  component: __WEBPACK_IMPORTED_MODULE_5__components_mybaogao___default.a
            }, {
                  path: '/setinfo',
                  component: __WEBPACK_IMPORTED_MODULE_4__components_setinfo___default.a
            }, {
                  path: '/ordermanagement',
                  component: __WEBPACK_IMPORTED_MODULE_6__components_ordermanagement___default.a
            }, {
                  path: '/payment',
                  component: __WEBPACK_IMPORTED_MODULE_7__components_payment___default.a
            }, {
                  path: '/successfulpayment',
                  component: __WEBPACK_IMPORTED_MODULE_8__components_successfulpayment___default.a
            }, {
                  path: '/cardSucc',
                  component: __WEBPACK_IMPORTED_MODULE_19__components_cardSucc___default.a
            }, {
                  path: '/startTest',
                  component: __WEBPACK_IMPORTED_MODULE_9__components_startTest___default.a
            }, {
                  path: '/payWeChat',
                  component: __WEBPACK_IMPORTED_MODULE_18__components_payWeChat___default.a
            }, {
                  path: '/gamelist',
                  component: __WEBPACK_IMPORTED_MODULE_10__components_gamelist___default.a
            }, {
                  path: '/gameover',
                  component: __WEBPACK_IMPORTED_MODULE_11__components_gameover___default.a
            }, {
                  path: '/viewreport',
                  component: __WEBPACK_IMPORTED_MODULE_12__components_viewreport___default.a
            }, {
                  path: '/mechanismCard',
                  component: __WEBPACK_IMPORTED_MODULE_22__components_mechanismCard___default.a
            }, {
                  path: '/reportpage',
                  component: __WEBPACK_IMPORTED_MODULE_13__components_reportpage___default.a
            }, {
                  path: '/mechanismPrin',
                  component: __WEBPACK_IMPORTED_MODULE_21__components_mechanismPrin___default.a
            }, {
                  path: '/pay',
                  component: __WEBPACK_IMPORTED_MODULE_14__components_pay___default.a
            }, {
                  path: '/carrypay',
                  component: __WEBPACK_IMPORTED_MODULE_15__components_carrypay___default.a
            }, {
                  path: '/payQuest',
                  component: __WEBPACK_IMPORTED_MODULE_17__components_payQuest___default.a
            }, {
                  path: '/setpassword',
                  component: __WEBPACK_IMPORTED_MODULE_20__components_setpassword___default.a
            }]
      }, {
            path: '/print',
            component: __WEBPACK_IMPORTED_MODULE_16__components_print___default.a
      }];
}
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
      saveScrollPosition: true,
      routes: routerArr
}));

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var urlLogin = "http://njc.66nao.com/nao-login/user";
/* harmony default export */ __webpack_exports__["a"] = ({
	urlLoginTest: urlLogin
});

/***/ }),
/* 301 */,
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(757),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app'
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	created: function created() {
		var _this = this;

		setTimeout(function () {
			_this.$http.post(urls.urltest + "/personal/checkUser.json", {
				token: localStorage.getItem('token'),
				phone: localStorage.getItem('phone')
			}).then(function (res) {
				if (res.body == '0') {
					this.$router.push('/startTest');
				} else {
					this.$router.push('/gamelist');
				}
			});
		}, 3000);
	}
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.$http.post(urls.urltest + "/alipay/repay", {
			token: localStorage.getItem('token'),
			ordernumber: localStorage.getItem('orderNumber')
		}).then(function (ress) {
			this.content = ress.body;
			setTimeout(function () {
				document.getElementById('myfroms').innerHTML = ress.body;
				document.forms[0].submit();
			});
		});
	}
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			usergame: {},
			gameListInfo: {},
			userEid: {},
			gametoken: {},
			gameStatus: {}
		};
	},
	created: function created() {
		var gameEid = localStorage.getItem('eid');
		if (gameEid == '' || gameEid == undefined || gameEid == null) {
			location.href = "/#/";
		} else {
			this.$http.post(urls.urltest + '/game/getMyGames.json', {
				token: localStorage.getItem('token'),
				eid: gameEid
			}).then(function (res) {
				console.log(res.body);
				this.usergame = res.body.name;
				this.gametoken = res.body.token;
				this.gameListInfo = res.body.object;
				this.gameStatus = res.body.gameStatus;
				$(window).focus(function () {
					location.reload();
				});
			});
		}
	},

	methods: {
		imgIcon: function imgIcon(gameUrl, gameID) {
			var eid = localStorage.getItem('eid');
			console.log(gameID);
			console.log(eid);
			window.open(gameUrl + '?eid=' + eid + '&egid=' + gameID);
		}
	}
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	methods: {
		carryGame: function carryGame() {
			this.$http.post(urls.urltest + "/game/getNextGame.json", {
				token: localStorage.getItem('token'),
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				if (!res.body == '') {
					console.log(res.body);
					window.location.href = res.body;
				} else {
					this.$router.push('/gamelist');
				}
			});
		}
	}
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			editionList: [{
				imgSrc: '../assets/01.png',
				title: '青年版（17-44周岁）'
			}, {
				imgSrc: '../assets/guide2.png',
				title: '中年版（45-60周岁）'
			}, {
				imgSrc: '../assets/guide3.png',
				title: '老年版（60周岁以上）'
			}],
			mySwiper: null
		};
	},
	created: function created() {
		var _this = this;
		setTimeout(function () {
			_this.mySwiper = new Swiper('.swiper-container', {
				direction: 'horizontal',
				loop: true,

				pagination: '.swiper-pagination',

				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				autoplay: 5000
			});
		}, 200);
	},

	methods: {
		goPayment: function goPayment(ind) {
			this.$router.replace({ path: '/payment', query: { pID: ind } });
		}
	}
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(41);






var props = {
	name: {
		type: String,
		default: ''
	}
};
/* harmony default export */ __webpack_exports__["default"] = ({
	props: props,
	data: function data() {
		var _this2 = this;

		var reg = /^1[3|4|5|7|8][0-9]{9}$/;
		var checkAccount = function checkAccount(rule, value, callback) {
			if (!value) {
				return callback(new Error('手机号不能为空'));
			}
			setTimeout(function () {
				if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
					callback(new Error('请输入数字值'));
				} else {
					if (!reg.test(value)) {
						callback(new Error('手机号格式错误'));
					} else {
						callback();
					}
				}
			}, 1000);
		};
		var pwdReg = /^[0-9a-zA-Z_#]{6,16}$/;
		var validatePass = function validatePass(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (_this2.ruleForm2.checkPass !== '') {
					_this2.$refs.ruleForm2.validateField('checkPass');
				} else if (!pwdReg.test(value)) {
					callback(new Error('用户名格式错误'));
				}
				callback();
			}
		};
		var validatePass2 = function validatePass2(rule, value, callback) {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== _this2.ruleForm2.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			isLogin: true,
			isDrop: false,
			isMark: false,
			isLoginFrorm: false,
			isRegForm: false,
			isResetPassword: false,
			isNewPassword: false,
			isLoginBack: false,
			contFlag: 0,
			isNull: false,
			isSecond: false,
			isSecondT: false,
			secondText: 120,
			secondTextT: 120,
			userName: "",
			dis: false,
			disab: false,
			phone: '',
			loginList: ["登录", "注册"],
			markList: {
				title: "",
				buttons: "",
				footerImg: ""
			},
			ruleLogin: {
				userTel: '',
				userPwd: ''
			},
			registered: {
				userTel: '',

				zcuserPwd: '',

				sendSecond: ''
			},
			setNewPassword: {
				userTel: '',
				sendSecond: ''
			},
			ruleForm2: {
				pass: '',
				checkPass: ''
			},
			rules: {
				userTel: [{
					required: true,
					validator: checkAccount,
					trigger: 'blur'
				}],
				userPwd: [{
					required: true,
					message: '密码不能为空',
					trigger: 'blur'
				}]
			},
			registeredRules: {
				userTel: [{
					required: true,
					validator: checkAccount,
					trigger: 'blur'
				}],
				zcuserPwd: [{
					required: true,
					message: '密码不能为空',
					trigger: 'blur'
				}],
				sendSecond: [{
					required: true,
					message: '请输入验证码',
					trigger: 'blur'
				}]
			},
			newPas: {
				userTel: [{
					required: true,
					validator: checkAccount,
					trigger: 'blur'
				}],
				sendSecond: [{
					required: true,
					message: '请输入验证码',
					trigger: 'blur'
				}]
			},
			rules2: {
				pass: [{
					required: true,
					validator: validatePass,
					trigger: 'blur'
				}],
				checkPass: [{
					required: true,
					validator: validatePass2,
					trigger: 'blur'
				}]
			},
			navList: [{
				router: '/',
				title: "在线检测"
			}, {
				router: '/mybaogao',
				title: "我的报告"
			}]
		};
	},

	methods: {
		goLogin: function goLogin() {
			this.isNull = false;
			this.isMark = true;
			this.isLoginFrorm = true;
			this.isRegForm = false;
			this.isLoginBack = false;
			this.isResetPassword = false;
			this.isNewPassword = false;
			this.markList.title = "手机号登录";
			this.markList.buttons = "登录";
			this.contFlag = 0;
		},
		setLoginOrRegister: function setLoginOrRegister(ind) {
			this.setNewPassword.userTel = '';
			this.setNewPassword.sendSecond = '';
			this.registered.userTel = '';
			this.registered.zcuserPwd = '';
			this.registered.sendSecond = '';

			this.isMark = true;
			this.dis = false;
			this.disab = false;
			if (ind == 0) {
				this.markList.title = "手机号登录";
				this.markList.buttons = "登录";
				this.isRegForm = false;
				this.isLoginFrorm = true;
				this.isLoginBack = false;
				this.isResetPassword = false;
				this.isNewPassword = false;
				this.contFlag = 0;
			} else if (ind == 1) {
				this.markList.title = "手机号注册";
				this.markList.buttons = "注册";
				this.isRegForm = true;
				this.isLoginFrorm = false;
				this.isLoginBack = true;
				this.isResetPassword = false;
				this.isNewPassword = false;
				this.contFlag = 1;
			} else if (ind == 2) {
				this.markList.title = "重置密码";
				this.markList.buttons = "下一步";
				this.isResetPassword = true;
				this.isRegForm = false;
				this.isLoginFrorm = false;
				this.isLoginBack = true;
				this.isNewPassword = false;
				this.contFlag = 2;
			}
		},
		getOperation: function getOperation(formName) {
			var _this3 = this;

			if (this.contFlag == 0) {
				this.$refs[formName].validate(function (valid) {
					if (valid) {
						_this3.$http.post(urlLogin.urlLoginTest + '/login.json', {
							phone: _this3.ruleLogin.userTel,
							password: _this3.ruleLogin.userPwd,
							role: 4
						}).then(function (res) {
							if (res.body) {
								this.ruleLogin.userTel = '';
								this.ruleLogin.userPwd = '';
								localStorage.setItem("token", res.body.token);
								localStorage.setItem("userName", res.body.object.username);
								localStorage.setItem('phone', res.body.object.phone);
								this.userName = localStorage.getItem("userName");
								this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
								this.isMark = false;
								this.isLogin = false;
								this.isDrop = true;
							} else {
								this.$message({
									message: '错了哦，请确认登录名或密码',
									type: 'error'
								});
							}
						});
					} else {
						return false;
					}
				});
			} else if (this.contFlag == 1) {
				this.$refs[formName].validate(function (valid) {
					if (valid) {
						_this3.$http.post(urls.urltest + "/personal/registUser.json", {
							phone: _this3.registered.userTel,
							password: _this3.registered.zcuserPwd,
							code: _this3.registered.sendSecond
						}).then(function (res) {
							if (res.body.status == "100") {
								this.$message({
									message: '验证码超时',
									type: 'error'
								});
							} else {
								console.log(res.body);
								localStorage.setItem("userName", res.body.object.username);
								localStorage.setItem("phone", res.body.object.phone);
								this.userName = localStorage.getItem("userName");
								this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
								this.isMark = false;
								this.isLogin = false;
								this.isDrop = true;
								this.contFlag = 0;
								localStorage.setItem("token", res.body.token);
								this.isSecond = false;
								this.registered.userTel = '';
								this.ruleLogin.userPwd = '';
								this.setNewPassword.sendSecond = '';
							}
						});
					} else {
						return false;
					}
				});
			} else if (this.contFlag == 2) {
				this.$refs[formName].validate(function (valid) {
					if (valid) {
						_this3.$http.post(urls.urltest + "/personal/checkPhoneCode.json", {
							code: _this3.setNewPassword.sendSecond,
							phone: _this3.setNewPassword.userTel
						}).then(function (res) {
							if (res.body) {
								this.markList.buttons = "确定";
								this.isResetPassword = false;
								this.isRegForm = false;
								this.isLoginFrorm = false;
								this.isLoginBack = true;
								this.isNewPassword = true;
								this.contFlag = 3;
							} else {
								this.$message({
									message: '验证码输入不正确',
									type: 'error'
								});
								return false;
							}
						});
					} else {
						return false;
					}
				});
			} else if (this.contFlag == 3) {
				this.$refs[formName].validate(function (valid) {
					if (valid) {
						_this3.$http.post(urls.urltest + '/personal/changePassword.json', {
							phone: _this3.setNewPassword.userTel,
							password: _this3.ruleForm2.checkPass
						}).then(function (res) {
							this.isMark = false;
							this.isLogin = false;
							this.isDrop = true;
							this.contFlag = 0;
							this.$message({
								message: '密码修改成功',
								type: 'success'
							});
							localStorage.setItem("userName", res.body.object.username);
							localStorage.setItem("phone", res.body.object.phone);
							this.userName = localStorage.getItem("userName");
							this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
							localStorage.setItem("token", res.body.token);
						});
					} else {
						return false;
					}
				});
			}
		},
		regPhone: function regPhone() {
			this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
				phone: this.registered.userTel
			}).then(function (res) {
				if (res.body == "1") {
					this.$message({
						message: '手机号码已经注册',
						type: 'error'
					});
				}
			});
		},
		setregPhone: function setregPhone() {
			this.$http.post(urls.urltest + "/personal/checkUserExist.json", {
				phone: this.setNewPassword.userTel
			}).then(function (res) {
				if (res.body == "0") {
					this.$message({
						message: '用户不存在',
						type: 'error'
					});
					return false;
				}
			});
		},
		setExit: function setExit() {
			this.$http.post(urls.urltest + '/personal/loginout.json', {
				token: localStorage.getItem('token')
			}).then(function (res) {
				localStorage.clear();

				this.isLogin = true;
				this.isDrop = false;
				this.$router.replace('/');
			});
		},
		shutDown: function shutDown() {
			this.isMark = false;
			this.isNull = false;
			this.dis = false;
			this.isSecond = false;
			localStorage.removeItem("token");
		},
		getRegCode: function getRegCode() {
			if (this.registered.userTel == '') {
				this.$message({
					message: '请填写手机号码',
					type: 'error'
				});
			} else if (!this.registered.userTel == '') {
				this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
					phone: this.registered.userTel
				}).then(function (res) {
					console.log(+11 + res.body);
					if (res.body == "1") {
						this.$message({
							message: '手机号码已经注册',
							type: 'error'
						});
					} else if (res.body == "2") {
						this.$message({
							message: '用户名格式错误',
							type: 'error'
						});
					} else {
						var _this = this;
						this.isSecond = true;
						this.dis = false;
						this.$http.post(urls.urltest + "/personal/getRegistCheckCode.json", {
							phone: this.registered.userTel
						}).then(function (res) {
							var timer = null;
							var sT = this.secondText * 1;
							timer = setInterval(function () {
								if (sT > 0) {
									_this.dis = true;
									sT--;
								}
								_this.secondText = sT;
								if (_this.secondText <= 0) {
									_this.dis = false;
									clearInterval(timer);
									_this.isSecond = false;
									_this.secondText = 120;
								}
							}, 1000);
						});
					}
				});
			}
		},
		getRegNumber: function getRegNumber() {
			if (this.setNewPassword.userTel == '') {
				this.$message({
					message: '请填写手机号码',
					type: 'error'
				});
			} else if (!this.setNewPassword.userTel == '') {
				this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
					phone: this.setNewPassword.userTel
				}).then(function (res) {
					console.log(res.body);
					if (res.body == "0") {
						this.$message({
							message: '用户不存在',
							type: 'error'
						});
					} else if (res.body == "2") {
						this.$message({
							message: '用户名格式错误',
							type: 'error'
						});
					} else {
						var _this = this;
						this.isSecondT = true;
						this.disab = false;
						this.$http.post(urls.urltest + "/personal/getChangePassWordCode.json", {
							phone: this.setNewPassword.userTel
						}).then(function (res) {
							var timer = null;
							var sT = this.secondTextT * 1;
							timer = setInterval(function () {
								if (sT > 0) {
									_this.disab = true;
									sT--;
								}
								_this.secondTextT = sT;
								if (_this.secondTextT <= 0) {
									clearInterval(timer);
									_this.disab = false;
									_this.isSecondT = false;
									_this.secondTextT = 120;
								}
							}, 1000);
						});
					}
				});
			}
		},
		changeIndex: function changeIndex(index) {
			if (index == 0) {
				this.$router.replace('/');
				this.$store.dispatch("changeIndex", index);
			} else if (index == 1) {
				if (localStorage.getItem("token")) {
					this.$router.replace('/mybaogao');
					this.$store.dispatch("changeIndex", index);
				} else {
					this.isNull = true;
				}
			}
		}
	},
	created: function created() {
		if (localStorage.getItem("token")) {
			this.isDrop = true;
			this.isLogin = false;
			this.userName = localStorage.getItem("userName");
			this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
		}
	},

	store: __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */],
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['ind']))
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(41);




var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_1__components_header___default.a
};


/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	name: 'hello',
	store: __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */],
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['ind']))
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var echarts = __webpack_require__(1);

__webpack_require__(90);

__webpack_require__(97);
__webpack_require__(96);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			getPrintPageFirst: {},
			getPrintPage: {},
			getscoreList: {},
			brainsuggest: {},
			radarList: {},
			getshuzibijiao: {},
			shuzibijiaoList: {},
			getluojituili: {},
			luojituiliList: {},
			getgongzuojiyi: {},
			gongzuojiyiList: {},
			zhuyiguangdu: {},
			zhuyiguangduList: {},
			brainVosList: {} };
	},
	mounted: function mounted() {
		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/report/individual.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			console.log(res.body);
			this.getshuzibijiao = res.body.szbjResult;
			this.shuzibijiaoList = res.body.szbjResult.list;
			this.getluojituili = res.body.txtlResult;
			this.luojituiliList = res.body.txtlResult.list;
			this.getgongzuojiyi = res.body.szdbResult;
			this.gongzuojiyiList = res.body.szdbResult.list;
			this.zhuyiguangdu = res.body.ssydResult;
			this.zhuyiguangduList = res.body.ssydResult.list;
			if (this.shuzibijiaoList.length > 3) {
				var shuzibijiaoList1 = [];
				var shuzibijiaoList2 = [];
				shuzibijiaoList2.push(this.shuzibijiaoList[this.shuzibijiaoList.length - 1]);
				console.log(shuzibijiaoList2);
				var numL = this.shuzibijiaoList.length - 1;
				for (var i = 0; i < numL; i++) {
					shuzibijiaoList1.push(this.shuzibijiaoList[i]);
				}
				this.shuzibijiaoList1 = shuzibijiaoList1;
				this.shuzibijiaoList2 = shuzibijiaoList2;
			}
		});
		this.addDiv();
		var timer = null;
		var isTop = true;
		var clientHeight = document.documentElement.clientHeight;

		window.onscroll = function () {
			var osTop = document.documentElement.scrollTop || document.body.scrollTop;
			if (osTop >= clientHeight) {
				$('.moveUp').css('display', 'block');
			} else {
				$('.moveUp').css('display', 'none');
			}
			if (!isTop) {
				clearInterval(timer);
			}
			isTop = false;
		};

		$('.moveUp').click(function () {
			timer = setInterval(function () {
				var osTop = document.documentElement.scrollTop || document.body.scrollTop;
				var ispeeed = Math.floor(-osTop / 5);
				document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeeed;

				isTop = true;
				if (osTop == 0) {
					clearInterval(timer);
				}
			}, 30);
		});
	},

	methods: {
		drawLine: function drawLine() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/report/getBrainAtlas.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				this.radarList = res.body;
				var myChart = this.$echarts.init(document.getElementById('radarChart'));
				myChart.setOption({
					radar: {
						indicator: [{
							text: '逻辑型',
							max: 100
						}, {
							text: '语言型',
							max: 100
						}, {
							text: '记忆型',
							max: 100
						}, {
							text: '灵活型',
							max: 100
						}],
						nameGap: 4,
						center: ['50%', '50%'],
						radius: '80%',

						startAngle: 90,
						splitNumber: 3,
						shape: 'circle',
						name: {
							show: true,
							formatter: null,
							textStyle: {
								color: '#000000' },
							axisLine: {}
						},
						splitArea: {
							areaStyle: {
								color: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'] }
						},
						axisTick: {
							show: true,
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.8)' }
						},

						axisLine: {
							lineStyle: {
								color: 'rgba((255, 255, 255, 0.4)' }
						},
						splitLine: {
							lineStyle: {
								color: '#DDDDDD' }
						}
					},
					series: [{
						type: 'radar',
						symbol: "none",
						tooltip: {
							trigger: 'item'
						},
						itemStyle: {
							normal: {
								areaStyle: {
									color: '#5089F4' },
								lineStyle: {
									color: "#5089F4" }
							}
						},
						data: [{
							value: [this.radarList[0], this.radarList[1], this.radarList[2], this.radarList[3]],
							name: '雷达图'
						}]
					}]
				});
			});
		},
		color: function color(col) {
			if (col == '不健康') return "#FD836A";
			if (col == '亚健康') return "#5089F4";
		},
		addDiv: function addDiv() {
			setTimeout(function () {
				$(function () {
					$('.printing').each(function (index, dom) {
						var pageindex = index < 10 ? "0" + index : index;
						$(dom).find('.page-num').html(pageindex);
					});
				});
			}, 600);
		},
		print_close: function print_close() {
			window.close();
		},
		print_page: function print_page() {
			window.print();
		}
	}, created: function created() {
		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/report/exinfo.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			console.log(res.body);
			this.getPrintPageFirst = res.body;
			this.getscoreList = res.body.resultBos;
			this.brainsuggest = res.body.brainAtlas;
			this.brainVosList = res.body.brainVos;
			this.$nextTick(function () {
				if (this.getPrintPageFirst.gameCount == 4) {
					this.drawLine();
				}
			});
		});
	}
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var echarts = __webpack_require__(1);

__webpack_require__(90);

__webpack_require__(97);
__webpack_require__(96);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			getPrintPageFirst: {},
			getPrintPage: {},
			singleReport: {},
			getscoreList: {},
			brainsuggest: {},
			radarList: {},
			Reactiontime: {},
			Correctrate: {},
			ReactTu: {},
			Reactxing: {},
			getshuzibijiao: {},
			getrenwuqingjing: {},
			getTalentyou: {},
			jagongsport: {},
			qinjingjiyi: {},
			luojituili: {},
			shuzibijiaoList: {},
			tuxintuiliList: {},
			tuxintuiliList1: {},
			tuxintuiliList2: {},
			jiagongsuduList: {},
			renwuqingjign: {} };
	},
	mounted: function mounted() {
		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/game/lookmynewreport.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			this.getPrintPage = res.body;
			this.getscoreList = res.body.resultBos;
			this.brainsuggest = res.body.brainAtlas;
			this.$nextTick(function () {
				if (this.getPrintPage.zhdx == 1) {
					this.drawLine();
				}
			});
		});

		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/game/individual.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			console.log(res.body);
			this.singleReport = res.body;
			this.getshuzibijiao = res.body.szbjResult;
			this.getrenwuqingjing = res.body.szbjResult;
			this.jagongsport = res.body.fhzhResult;
			this.qinjingjiyi = res.body.rwqjResult;
			this.luojituili = res.body.txtlResult;
			this.shuzibijiaoList = res.body.szbjResult.list;
			this.tuxintuiliList = res.body.txtlResult.list;
			this.jiagongsuduList = res.body.fhzhResult.list;
			this.renwuqingjign = res.body.rwqjResult.list;
			if (this.tuxintuiliList.length > 4) {
				console.log(this.tuxintuiliList);
				var luojituiliList1 = [];
				var luojituiliList2 = [];
				luojituiliList2.push(this.tuxintuiliList[this.tuxintuiliList.length - 1]);
				for (var i = 0; i < this.tuxintuiliList.length - 1; i++) {
					luojituiliList1.push(this.tuxintuiliList[i]);
				}
				this.luojituiliList1 = luojituiliList1;
				this.luojituiliList2 = luojituiliList2;
			}
			if (this.jiagongsuduList.length > 4) {
				console.log(this.tuxintuiliList);
				var jiagongsuduList1 = [];
				var jiagongsuduList2 = [];
				jiagongsuduList2.push(this.jiagongsuduList[this.jiagongsuduList.length - 1]);
				for (var i = 0; i < this.jiagongsuduList.length - 1; i++) {
					luojituiliList1.push(this.jiagongsuduList[i]);
				}
				this.jiagongsuduList1 = jiagongsuduList1;
				this.jiagongsuduList2 = jiagongsuduList2;
			}
			this.$nextTick(function () {
				if (this.getshuzibijiao.status == 1) {
					this.drawarea();
					this.drawRight();
				}
				if (this.luojituili.status == 1) {
					this.drawGraphics();
					this.drawRae();
				}
			});
		});
		this.addDiv();
		var timer = null;
		var isTop = true;
		var clientHeight = document.documentElement.clientHeight;

		window.onscroll = function () {
			var osTop = document.documentElement.scrollTop || document.body.scrollTop;
			if (osTop >= clientHeight) {
				$('.moveUp').css('display', 'block');
			} else {
				$('.moveUp').css('display', 'none');
			}
			if (!isTop) {
				clearInterval(timer);
			}
			isTop = false;
		};

		$('.moveUp').click(function () {
			timer = setInterval(function () {
				var osTop = document.documentElement.scrollTop || document.body.scrollTop;
				var ispeeed = Math.floor(-osTop / 5);
				document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeeed;

				isTop = true;
				if (osTop == 0) {
					clearInterval(timer);
				}
			}, 30);
		});
	},

	methods: {
		drawLine: function drawLine() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/lookmynewreport.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				this.radarList = res.body.brainAtlas.atlas;
				console.log(res.body.status);

				var myChart = this.$echarts.init(document.getElementById('radarChart'));
				myChart.setOption({
					radar: {
						indicator: [{
							text: '逻辑型',
							max: 100
						}, {
							text: '语言型',
							max: 100
						}, {
							text: '记忆型',
							max: 100
						}, {
							text: '灵活型',
							max: 100
						}],
						nameGap: 4,
						center: ['50%', '50%'],
						radius: '80%',

						startAngle: 90,
						splitNumber: 3,
						shape: 'circle',
						name: {
							show: true,
							formatter: null,
							textStyle: {
								color: '#000000' },
							axisLine: {}
						},
						splitArea: {
							areaStyle: {
								color: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'] }
						},
						axisTick: {
							show: true,
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.8)' }
						},

						axisLine: {
							lineStyle: {
								color: 'rgba((255, 255, 255, 0.4)' }
						},
						splitLine: {
							lineStyle: {
								color: '#DDDDDD' }
						}
					},
					series: [{
						type: 'radar',
						symbol: "none",
						tooltip: {
							trigger: 'item'
						},
						itemStyle: {
							normal: {
								areaStyle: {
									color: '#5089F4' },
								lineStyle: {
									color: "#5089F4" }
							}
						},
						data: [{
							value: [this.radarList[0], this.radarList[1], this.radarList[2], this.radarList[3]],
							name: '雷达图'
						}]
					}]
				});
			});
		},
		drawarea: function drawarea() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/szbjIndivdual.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				console.log(res.body);
				this.Reactiontime = res.body;
				this.ReactiontimeRate = res.body.hard;

				var myChart = echarts.init(document.getElementById('histogram'));

				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'show'
						}
					},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						axisLabel: {
							formatter: function formatter(value) {
								var texts = [];
								if (value === 5800) {
									texts.push('反应时(ms)');
								}
								return texts;
							},
							rotate: 90,
							textStyle: {
								color: '#000000',
								fontSize: '24'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						type: 'value',
						splitNumber: 100,
						max: 10000
					},
					xAxis: {
						axisLabel: {
							textStyle: {
								color: '#000000'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						type: 'category',
						data: ['1', '2', '3', '4']
					},
					series: [{
						name: '反应时',
						type: 'bar',
						data: [this.ReactiontimeRate[0], this.ReactiontimeRate[1], this.ReactiontimeRate[2], this.ReactiontimeRate[3]],
						barWidth: '24',
						itemStyle: {
							normal: {
								color: '#09BCD9'
							}
						}
					}, {
						name: '反应时',
						type: 'line',
						data: [this.ReactiontimeRate[0], this.ReactiontimeRate[1], this.ReactiontimeRate[2], this.ReactiontimeRate[3]],
						symbolSize: 6,
						symbol: 'circle',
						itemStyle: {
							normal: {
								color: "#09BCD9",
								barBorderRadius: 0,
								label: {
									show: true,
									position: "top"
								}
							}
						}
					}]
				});
			});
		},
		drawRight: function drawRight() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/szbjIndivduals.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				this.Correctrate = res.body;
				this.correctRate = res.body.hard;

				var myChart = echarts.init(document.getElementById('hisRight'));

				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'show'
						}
					},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						axisLabel: {
							formatter: function formatter(value) {
								var texts = [];
								if (value === 45) {
									texts.push('正确率(%)');
								}
								return texts;
							},
							rotate: 90,
							textStyle: {
								color: '#000000',
								fontSize: '24'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						type: 'value',
						splitNumber: 1000,
						max: 100
					},
					xAxis: {
						axisLabel: {
							textStyle: {
								color: '#000000'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						type: 'category',
						data: ['1', '2', '3', '4']
					},
					series: [{
						name: '反应时',
						type: 'bar',
						data: [this.correctRate[0], this.correctRate[1], this.correctRate[2], this.correctRate[3]],
						barWidth: '24',
						itemStyle: {
							normal: {
								color: '#09BCD9'
							}
						}
					}, {
						name: '反应时',
						type: 'line',
						data: [this.correctRate[0], this.correctRate[1], this.correctRate[2], this.correctRate[3]],
						symbolSize: 6,
						symbol: 'circle',
						itemStyle: {
							normal: {
								color: "#09BCD9",
								barBorderRadius: 0,
								label: {
									show: true,
									position: "top"
								}
							}
						}
					}]
				});
			});
		},
		drawGraphics: function drawGraphics() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/txtlIndivdual.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				console.log(res.body);
				this.ReactTu = res.body;
				this.Graphicstuili = res.body.hard;
				console.log(this.ReactTu.status);

				var myChart = echarts.init(document.getElementById('Graphics'));

				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'show'
						}
					},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						axisLabel: {
							formatter: function formatter(value) {
								var texts = [];
								if (value === 28000) {
									texts.push('反应时(ms)');
								}
								return texts;
							},
							rotate: 90,
							textStyle: {
								color: '#000000',
								fontSize: '24'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						type: 'value',
						splitNumber: 100,
						max: 50000
					},
					xAxis: {
						axisLabel: {
							textStyle: {
								color: '#000000'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						type: 'category',
						data: ['1', '2', '3', '4', '5']
					},
					series: [{
						name: '反应时',
						type: 'bar',
						data: [this.Graphicstuili[0], this.Graphicstuili[1], this.Graphicstuili[2], this.Graphicstuili[3], this.Graphicstuili[4]],
						barWidth: '24',
						itemStyle: {
							normal: {
								color: '#09BCD9'
							}
						}
					}, {
						name: '反应时',
						type: 'line',
						data: [this.Graphicstuili[0], this.Graphicstuili[1], this.Graphicstuili[2], this.Graphicstuili[3], this.Graphicstuili[4]],
						symbolSize: 6,
						symbol: 'circle',
						itemStyle: {
							normal: {
								color: "#09BCD9",
								barBorderRadius: 0,
								label: {
									show: true,
									position: "top"
								}
							}
						}
					}]
				});
			});
		},
		drawRae: function drawRae() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/txtlIndivduals.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				console.log(res.body);
				this.Reactxing = res.body;
				this.Graprea = res.body.hard;

				var myChart = echarts.init(document.getElementById('reasoning'));

				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'show'
						}
					},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						axisLabel: {
							textStyle: {
								color: '#000000'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						type: 'category',
						data: ['1', '2', '3', '4', '5']
					},
					yAxis: {
						axisLabel: {
							formatter: function formatter(value) {
								var texts = [];
								if (value === 50) {
									texts.push('正确率(%)');
								}
								return texts;
							},
							rotate: 90,
							textStyle: {
								color: '#000000',
								fontSize: '24'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						type: 'value',
						splitNumber: 1000,
						max: 100
					},
					series: [{
						name: '反应时',
						type: 'bar',
						data: [this.Graprea[0], this.Graprea[1], this.Graprea[2], this.Graprea[3], this.Graprea[4]],
						barWidth: '24',
						itemStyle: {
							normal: {
								color: '#09BCD9'
							}
						}
					}, {
						name: '反应时',
						type: 'line',
						data: [this.Graprea[0], this.Graprea[1], this.Graprea[2], this.Graprea[3], this.Graprea[4]],
						symbolSize: 6,
						symbol: 'circle',
						itemStyle: {
							normal: {
								color: "#09BCD9",
								barBorderRadius: 0,
								label: {
									show: true,
									position: "top"
								}
							}
						}
					}]
				});
			});
		},
		color: function color(col) {
			if (col == '不健康') return "#FD836A";
			if (col == '亚健康') return "#5089F4";
		},
		addDiv: function addDiv() {
			setTimeout(function () {
				$(function () {
					$('.printing').each(function (index, dom) {
						var pageindex = index < 10 ? "0" + index : index;
						$(dom).find('.page-num').html(pageindex);
					});
					var out1 = $('.carried1').html();
					var out2 = $('.carried2').html();
					var out3 = $('.carried1').html();
					var out4 = $('.carried3').html();
					var out5 = $('.carried5').html();
					var scene1 = $('.scene1').html();
					var scene2 = $('.scene2').html();
					var scene3 = $('.scene3').html();
					var scene4 = $('.scene4').html();
					var processing1 = $('.processing1').html();
					var processing2 = $('.processing2').html();
					var processing3 = $('.processing3').html();
					var know = $('.know').html();
					var postscript = $('.postscript').html();
					var graphic1 = $('.graphic1').html();
					var graphic2 = $('.graphic2').html();
					var graphic3 = $('.graphic3').html();
					var graphic4 = $('.graphic4').html();
					var graphic5 = $('.graphic5').html();
					if (out1) {
						$('.out1').html(out1);
					} else if (scene1) {
						$('.out1').html(scene1);
					} else if (graphic1) {
						$('.out1').html(graphic1);
					} else {
						$('.out1').html(processing1);
					}
					$('.out2').html(out2);
					$('.out3').html(out3);
					$('.out4').html(out4);
					$('.out5').html(out5);
					$('.memory1').html(scene1);
					$('.memory2').html(scene1);
					$('.memory3').html(scene2);
					$('.memory4').html(scene4);
					$('.speed1').html(processing1);
					$('.speed1').html(processing1);
					$('.speed2').html(processing2);
					$('.speed3').html(processing3);
					$('.understanding').html(know);
					$('.lastpostscript').html(postscript);
					$('.reasoning1').html(graphic1);
					$('.reasoning2').html(graphic1);
					$('.reasoning3').html(graphic3);
					$('.reasoning4').html(graphic5);
				});
			}, 600);
		},
		print_close: function print_close() {
			window.close();
		},
		print_page: function print_page() {
			window.print();
		}
	}, created: function created() {
		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/game/indexReport.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			this.getPrintPageFirst = res.body;
		});

		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/game/getTalent.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			this.getTalentyou = res.body;
		});
	}
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_vue__);




var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			isList: false,
			isNull: false,
			getPages: null,
			getTotal: null,
			pageSize: null,
			getReportList: null
		};
	},
	created: function created() {
		this.$http.post('http://192.168.11.86/api/v1/page/hospitalmanage', {
			a: 1
		}).then(function (res) {});

		this.$http.post(urls.urltest + '/personal/getMyReport.json', {
			token: localStorage.getItem('token')
		}).then(function (res) {
			if (res.body.code == 500) {
				location.href = "/#/";
			} else {
				if (res.body.records.length) {
					this.isList = true;
					this.isNull = false;
					this.getPages = res.body.pages;
					this.getTotal = res.body.total;
					this.pageSize = res.body.size;
					this.getReportList = res.body.records;
				} else {
					this.isList = false;
					this.isNull = true;
				}
			}
		});
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.$http.post(urls.urltest + '/personal/getMyReport.json', {
				token: localStorage.getItem('token'),
				current: val
			}).then(function (res) {
				this.getReportList = res.body.records;
			});
			console.log(val);
			this.pageChange = val;
			console.log(this.pageChange);
		},
		lookREport: function lookREport(reportID, childReportID, reportBid) {
			localStorage.setItem('eid', reportID);
			if (childReportID == 6 && reportBid == 2) {
				window.open('/#/mechanismCard');
			} else if (childReportID == 1 && reportBid == 1) {
				window.open('/#/mechanismPrin');
			} else {
				window.open('/#/reportpage');
			}
		}
	}
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			isShowNull: false,
			isShowOrderList: false,
			getOrserList: {},
			getPages: null,
			getTotal: null,
			pageSize: null,
			stateButton: '',
			getordernumber: ''
		};
	},
	created: function created() {
		this.$http.post(urls.urltest + "/personal/getOrderList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			console.log(res.body);
			if (res.body.records.length) {
				this.isShowOrderList = true;
				this.isShowNull = false;
				console.log(res.body);
				this.getOrserList = res.body.records;
				this.getPages = res.body.pages;
				this.getTotal = res.body.total;
				this.pageSize = res.body.size;
			} else {
				this.isShowOrderList = false;
				this.isShowNull = true;
			}
		});
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.$http.post(urls.urltest + '/personal/getOrderList.json', {
				token: localStorage.getItem('token'),
				current: val
			}).then(function (res) {
				this.getOrserList = res.body.records;
			});
		},
		buttonCancel: function buttonCancel(TC) {
			if (TC == '青年版-基础套餐') {
				this.$router.replace('/payment?pID=1');
			} else if (TC == '中年版-基础套餐') {
				this.$router.replace('/payment?pID=2');
			} else if (TC == '老年版-基础套餐') {
				this.$router.replace('/payment?pID=3');
			} else {
				this.$router.replace('/payment?pID=1');
			}
		},
		buttonOrder: function buttonOrder(orderNumber, reportEid) {
			localStorage.setItem('orderNumber', orderNumber);
			localStorage.setItem('eid', reportEid);
			this.$router.replace('/payQuest');
		},
		buttonEvaluation: function buttonEvaluation(reportEid) {
			this.$http.post(urls.urltest + "/personal/checkUser.json", {
				token: localStorage.getItem('token'),
				phone: localStorage.getItem('phone')
			}).then(function (res) {
				localStorage.setItem('eid', reportEid);
				if (res.body == '0') {
					this.$router.push('/startTest');
				} else {
					this.$router.push('/gamelist');
				}
			});
		},
		buttonLook: function buttonLook(reportEid, childReportPID, reportBid) {
			localStorage.setItem('eid', reportEid);
			if (childReportPID == 6 && reportBid == 2) {
				window.open('/#/mechanismCard');
			} else if (childReportPID == 1 && reportBid == 1) {
				window.open('/#/mechanismPrin');
			} else {
				window.open('/#/reportpage');
			}
		}
	}
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	created: function created() {
		this.$http.post(urls.urltest + "/alipay/zfbpay.json", {
			token: localStorage.getItem('token'),
			ordernumber: localStorage.getItem('orderNumber')
		}).then(function (res) {
			setTimeout(function () {
				document.getElementById('myfroms').innerHTML = res.bodyText;
				document.forms[0].submit();
			});
		});
	}
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_zfbz_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_zfbz_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_zfbz_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_wxz_png__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_wxz_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_wxz_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_cardRoll_png__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_cardRoll_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_cardRoll_png__);






var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			imgList: [{
				imgUrl: __WEBPACK_IMPORTED_MODULE_1__assets_zfbz_png___default.a,
				'payimg': '支付宝'
			}, {
				imgUrl: __WEBPACK_IMPORTED_MODULE_2__assets_wxz_png___default.a,
				'payimg': '微信支付'
			}, {
				imgUrl: __WEBPACK_IMPORTED_MODULE_3__assets_cardRoll_png___default.a,
				'payimg': '电子卡'
			}],
			payCurrent: '1',
			MID: '',
			getOrderInfoList: null,
			ordernumberpay: '',
			orderpaypac: '',
			ordertcprice: '',
			payMoneyMess: false,
			Originalprice: '',
			Discount: '',
			isNullMoney: false,
			cardnumRoll: '',
			checkPasswordStatus: null,
			payNextInput: false,
			isPaymentShow: false,
			DisPid: '',
			DisBid: ''
		};
	},

	methods: {
		getCurrentpay: function getCurrentpay(mid) {
			this.payCurrent = mid;
			this.getPackageId(mid, this.payCurrent);
			if (this.payCurrent == 3) {
				this.payNextInput = true;
			} else {
				this.payNextInput = false;
			}
		},
		getPackageId: function getPackageId(mid) {
			this.MID = this.payCurrent;
		},
		goPaymentQuest: function goPaymentQuest() {
			var ordernumber = localStorage.getItem('orderNumber');
			if (this.payCurrent == 1 || this.payCurrent == 2) {
				this.isPaymentShow = true;
				this.$http.post(urls.urltest + "/order/saveOrder.json", {
					token: localStorage.getItem('token'),
					payType: this.MID,
					ordernumber: this.ordernumberpay
				}).then(function (res) {
					if (this.payCurrent == 1) {
						var ordernumber = localStorage.getItem('orderNumber');
						window.open(urls.urltest + "/alipay/zfbpay.json" + '?ordernumber=' + ordernumber);
					} else {
						window.open('/#/payWeChat');
					}
				});
			} else {
				this.$http.post(urls.urltest + "/order/checkPassword.json", {
					token: localStorage.getItem('token'),
					password: this.cardnumRoll,
					payType: this.payCurrent,
					ordernumber: this.ordernumberpay
				}).then(function (res) {
					this.checkPasswordStatus = res.body;
					if (res.body == '') {
						this.payMoneyMess = true;
					} else if (res.body == 0) {
						this.payMoneyMess = true;
					} else if (res.body > 0) {
						this.$http.post(urls.urltest + "/order/saveOrder.json", {
							token: localStorage.getItem('token'),
							password: this.cardnumRoll,
							payType: this.payCurrent,
							ordernumber: this.ordernumberpay
						}).then(function (res) {
							console.log(res.body);
							this.payMoneyMess = false;
							this.isNullMoney = true;
							this.ordertcprice = '0.00';
							this.$router.replace('/cardSucc');
						});
					}
				});
			}
		},
		goPayEnter: function goPayEnter() {
			if (this.MID == 3) {
				var token = localStorage.getItem('token');
				this.$http.post(urls.urltest + "/order/checkPassword.json", {
					token: token,
					password: this.cardnumRoll,
					pid: this.DisPid,
					bid: this.DisBid
				}).then(function (res) {
					this.checkPasswordStatus = res.body;
					if (this.checkPasswordStatus > 0) {
						this.payMoneyMess = false;
						this.isNullMoney = true;
						this.ordertcprice = '0.00';
					} else if (this.checkPasswordStatus == '') {
						this.payMoneyMess = true;
					} else if (this.checkPasswordStatus = 0) {
						this.payMoneyMess = true;
					}
				});
			}
		},
		getPaymentProblem: function getPaymentProblem() {
			this.isPaymentShow = false;
			this.$router.replace('/ordermanagement');
		},
		getPaymentSuccess: function getPaymentSuccess() {
			var ordernumber = localStorage.getItem('orderNumber');
			this.$http.post(urls.urltest + "/order/getOrderInfo.json", {
				ordernumber: ordernumber,
				token: localStorage.getItem('token')
			}).then(function (res) {
				if (res.body.orderstatus == '2') {
					this.$http.post(urls.urltest + "/personal/checkUser.json", {
						token: localStorage.getItem('token'),
						phone: localStorage.getItem('phone')
					}).then(function (res) {
						if (res.body == '0') {
							this.$router.push('/startTest');
						} else {
							this.$router.push('/gamelist');
						}
					});
				} else {
					this.$router.replace('/ordermanagement');
				}
			});
		}
	},
	mounted: function mounted() {
		this.getPackageId(this.payCurrent);
		$('.payQuest-left-zf li').click(function () {
			var i = $(this).index();
			$(this).addClass('on').siblings().removeClass('on');
		});
		this.ordernumberpay = localStorage.getItem('orderNumber');
		this.$http.post(urls.urltest + "/order/getOrderInfo.json", {
			ordernumber: this.ordernumberpay,
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.getOrderInfoList = res.body;
			this.payCurrent = res.body.payType;
			this.orderpaypac = res.body.packageName;
			this.ordertcprice = res.body.tcprice;
			this.Originalprice = res.body.tcprice;
			this.Discount = res.body.tcprice;
			this.DisPid = res.body.pid;
			this.DisBid = res.body.bid;
		});
	}
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			imgSrc: '',
			payName: '',
			payPprice: '',
			ordernumberpay: ''
		};
	},
	mounted: function mounted() {
		this.ordernumberpay = localStorage.getItem('orderNumber');
		this.$http.post(urls.urltest + "/order/getOrderInfo.json", {
			ordernumber: this.ordernumberpay,
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.payName = res.body.packageName;
			this.payPprice = res.body.tcprice;
		});
	},
	created: function created() {
		var _this = this;

		var ordernumberWechat = localStorage.getItem('orderNumber');
		var imgSrc = urls.urltest + "/wxpay/qrcode" + '?ordernumber=' + ordernumberWechat;
		this.imgSrc = imgSrc;
		var j = setInterval(function () {
			_this.$http.post(urls.urltest + "/wxpay/hadPay", {
				token: localStorage.getItem('token'),
				ordernumber: ordernumberWechat
			}).then(function (res) {
				if (!res.body == '') {
					clearInterval(j);
					this.$router.replace("/successfulpayment" + '?out_trade_no=' + res.body);
				} else {
					return false;
				}
			});
		}, 2000);
		window.onbeforeunload = function () {
			clearInterval(j);
		};
	}
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_zfbz_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_zfbz_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_zfbz_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_wxz_png__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_wxz_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_wxz_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_cardRoll_png__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_cardRoll_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_cardRoll_png__);





var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_2__components_header___default.a
};





/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		var _ref;

		return _ref = {
			payInput: false,
			payMoneyMess: false,
			isNullMoney: false,
			typeList: ["青年版", "中年版", "老年版", "儿童版"],

			comboList: [{
				value: '1',
				label: '基础套餐'
			}, {
				value: '2',
				label: '标准套餐',
				disabled: true
			}],

			imgList: [{
				imgUrl: __WEBPACK_IMPORTED_MODULE_5__assets_zfbz_png___default.a,
				'payimg': '支付宝'
			}, {
				imgUrl: __WEBPACK_IMPORTED_MODULE_6__assets_wxz_png___default.a,
				'payimg': '微信支付'
			}, {
				imgUrl: __WEBPACK_IMPORTED_MODULE_7__assets_cardRoll_png___default.a,
				'payimg': '电子卡'
			}],
			current: this.$route.query.pID,
			comboCurrent: 1,
			payCurrent: 1,
			introduceList: null,
			PID: '',
			BID: '',
			MID: '',
			isPaymentShow: false,
			content: "",
			checkPasswordStatus: '',
			Originalprice: '',
			Discount: '',
			userInfomationpay: {
				cardnumRoll: ''
			}
		}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'introduceList', {
			price: ''
		}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'rules', {}), _ref;
	},

	methods: {
		getCurrentTyle: function getCurrentTyle(pid) {
			this.current = pid;
			this.getPackageId(pid, this.comboCurrent);
			if (this.current == 4) {
				this.comboList[1].disabled = false;
			} else {
				this.comboCurrent = 1;
				this.comboList[1].disabled = true;
			}
		},
		getCurrentCombo: function getCurrentCombo(bid) {
			this.comboCurrent = bid;
			this.getPackageId(bid, this.current);
			if (bid == 2) {}
		},
		getCurrentpay: function getCurrentpay(mid) {
			this.payCurrent = mid;
			this.getPackageId(mid, this.payCurrent);
			if (this.payCurrent == 3) {
				this.payInput = true;
			} else {
				this.payInput = false;
			}
		},
		getPackageId: function getPackageId(pid, bid, mid) {
			this.PID = this.current;
			this.BID = this.comboCurrent;
			this.MID = this.payCurrent;
			var a = Number(this.current);
			var b = Number(2);
			this.$http.post(urls.urltest + "/personal/getPackagevaBuvInfo.json", {
				pid: a + b,
				bid: this.comboCurrent
			}).then(function (res) {
				this.introduceList = res.body;
				this.Originalprice = res.body.price;
				this.Discount = res.body.price;
			});
		},
		goPayment: function goPayment(formName) {
			var _this = this;

			$.getScript('http://int.dpool.sina.com.cn/iplookup/iplookup.php?format=js', function () {
				var payCountry = remote_ip_info.country;
				var payProvince = remote_ip_info.province;
				var payCity = remote_ip_info.city;
				localStorage.setItem('payCountry', payCountry);
				localStorage.setItem('payProvince', payProvince);
				localStorage.setItem('payCity', payCity);
			});
			var token = localStorage.getItem('token');
			var addressCountry = localStorage.getItem('payCountry') + localStorage.getItem('payProvince') + localStorage.getItem('payCity');
			if (token) {
				var a = Number(this.current);
				var b = Number(2);
				if (this.MID == 1 || this.MID == 2) {
					this.$http.post(urls.urltest + "/order/saveOrder.json", {
						pid: a + b,
						bid: this.BID,
						token: token,
						payType: this.MID,
						address: addressCountry
					}).then(function (res) {
						localStorage.setItem('eid', res.body.eid);
						localStorage.setItem('orderNumber', res.body.ordernumber);
						this.isPaymentShow = true;
						if (this.MID == 1) {
							var ordernumber = localStorage.getItem('orderNumber');
							window.open(urls.urltest + "/alipay/zfbpay.json" + '?ordernumber=' + ordernumber);
						} else {
							var winHandler = window.open("", "_blank");
							winHandler.location.href = '/#/payWeChat';
						}
					});
				} else {
					var addressCountry = localStorage.getItem('payCountry') + localStorage.getItem('payProvince') + localStorage.getItem('payCity');
					this.$refs[formName].validate(function (valid) {
						if (_this.checkPasswordStatus == 1) {
							_this.$http.post(urls.urltest + "/order/saveOrder.json", {
								pid: a + b,
								bid: _this.BID,
								token: localStorage.getItem('token'),
								payType: _this.MID,
								password: _this.userInfomationpay.cardnumRoll,
								address: addressCountry
							}).then(function (res) {
								console.log(res.body);
								localStorage.setItem('eid', res.body.eid);
								localStorage.setItem('orderNumber', res.body.ordernumber);
								this.$router.replace('/cardSucc');
							});
						} else {
							_this.$http.post(urls.urltest + "/order/checkPassword.json", {
								pid: a + b,
								bid: _this.BID,
								token: localStorage.getItem('token'),
								password: _this.userInfomationpay.cardnumRoll
							}).then(function (res) {
								this.checkPasswordStatus = res.body;
								if (res.body == '') {
									this.payMoneyMess = true;
								} else if (res.body == 0) {
									this.payMoneyMess = true;
								}
								if (res.body > 0) {
									this.payMoneyMess = false;
									this.isNullMoney = true;
									this.introduceList.price = '0.00';
									this.$http.post(urls.urltest + "/order/saveOrder.json", {
										pid: a + b,
										bid: this.BID,
										token: localStorage.getItem('token'),
										payType: this.MID,
										password: this.userInfomationpay.cardnumRoll,
										address: addressCountry
									}).then(function (res) {
										console.log(res.body);
										localStorage.setItem('eid', res.body.eid);
										localStorage.setItem('orderNumber', res.body.ordernumber);
										this.$router.replace('/cardSucc');
									});
								}
							});
						}
					});
				}
			} else {
				this.$refs.header.goLogin();
			}
		},
		getPaymentProblem: function getPaymentProblem() {
			this.isPaymentShow = false;
			this.$router.replace('/ordermanagement');
		},
		getPaymentSuccess: function getPaymentSuccess() {
			var ordernumber = localStorage.getItem('orderNumber');
			this.$http.post(urls.urltest + "/order/getOrderInfo.json", {
				ordernumber: ordernumber,
				token: localStorage.getItem('token')
			}).then(function (res) {
				if (res.body.orderstatus == '2') {
					this.$http.post(urls.urltest + "/personal/checkUser.json", {
						token: localStorage.getItem('token'),
						phone: localStorage.getItem('phone')
					}).then(function (res) {
						if (res.body == '0') {
							this.$router.push('/startTest');
						} else {
							this.$router.push('/gamelist');
						}
					});
				} else {
					this.$router.replace('/ordermanagement');
				}
			});
		},
		goPayEnter: function goPayEnter(formName) {
			var _this2 = this;

			var c = Number(this.current);
			var b = Number(2);
			if (this.MID == 3) {
				this.$refs[formName].validate(function (valid) {
					var token = localStorage.getItem('token');
					if (token) {
						var a = _this2.userInfomationpay.cardnumRoll;
						_this2.$http.post(urls.urltest + "/order/checkPassword.json", {
							pid: c + b,
							bid: _this2.BID,
							token: token,
							password: _this2.userInfomationpay.cardnumRoll
						}).then(function (res) {
							this.checkPasswordStatus = res.body;
							if (this.checkPasswordStatus > 0) {
								this.payMoneyMess = false;
								this.isNullMoney = true;
								this.introduceList.price = '0.00';
							} else if (this.checkPasswordStatus == '') {
								this.payMoneyMess = true;
							} else if (this.checkPasswordStatus = 0) {
								this.payMoneyMess = true;
							}
						});
					} else {
						_this2.$refs.header.goLogin();
					}
				});
			}
		}
	},
	store: __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */],
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['tyleInd', 'comboInd'])),
	mounted: function mounted() {
		console.log(this.current);
		if (this.current == 4) {
			this.comboList[1].disabled = false;
		}
		this.getPackageId(this.current, this.comboCurrent);
		$('.zfb li').click(function () {
			var i = $(this).index();
			$(this).addClass('on').siblings().removeClass('on');
		});
	}
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var echarts = __webpack_require__(1);

__webpack_require__(90);

__webpack_require__(97);
__webpack_require__(96);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			getPrintPageFirst: {},
			getPrintPage: {},
			singleReport: {},
			getscoreList: {},
			brainsuggest: {},
			radarList: {},
			Reactiontime: {},
			Correctrate: {},
			ReactTu: {},
			Reactxing: {},
			getshuzibijiao: {},
			getrenwuqingjing: {},
			getTalentyou: {},
			jagongsport: {},
			qinjingjiyi: {},
			luojituili: {},
			shuzibijiaoList: {},
			tuxintuiliList: {},
			tuxintuiliList1: {},
			tuxintuiliList2: {},
			jiagongsuduList: {},
			renwuqingjign: {} };
	},
	mounted: function mounted() {
		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/game/lookmynewreport.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			this.getPrintPage = res.body;
			this.getscoreList = res.body.resultBos;
			this.brainsuggest = res.body.brainAtlas;
			this.$nextTick(function () {
				if (this.getPrintPage.zhdx == 1) {
					this.drawLine();
				}
			});
		});

		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/game/individual.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			console.log(res.body);
			this.singleReport = res.body;
			this.getshuzibijiao = res.body.szbjResult;
			this.getrenwuqingjing = res.body.szbjResult;
			this.jagongsport = res.body.fhzhResult;
			this.qinjingjiyi = res.body.rwqjResult;
			this.luojituili = res.body.txtlResult;
			this.shuzibijiaoList = res.body.szbjResult.list;
			this.tuxintuiliList = res.body.txtlResult.list;
			this.jiagongsuduList = res.body.fhzhResult.list;
			this.renwuqingjign = res.body.rwqjResult.list;
			if (this.tuxintuiliList.length > 4) {
				console.log(this.tuxintuiliList);
				var luojituiliList1 = [];
				var luojituiliList2 = [];
				luojituiliList2.push(this.tuxintuiliList[this.tuxintuiliList.length - 1]);
				for (var i = 0; i < this.tuxintuiliList.length - 1; i++) {
					luojituiliList1.push(this.tuxintuiliList[i]);
				}
				this.luojituiliList1 = luojituiliList1;
				this.luojituiliList2 = luojituiliList2;
			}
			if (this.jiagongsuduList.length > 4) {
				console.log(this.tuxintuiliList);
				var jiagongsuduList1 = [];
				var jiagongsuduList2 = [];
				jiagongsuduList2.push(this.jiagongsuduList[this.jiagongsuduList.length - 1]);
				for (var i = 0; i < this.jiagongsuduList.length - 1; i++) {
					luojituiliList1.push(this.jiagongsuduList[i]);
				}
				this.jiagongsuduList1 = jiagongsuduList1;
				this.jiagongsuduList2 = jiagongsuduList2;
			}
			this.$nextTick(function () {
				if (this.getshuzibijiao.status == 1) {
					this.drawarea();
					this.drawRight();
				}
				if (this.luojituili.status == 1) {
					this.drawGraphics();
					this.drawRae();
				}
			});
		});
		this.addDiv();
		var timer = null;
		var isTop = true;
		var clientHeight = document.documentElement.clientHeight;

		window.onscroll = function () {
			var osTop = document.documentElement.scrollTop || document.body.scrollTop;
			if (osTop >= clientHeight) {
				$('.moveUp').css('display', 'block');
			} else {
				$('.moveUp').css('display', 'none');
			}
			if (!isTop) {
				clearInterval(timer);
			}
			isTop = false;
		};

		$('.moveUp').click(function () {
			timer = setInterval(function () {
				var osTop = document.documentElement.scrollTop || document.body.scrollTop;
				var ispeeed = Math.floor(-osTop / 5);
				document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeeed;

				isTop = true;
				if (osTop == 0) {
					clearInterval(timer);
				}
			}, 30);
		});
	},

	methods: {
		drawLine: function drawLine() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/lookmynewreport.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				this.radarList = res.body.brainAtlas.atlas;
				console.log(res.body.status);

				var myChart = this.$echarts.init(document.getElementById('radarChart'));
				myChart.setOption({
					radar: {
						indicator: [{
							text: '逻辑型',
							max: 100
						}, {
							text: '语言型',
							max: 100
						}, {
							text: '记忆型',
							max: 100
						}, {
							text: '灵活型',
							max: 100
						}],
						nameGap: 4,
						center: ['50%', '50%'],
						radius: '80%',

						startAngle: 90,
						splitNumber: 3,
						shape: 'circle',
						name: {
							show: true,
							formatter: null,
							textStyle: {
								color: '#000000' },
							axisLine: {}
						},
						splitArea: {
							areaStyle: {
								color: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'] }
						},
						axisTick: {
							show: true,
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.8)' }
						},

						axisLine: {
							lineStyle: {
								color: 'rgba((255, 255, 255, 0.4)' }
						},
						splitLine: {
							lineStyle: {
								color: '#DDDDDD' }
						}
					},
					series: [{
						type: 'radar',
						symbol: "none",
						tooltip: {
							trigger: 'item'
						},
						itemStyle: {
							normal: {
								areaStyle: {
									color: '#5089F4' },
								lineStyle: {
									color: "#5089F4" }
							}
						},
						data: [{
							value: [this.radarList[0], this.radarList[1], this.radarList[2], this.radarList[3]],
							name: '雷达图'
						}]
					}]
				});
			});
		},
		drawarea: function drawarea() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/szbjIndivdual.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				console.log(res.body);
				this.Reactiontime = res.body;
				this.ReactiontimeRate = res.body.hard;

				var myChart = echarts.init(document.getElementById('histogram'));

				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'show'
						}
					},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						axisLabel: {
							formatter: function formatter(value) {
								var texts = [];
								if (value === 5800) {
									texts.push('反应时(ms)');
								}
								return texts;
							},
							rotate: 90,
							textStyle: {
								color: '#000000',
								fontSize: '24'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						type: 'value',
						splitNumber: 100,
						max: 10000
					},
					xAxis: {
						axisLabel: {
							textStyle: {
								color: '#000000'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						type: 'category',
						data: ['1', '2', '3', '4']
					},
					series: [{
						name: '反应时',
						type: 'bar',
						data: [this.ReactiontimeRate[0], this.ReactiontimeRate[1], this.ReactiontimeRate[2], this.ReactiontimeRate[3]],
						barWidth: '24',
						itemStyle: {
							normal: {
								color: '#09BCD9'
							}
						}
					}, {
						name: '反应时',
						type: 'line',
						data: [this.ReactiontimeRate[0], this.ReactiontimeRate[1], this.ReactiontimeRate[2], this.ReactiontimeRate[3]],
						symbolSize: 6,
						symbol: 'circle',
						itemStyle: {
							normal: {
								color: "#09BCD9",
								barBorderRadius: 0,
								label: {
									show: true,
									position: "top"
								}
							}
						}
					}]
				});
			});
		},
		drawRight: function drawRight() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/szbjIndivduals.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				this.Correctrate = res.body;
				this.correctRate = res.body.hard;

				var myChart = echarts.init(document.getElementById('hisRight'));

				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'show'
						}
					},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						axisLabel: {
							formatter: function formatter(value) {
								var texts = [];
								if (value === 45) {
									texts.push('正确率(%)');
								}
								return texts;
							},
							rotate: 90,
							textStyle: {
								color: '#000000',
								fontSize: '24'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						type: 'value',
						splitNumber: 1000,
						max: 100
					},
					xAxis: {
						axisLabel: {
							textStyle: {
								color: '#000000'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						type: 'category',
						data: ['1', '2', '3', '4']
					},
					series: [{
						name: '反应时',
						type: 'bar',
						data: [this.correctRate[0], this.correctRate[1], this.correctRate[2], this.correctRate[3]],
						barWidth: '24',
						itemStyle: {
							normal: {
								color: '#09BCD9'
							}
						}
					}, {
						name: '反应时',
						type: 'line',
						data: [this.correctRate[0], this.correctRate[1], this.correctRate[2], this.correctRate[3]],
						symbolSize: 6,
						symbol: 'circle',
						itemStyle: {
							normal: {
								color: "#09BCD9",
								barBorderRadius: 0,
								label: {
									show: true,
									position: "top"
								}
							}
						}
					}]
				});
			});
		},
		drawGraphics: function drawGraphics() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/txtlIndivdual.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				console.log(res.body);
				this.ReactTu = res.body;
				this.Graphicstuili = res.body.hard;
				console.log(this.ReactTu.status);

				var myChart = echarts.init(document.getElementById('Graphics'));

				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'show'
						}
					},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						axisLabel: {
							formatter: function formatter(value) {
								var texts = [];
								if (value === 28000) {
									texts.push('反应时(ms)');
								}
								return texts;
							},
							rotate: 90,
							textStyle: {
								color: '#000000',
								fontSize: '24'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						type: 'value',
						splitNumber: 100,
						max: 50000
					},
					xAxis: {
						axisLabel: {
							textStyle: {
								color: '#000000'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						type: 'category',
						data: ['1', '2', '3', '4', '5']
					},
					series: [{
						name: '反应时',
						type: 'bar',
						data: [this.Graphicstuili[0], this.Graphicstuili[1], this.Graphicstuili[2], this.Graphicstuili[3], this.Graphicstuili[4]],
						barWidth: '24',
						itemStyle: {
							normal: {
								color: '#09BCD9'
							}
						}
					}, {
						name: '反应时',
						type: 'line',
						data: [this.Graphicstuili[0], this.Graphicstuili[1], this.Graphicstuili[2], this.Graphicstuili[3], this.Graphicstuili[4]],
						symbolSize: 6,
						symbol: 'circle',
						itemStyle: {
							normal: {
								color: "#09BCD9",
								barBorderRadius: 0,
								label: {
									show: true,
									position: "top"
								}
							}
						}
					}]
				});
			});
		},
		drawRae: function drawRae() {
			var token = localStorage.getItem('token');
			this.$http.post(urls.urlReport + '/game/txtlIndivduals.json', {
				token: token,
				eid: localStorage.getItem('eid')
			}).then(function (res) {
				console.log(res.body);
				this.Reactxing = res.body;
				this.Graprea = res.body.hard;
				var myChart = echarts.init(document.getElementById('reasoning'));
				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'show'
						}
					},
					grid: {
						left: '6%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						axisLabel: {
							textStyle: {
								color: '#000000'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						type: 'category',
						data: ['1', '2', '3', '4', '5']
					},
					yAxis: {
						axisLabel: {
							formatter: function formatter(value) {
								var texts = [];
								if (value === 50) {
									texts.push('正确率(%)');
								}
								return texts;
							},
							rotate: 90,
							textStyle: {
								color: '#000000',
								fontSize: '24'
							}
						},
						axisLine: {
							lineStyle: {
								color: '#cccccc'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						type: 'value',
						splitNumber: 1000,
						max: 100
					},
					series: [{
						name: '反应时',
						type: 'bar',
						data: [this.Graprea[0], this.Graprea[1], this.Graprea[2], this.Graprea[3], this.Graprea[4]],
						barWidth: '24',
						itemStyle: {
							normal: {
								color: '#09BCD9'
							}
						}
					}, {
						name: '反应时',
						type: 'line',
						data: [this.Graprea[0], this.Graprea[1], this.Graprea[2], this.Graprea[3], this.Graprea[4]],
						symbolSize: 6,
						symbol: 'circle',
						itemStyle: {
							normal: {
								color: "#09BCD9",
								barBorderRadius: 0,
								label: {
									show: true,
									position: "top"
								}
							}
						}
					}]
				});
			});
		},
		color: function color(col) {
			if (col == '不健康') return "#FD836A";
			if (col == '亚健康') return "#5089F4";
		},
		addDiv: function addDiv() {
			setTimeout(function () {
				$(function () {
					$('.printing').each(function (index, dom) {
						var pageindex = index < 10 ? "0" + index : index;
						$(dom).find('.page-num').html(pageindex);
					});
					var out1 = $('.carried1').html();
					var out2 = $('.carried2').html();
					var out3 = $('.carried1').html();
					var out4 = $('.carried3').html();
					var out5 = $('.carried5').html();
					var scene1 = $('.scene1').html();
					var scene2 = $('.scene2').html();
					var scene3 = $('.scene3').html();
					var scene4 = $('.scene4').html();
					var processing1 = $('.processing1').html();
					var processing2 = $('.processing2').html();
					var processing3 = $('.processing3').html();
					var know = $('.know').html();
					var postscript = $('.postscript').html();
					var graphic1 = $('.graphic1').html();
					var graphic2 = $('.graphic2').html();
					var graphic3 = $('.graphic3').html();
					var graphic4 = $('.graphic4').html();
					var graphic5 = $('.graphic5').html();
					if (out1) {
						$('.out1').html(out1);
					} else if (scene1) {
						$('.out1').html(scene1);
					} else if (graphic1) {
						$('.out1').html(graphic1);
					} else {
						$('.out1').html(processing1);
					}
					$('.out2').html(out2);
					$('.out3').html(out3);
					$('.out4').html(out4);
					$('.out5').html(out5);
					$('.memory1').html(scene1);
					$('.memory2').html(scene1);
					$('.memory3').html(scene2);
					$('.memory4').html(scene4);
					$('.speed1').html(processing1);
					$('.speed1').html(processing1);
					$('.speed2').html(processing2);
					$('.speed3').html(processing3);
					$('.understanding').html(know);
					$('.lastpostscript').html(postscript);
					$('.reasoning1').html(graphic1);
					$('.reasoning2').html(graphic1);
					$('.reasoning3').html(graphic3);
					$('.reasoning4').html(graphic5);
				});
			}, 600);
		},
		print_close: function print_close() {
			window.close();
		},
		print_page: function print_page() {
			window.print();
		}
	}, created: function created() {
		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/game/indexReport.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			this.getPrintPageFirst = res.body;
		});

		var token = localStorage.getItem('token');
		this.$http.post(urls.urlReport + '/game/getTalent.json', {
			token: token,
			eid: localStorage.getItem('eid')
		}).then(function (res) {
			this.getTalentyou = res.body;
		});
	}
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	name: 'hello',
	data: function data() {
		var checkBirthday = function checkBirthday(rule, value, callback) {
			setTimeout(function () {
				if (!value) {
					return callback(new Error('日期不能为空'));
				} else {
					callback();
				}
			}, 1000);
		};
		var isIDCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
		var checkCard = function checkCard(rule, value, callback) {
			if (!value) {
				return callback(new Error('身份证号不能为空'));
				callback();
			}
			setTimeout(function () {
				if (!isIDCard.test(value)) {
					callback(new Error('身份证号格式错误'));
				} else {
					callback();
				}
			}, 1000);
		};
		return {
			userName: null,
			userInfomation: {
				userName: '',
				userCard: '',
				userBirthday: '',
				userEducation: '',
				userLives: '',
				userJobs: '',
				classification: ''
			},
			rules: {
				userName: [{
					required: true,
					message: '请输入姓名',
					trigger: 'blur'
				}],
				userCard: [{
					required: true,
					validator: checkCard,
					trigger: 'blur'
				}],
				userBirthday: [{
					required: true,
					validator: checkBirthday,
					trigger: 'change'
				}],
				userJobs: [{
					type: 'number',
					required: false,
					message: '请选择职业',
					trigger: 'blur'
				}],
				userEducation: [{
					type: 'number',
					required: false,
					message: '请选择教育程度',
					trigger: 'blur'
				}],
				userLives: [{
					type: 'number',
					required: false,
					message: '请选择居住地址',
					trigger: 'blur'
				}]
			},
			pickerOptions0: {
				disabledDate: function disabledDate(time) {
					return time.getTime() > new Date('2014,12,12,00:00:00').getTime() || time.getTime() < new Date('1899,12,12,00:00:00').getTime();;
				}
			},
			userSexList: {
				0: "男",
				1: "女"
			},
			userSex: 0,
			loadUserHealthList: null,
			userHealth: [],
			loadUserEducationList: null,
			loadUserProfessional: null,
			loadUserLiveList: null,
			loadclassificationList: null,
			isShowInput: false,
			qita: '',
			healstr: '',
			userHealthStr: ''
		};
	},

	methods: {
		regCarNum: function regCarNum() {
			var code = this.userInfomation.userCard;
			if (code.length > 17) {
				var year = code.substring(6, 10);
				var month = code.substring(10, 12);
				var thetime = year + '-' + month;
				var d = new Date(Date.parse(thetime.replace(/-/g, "/")));
				var finishTimeDate = '2014-12';
				var endTimeDate = new Date(Date.parse(finishTimeDate.replace(/-/g, "/")));
				if (d <= endTimeDate) {
					this.userInfomation.userBirthday = year + -month;
				} else {
					this.userInfomation.userBirthday = '';
				}
				var sexName = code.substring(16, 17);
				var sex = sexName % 2 == 0 ? "1" : "0";
				this.userSex = sex;
			}
		},
		getclassification: function getclassification(loadclassID) {
			this.$http.post(urls.urlApi + '/loadTradeListByTid.json', {
				id: loadclassID == undefined ? '0' : loadclassID
			}).then(function (res) {
				this.loadclassificationList = res.body;
			});
		},

		dataFormt: function dataFormt(val) {
			this.userInfomation.userBirthday = val;
		},
		currentClass: function currentClass(content, style) {
			for (var j = 1; j < content.children.length; j++) {
				content.children[j].className = style;
			}
		},
		check: function check(ind, ev) {
			var active = ev.getAttribute('data-num');
			var content = document.querySelector('#content');
			var inp = document.querySelector('#inp');
			var disStyle = -1;
			if (+active === 1) {
				if (ev.className === 'blue') {
					ev.className = 'ospan';
					this.currentClass(content, 'ospan');
				} else {
					ev.className = 'blue';
					inp.className = 'isnone';
					this.currentClass(content, 'ospan');
				}
			}
			if (+active !== 1) {
				if (ev.className === 'blue') {
					ev.className = 'ospan';
					if (+active === 10) {
						inp.className = 'isnone';
					}
					for (var j = 1; j < content.children.length; j++) {
						if (content.children[j].className === 'blue') {
							disStyle = 1;
						}
					}
					if (disStyle !== 1) {
						content.children[0].className = 'ospan';
					}
				} else {
					ev.className = 'blue';
					if (+active === 10) {
						inp.className = 'isblock';
					}
					content.children[0].className = 'ospan';
				}
			}
		},
		submit: function submit() {
			var content = document.querySelector('#content');
			var str = '';
			for (var j = 0; j < content.children.length; j++) {
				if (content.children[j].className === 'blue') {
					str += content.children[j].getAttribute('data-num') + ',';
				}
			}
			var reg = /,$/;
			str = str.replace(reg, '');
			this.userHealthStr = str;
		},
		saveInfo: function saveInfo(formName) {
			var _this2 = this;

			this.submit();
			console.log(this.userHealthStr);
			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this2.$http.post(urls.urltest + "/personal/updateUserInfo", {
						token: localStorage.getItem('token'),
						name: _this2.userInfomation.userName,
						sex: _this2.userSex,
						cardnumber: _this2.userInfomation.userCard,
						birthday: _this2.userInfomation.userBirthday,
						tradeId: _this2.userInfomation.userJobs == undefined ? '' : _this2.userInfomation.userJobs,
						education: _this2.userInfomation.userEducation == undefined ? ' ' : _this2.userInfomation.userEducation,
						live: _this2.userInfomation.userLives == undefined ? '' : _this2.userInfomation.userLives,
						health: _this2.userHealthStr,
						id: localStorage.getItem('userID'),
						tradeTypeId: _this2.userInfomation.classification == undefined ? '' : _this2.userInfomation.classification
					}).then(function (res) {
						localStorage.setItem("userName", this.userInfomation.userName);
						if (res.body = 1) {
							console.log(res.body);
							this.userName = this.userInfomation.userName;
							this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
							this.$message({
								message: '修改成功',
								type: 'success'
							});
						} else {
							this.$message({
								message: '修改失败',
								type: 'error'
							});
						}
					});
				} else {
					_this2.$message({
						message: '请填写基本信息',
						type: 'error'
					});
					return false;
				}
			});
		}
	}, created: function created() {
		this.$http.post(urls.urlApi + '/loadTradeList.json', {
			token: localStorage.getItem('token')
		}).then(function (res) {
			console.log(res.body);
			this.loadUserProfessional = res.body;
		});

		this.$http.post(urls.urltest + "/api/loadUserEducationList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.loadUserEducationList = res.body;
		});

		this.$http.post(urls.urltest + "/api/loadUserLiveList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.loadUserLiveList = res.body;
		});

		this.$http.post(urls.urltest + "/api/loadUserHealthList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			console.log(res.body);
			this.loadUserHealthList = res.body;
			console.log(this.loadUserHealthList);
			this.userHealthStr = res.body[0].id;
		});

		var _this = this;
		setTimeout(function () {
			_this.$http.post(urls.urltest + "/personal/getUserInfo.json", {
				token: localStorage.getItem('token')
			}).then(function (res) {
				console.log(res.body);
				_this.userInfomation.userName = res.body.object.name;
				localStorage.setItem("userID", res.body.object.id);
				_this.userSex = res.body.object.sex;
				_this.userInfomation.userCard = res.body.object.cardnumber;
				_this.userInfomation.userJobs = res.body.object.professional;
				_this.userInfomation.userBirthday = res.body.object.birthday;
				_this.userInfomation.userEducation = res.body.object.education;
				_this.userInfomation.userLives = res.body.object.live;
				_this.userInfomation.classification = res.body.object.tradeTypeId;
				_this.userInfomation.userJobs = res.body.object.tradeId;
				_this.userHealthStr = res.body.object.health;
				console.log(_this.userHealthStr);
				var content = document.querySelector('#content');
				for (var j = 0; j < content.children.length; j++) {
					for (var i = 0; i < _this.userHealthStr.length; i++) {
						if (_this.userHealthStr[i] == content.children[j].getAttribute('data-num')) {
							content.children[j].className = 'blue';
						}
					}
				}
			});
		});
	}
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	name: 'hello',
	data: function data() {
		var _this2 = this;

		var oldPassword = function oldPassword(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				callback();
			}
		};
		var validatePass = function validatePass(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入新密码'));
			} else {
				if (_this2.ruleForm2.checkPass !== '') {
					_this2.$refs.ruleForm2.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = function validatePass2(rule, value, callback) {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== _this2.ruleForm2.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			ruleForm2: {
				pass: '',
				checkPass: '',
				oldPassword: ''
			},
			rules2: {
				oldPassword: [{
					validator: oldPassword,
					trigger: 'blur'
				}],
				pass: [{
					validator: validatePass,
					trigger: 'blur'
				}],
				checkPass: [{
					validator: validatePass2,
					trigger: 'blur'
				}]
			}
		};
	},

	methods: {
		submitForm: function submitForm(formName) {
			var _this3 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this3.$http.post(urls.urltest + "/personal/updatePassword.json", {
						token: localStorage.getItem("token"),
						oldPassword: _this3.ruleForm2.oldPassword,
						newPassword: _this3.ruleForm2.checkPass,
						phone: localStorage.getItem("phone")
					}).then(function (res) {
						if (res.body == true) {
							this.$message({
								type: 'info',
								message: '\u4FEE\u6539\u5BC6\u7801\u6210\u529F\u4E3A\u60A8\u8DF3\u8F6C\u5230\u767B\u5F55\u9875'
							});
							var _this = this;
							setTimeout(function () {
								_this.$router.replace("/");
							}, 2000);
						} else {
							this.$message({
								type: 'error',
								message: '\u539F\u5BC6\u7801\u4E0D\u6B63\u786E\u8BF7\u8F93\u5165\u6B63\u786E\u5BC6\u7801'
							});
						}
					});
				} else {
					return false;
				}
			});
		},
		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	}
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		var checkBirthday = function checkBirthday(rule, value, callback) {
			setTimeout(function () {
				if (!value) {
					return callback(new Error('日期不能为空'));
				} else {
					callback();
				}
			}, 1000);
		};
		var isIDCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
		var checkCard = function checkCard(rule, value, callback) {
			if (!value) {
				return callback(new Error('身份证号不能为空'));
				callback();
			}
			setTimeout(function () {
				if (!isIDCard.test(value)) {
					callback(new Error('身份证号格式错误'));
				} else {
					callback();
				}
			}, 1000);
		};
		return {
			userName: null,
			userInfomation: {
				userName: '',
				userCard: '',
				userBirthday: '',
				userEducation: '',
				userLives: '',
				userJobs: '',
				classification: ''
			},
			rules: {
				userName: [{
					required: true,
					message: '请输入姓名',
					trigger: 'change'
				}],
				userCard: [{
					required: true,
					validator: checkCard,
					trigger: 'blur'
				}],
				userBirthday: [{
					required: true,
					validator: checkBirthday,
					trigger: 'change'
				}],
				userJobs: [{
					type: 'number',
					required: false,
					message: '请选择职业',
					trigger: 'blur'
				}],
				userEducation: [{
					type: 'number',
					required: false,
					message: '请选择教育程度',
					trigger: 'blur'
				}],
				userLives: [{
					type: 'number',
					required: false,
					message: '请选择居住地址',
					trigger: 'blur'
				}]
			},
			pickerOptions0: {
				disabledDate: function disabledDate(time) {
					return time.getTime() > new Date('2014,12,12,00:00:00').getTime() || time.getTime() < new Date('1899,12,12,00:00:00').getTime();
				}
			},
			userSexList: {
				0: "男",
				1: "女"
			},
			userSex: 0,
			loadUserHealthList: null,
			userHealth: [],
			loadUserEducationList: null,
			loadUserProfessional: null,
			loadUserLiveList: null,
			loadclassificationList: null,
			isShowInput: false,
			qita: '',
			userHealthStr: ''
		};
	},

	methods: {
		regCarNum: function regCarNum() {
			var code = this.userInfomation.userCard;
			if (code.length > 17) {
				var year = code.substring(6, 10);
				var month = code.substring(10, 12);
				var thetime = year + '-' + month;
				var d = new Date(Date.parse(thetime.replace(/-/g, "/")));
				var finishTimeDate = '2014-12';
				var endTimeDate = new Date(Date.parse(finishTimeDate.replace(/-/g, "/")));
				if (d <= endTimeDate) {
					this.userInfomation.userBirthday = year + -month;
				} else {
					this.userInfomation.userBirthday = '';
				}
				var sexName = code.substring(16, 17);
				var sex = sexName % 2 == 0 ? "1" : "0";
				this.userSex = sex;
			}
		},
		getclassification: function getclassification(loadclassID) {
			this.$http.post(urls.urlApi + '/loadTradeListByTid.json', {
				id: loadclassID == undefined ? '0' : loadclassID
			}).then(function (res) {
				console.log(res.body);
				this.loadclassificationList = res.body;
				this.userInfomation.classification = res.body[0].id;
			});
		},

		dataFormt: function dataFormt(val) {
			this.userInfomation.userBirthday = val;
		},
		currentClass: function currentClass(content, style) {
			for (var j = 1; j < content.children.length; j++) {
				content.children[j].className = style;
			}
		},
		check: function check(ind, ev) {
			var active = ev.getAttribute('data-num');
			var content = document.querySelector('#content');
			var inp = document.querySelector('#inp');
			var disStyle = -1;
			if (+active === 1) {
				if (ev.className === 'blue') {
					ev.className = 'ospan';
					this.currentClass(content, 'ospan');
				} else {
					ev.className = 'blue';
					inp.className = 'isnone';
					this.currentClass(content, 'ospan');
				}
			}
			if (+active !== 1) {
				if (ev.className === 'blue') {
					ev.className = 'ospan';
					if (+active === 10) {
						inp.className = 'isnone';
					}
					for (var j = 1; j < content.children.length; j++) {
						if (content.children[j].className === 'blue') {
							disStyle = 1;
						}
					}
					if (disStyle !== 1) {
						content.children[0].className = 'ospan';
					}
				} else {
					ev.className = 'blue';
					if (+active === 10) {
						inp.className = 'isblock';
					}
					content.children[0].className = 'ospan';
				}
			}
		},
		submit: function submit() {
			var content = document.querySelector('#content');
			var str = '';
			for (var j = 0; j < content.children.length; j++) {
				if (content.children[j].className === 'blue') {
					str += content.children[j].getAttribute('data-num') + ',';
				}
			}
			var reg = /,$/;
			str = str.replace(reg, '');
			this.userHealthStr = str;
		},
		saveInfo: function saveInfo(formName) {
			var _this2 = this;

			var eid = localStorage.getItem('eid');
			this.submit();
			console.log(this.userHealthStr);
			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this2.$http.post(urls.urltest + "/personal/updateMyInfo", {
						token: localStorage.getItem('token'),
						name: _this2.userInfomation.userName,
						sex: _this2.userSex,
						cardnumber: _this2.userInfomation.userCard,
						birthday: _this2.userInfomation.userBirthday,
						tradeId: _this2.userInfomation.userJobs == undefined ? '' : _this2.userInfomation.userJobs,
						education: _this2.userInfomation.userEducation == undefined ? ' ' : _this2.userInfomation.userEducation,
						live: _this2.userInfomation.userLives == undefined ? '' : _this2.userInfomation.userLives,
						health: _this2.userHealthStr,
						id: localStorage.getItem('userID'),
						tradeTypeId: _this2.userInfomation.classification == undefined ? '' : _this2.userInfomation.classification,
						eid: eid
					}).then(function (res) {
						localStorage.setItem("userName", this.userInfomation.userName);
						this.userName = this.userInfomation.userName;
						this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
						localStorage.setItem('eid', res.body);
						this.$router.push('/gamelist');
					});
				} else {
					_this2.$message({
						message: '请填写基本信息',
						type: 'error'
					});
					return false;
				}
			});
		}
	}, created: function created() {
		this.$http.post(urls.urlApi + '/loadTradeList.json', {
			token: localStorage.getItem('token')
		}).then(function (res) {
			console.log(res.body);
			this.loadUserProfessional = res.body;
		});

		this.$http.post(urls.urltest + "/api/loadUserEducationList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.loadUserEducationList = res.body;
		});

		this.$http.post(urls.urltest + "/api/loadUserLiveList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			console.log(res.body);
			this.loadUserLiveList = res.body;
		});

		this.$http.post(urls.urltest + "/api/loadUserHealthList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.loadUserHealthList = res.body;
			this.loadUserHealthList[1].className = "blue";
		});

		var _this = this;
		setTimeout(function () {
			_this.$http.post(urls.urltest + "/personal/getUserInfo.json", {
				token: localStorage.getItem('token')
			}).then(function (res) {
				console.log(res.body);
				_this.userInfomation.userName = res.body.object.name;
				localStorage.setItem("userID", res.body.object.id);
				_this.userSex = res.body.object.sex;
				_this.userInfomation.userCard = res.body.object.cardnumber;
				_this.userInfomation.userJobs = res.body.object.professional;
				_this.userInfomation.userBirthday = res.body.object.birthday;
				_this.userInfomation.userEducation = res.body.object.education;
				_this.userInfomation.userLives = res.body.object.live;
				_this.userInfomation.classification = res.body.object.tradeTypeId;
				_this.userInfomation.userJobs = res.body.object.tradeId;
				_this.userHealthStr = res.body.object.health;
				console.log(_this.userHealthStr);
				var content = document.querySelector('#content');
				for (var j = 0; j < content.children.length; j++) {
					for (var i = 0; i < _this.userHealthStr.length; i++) {
						if (_this.userHealthStr[i] == content.children[j].getAttribute('data-num')) {
							content.children[j].className = 'blue';
						}
					}
				}
			});
		});
	}
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	created: function created() {
		var _this = this;

		var url = location.href;
		var reg = /([^?&=]+)=([^?&=]*)/g;
		var obj1 = {};
		var arr1 = url.match(reg);
		for (var i = 0; i < arr1.length; i++) {
			if (arr1[i].indexOf('=') != -1) obj1[arr1[i].split('=')[0]] = arr1[i].split('=')[1];
		}
		console.log(obj1.out_trade_no);
		localStorage.setItem('orderNumber', obj1.out_trade_no);
		setTimeout(function () {
			_this.$http.post(urls.urltest + "/personal/checkUser.json", {
				token: localStorage.getItem('token'),
				phone: localStorage.getItem('phone')
			}).then(function (res) {
				if (res.body == '0') {
					this.$router.push('/startTest');
				} else {
					this.$router.push('/gamelist');
				}
			});
		}, 3000);
	}
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);



var components = {
	cIndex: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			gameReport: {}
		};
	},

	methods: {
		reportpage: function reportpage(gameReport) {
			if (gameReport.packageid == 6 && gameReport.bid == 2) {
				window.open('/#/mechanismCard');
			} else if (gameReport.packageid == 1 && gameReport.bid == 1) {
				window.open('/#/mechanismPrin');
			} else {
				window.open("/#/reportpage");
			}
		},
		endReportpage: function endReportpage() {
			this.$router.push({
				path: '/mybaogao'
			});
		}
	},
	created: function created() {
		this.$http.post(urls.urltest + "/game/getMyAssessReport.json", {
			eid: localStorage.getItem('eid'),
			token: localStorage.getItem('token')
		}).then(function (res) {
			console.log(res.body);
			this.gameReport = res.body;
		});
	}
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__);



var components = {
	myheader: __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			mySwiper: null,
			myIScroll: null

		};
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {

			_this.mySwiper = new Swiper('.swiper-container', {
				direction: 'horizontal',
				autoplay: 2400,
				loop: true,

				pagination: '.swiper-pagination'
			});
			_this.myIScroll = new IScroll(".content", {
				scrollY: true,
				scrollX: false,
				probeType: 3,
				preventDefault: false,
				bindToWrapper: true,
				"onScrollMove": function onScrollMove() {
					return false;
				},
				"onScrollEnd": function onScrollEnd() {
					return false;
				}
			});
		}, 200);
	},

	methods: {
		goPpayment: function goPpayment(ind) {
			this.$router.replace({ path: '/ppayment', query: { id: ind } });
		}
	},
	updated: function updated() {
		this.myIScroll.refresh();
	}
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__);



var components = {
	myheader: __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default.a
};

/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			isNull: false,
			isBaoGao: false
		};
	},
	created: function created() {
		this.$http.post(urls.urltest + '/personal/getMyReport.json', {
			token: localStorage.getItem('token')
		}).then(function (res) {
			console.log(res.body);
			if (res.body.records.length) {
				this.isBaoGao = true;
				this.isNull = false;
			} else {
				this.isBaoGao = false;
				this.isNull = true;
			}
		});
	}
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__);



var components = {
    myheader: __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
    components: components,
    data: function data() {
        return {
            myIScroll: null,
            getordernumber: '',
            getOrserList: {},
            isShowOrderList: false,
            isShowNull: false
        };
    },
    created: function created() {
        this.$http.post(urls.urltest + "/personal/getOrderList.json", {
            token: localStorage.getItem('token')
        }).then(function (res) {
            console.log(res.body);
            if (res.body.records.length) {
                this.isShowOrderList = true;
                this.isShowNull = false;
                console.log(res.body);
                this.getOrserList = res.body.records;
            } else {
                this.isShowOrderList = false;
                this.isShowNull = true;
            }
        });
    },

    methods: {
        buttonCancel: function buttonCancel() {
            this.$router.replace('/payment?pID=0');
        },
        buttonOrder: function buttonOrder(oderNumer) {
            console.log(oderNumer);
            window.location.href = urls.urltest + "/alipay/rewappay?ordernumber=" + oderNumer + '&token=' + localStorage.getItem('token');
        }
    },
    mounted: function mounted() {
        var _this = this;
        setTimeout(function () {
            _this.myIScroll = new IScroll(".pordermanagement", {
                prevenDefault: true
            });
        });
    },
    updated: function updated() {
        this.myIScroll.refresh();
    }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__);



var components = {
	myheader: __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		return {
			typeList: ["青年版", "中年版", "老年版"],
			comboList: ["基础套餐", "标准套餐", "升级套餐", "VIP套餐"],
			isMark: false,
			current: this.$route.query.id,
			comboCurrent: 1,
			myIScroll: null,
			PID: '',
			BID: '',
			username: '',
			isPaymentShow: false,
			introduceList: {
				price: ''
			}
		};
	},
	created: function created() {
		var _this = this;
		setTimeout(function () {
			_this.myIScroll = new IScroll(".ppayment", {
				prevenDefault: true
			});
		});
	},

	methods: {
		getCurrentTyle: function getCurrentTyle(ind) {
			this.current = ind;
			this.getPackageId(ind, this.comboCurrent);
		},
		getCurrentCombo: function getCurrentCombo(ind) {
			this.comboCurrent = ind;
			this.getPackageId(ind, this.current);
		},
		getPackageId: function getPackageId(pid, bid) {
			this.PID = pid;
			this.BID = bid;
			this.$http.post(urls.urltest + "/personal/getPackagevaBuvInfo.json", {
				pid: pid,
				bid: bid
			}).then(function (res) {
				this.introduceList = res.body;
			});
		},
		goPayment: function goPayment() {
			if (localStorage.getItem('token')) {
				this.$http.post(urls.urltest + "/alipay/checkLogin.json", {
					token: localStorage.getItem('token')
				}).then(function (res) {
					window.location.href = urls.urltest + "/alipay/zfbwappay?pid=" + this.PID + '&bid=' + this.BID + '&token=' + localStorage.getItem('token');
					this.isPaymentShow = false;
				});
			} else {
				this.$refs.pheader.goLoginOrReg();
			}
		}
	}, mounted: function mounted() {
		this.getPackageId(this.current, this.comboCurrent);
	},
	updated: function updated() {
		this.myIScroll.refresh();
	}
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(41);






var props = {
    name: {
        type: String,
        default: ''
    }
};
/* harmony default export */ __webpack_exports__["default"] = ({
    props: props,
    data: function data() {
        var _this2 = this;

        var reg = /^1[3|4|5|7|8][0-9]{9}$/;
        var checkAccount = function checkAccount(rule, value, callback) {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            }
            setTimeout(function () {
                if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
                    callback(new Error('请输入数字值'));
                } else {
                    if (!reg.test(value)) {
                        callback(new Error('用户名名格式错误'));
                    } else {
                        callback();
                    }
                }
            }, 1000);
        };
        var pwdReg = /^[0-9a-zA-Z_#]{6,16}$/;
        var validatePass = function validatePass(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (_this2.ruleForm2.checkPass !== '') {
                    _this2.$refs.ruleForm2.validateField('checkPass');
                } else if (!pwdReg.test(value)) {
                    callback(new Error('用户名名格式错误'));
                }
                callback();
            }
        };
        var validatePass2 = function validatePass2(rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== _this2.ruleForm2.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            current: 0,
            isAlert: false,
            myIScroll: null,
            isDropdowns: false,
            myFromList: {
                title: ""
            },
            isLoginContent: true,
            isRegForm: false,
            isForgotPassword: false,
            isLoginRegList: true,
            isSecond: false,
            isSecondT: false,
            isWelcome: false,
            secondText: 120,
            secondTextT: 120,
            userName: null,
            isNewPassword: false,
            dis: false,
            disab: false,
            ruleLogin: {
                userTel: '',
                userPwd: ''
            },
            registered: {
                userTel: '',
                zcuserPwd: '',
                sendSecond: ''
            },
            setNewPassword: {
                userTel: '',
                sendSecond: ''
            },
            ruleForm2: {
                pass: '',
                checkPass: ''
            },
            rules: {
                userTel: [{
                    required: true,
                    validator: checkAccount,
                    trigger: 'blur'
                }],
                userPwd: [{
                    required: true,
                    message: '密码不能为空',
                    trigger: 'blur'
                }]
            },
            newPas: {
                userTel: [{
                    required: true,
                    validator: checkAccount,
                    trigger: 'blur'
                }],
                sendSecond: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: 'blur'
                }]
            },
            rules2: {
                pass: [{
                    required: true,
                    validator: validatePass,
                    trigger: 'blur'
                }],
                checkPass: [{
                    required: true,
                    validator: validatePass2,
                    trigger: 'blur'
                }]
            },
            registeredRules: {
                userTel: [{
                    required: true,
                    validator: checkAccount,
                    trigger: 'blur'
                }],
                zcuserPwd: [{
                    required: true,
                    message: '密码不能为空',
                    trigger: 'blur'
                }],
                sendSecond: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: 'blur'
                }]
            }
        };
    },

    methods: {
        goLoginOrReg: function goLoginOrReg(ind) {
            this.current = ind;
            this.isAlert = true;
            if (ind == 0) {
                this.isLoginContent = true;
                this.isRegForm = false;
                this.isNewPassword = false;
                this.isForgotPassword = false;
                this.myFromList.title = "登录";
            } else if (ind == 1) {
                this.isLoginContent = false;
                this.isRegForm = true;
                this.isNewPassword = false;
                this.isForgotPassword = false;
                this.myFromList.title = "手机号注册";
            } else if (ind == 2) {
                this.isLoginContent = false;
                this.isRegForm = false;
                this.isNewPassword = false;
                this.isForgotPassword = true;
                this.myFromList.title = "重置密码";
            }
        },
        goHome: function goHome() {
            this.isAlert = false;
            this.isSecond = false;
            this.dis = false;
            this.isSecond = false;
        },
        getOperation: function getOperation(formName) {
            var _this3 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    console.log(_this3.ruleLogin.userTel);
                    console.log(_this3.ruleLogin.userPwd);
                    _this3.$http.post(urls.urltest + "/personal/login.json", {
                        phone: _this3.ruleLogin.userTel,
                        password: _this3.ruleLogin.userPwd
                    }).then(function (res) {
                        if (res.body) {
                            this.isAlert = false;
                            this.isWelcome = true;
                            this.isLoginRegList = false;
                            localStorage.setItem("token", res.body.token);
                            localStorage.setItem("userName", res.body.object.username);
                            this.userName = localStorage.getItem("userName");
                            this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
                        } else {
                            this.$message({
                                message: '错了哦，请确认登录名或密码',
                                type: 'error'
                            });
                        }
                    });
                }
            });
        },
        getRegInfo: function getRegInfo(formName) {
            var _this4 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this4.$http.post(urls.urltest + "/personal/registUser.json", {
                        phone: _this4.registered.userTel,
                        password: _this4.registered.zcuserPwd,
                        code: _this4.registered.sendSecond
                    }).then(function (res) {
                        this.isAlert = false;
                        this.isWelcome = true;
                        this.isLoginRegList = false;
                        localStorage.setItem("userName", res.body.object.username);
                        this.userName = localStorage.getItem("userName");
                        this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
                        localStorage.setItem("token", res.body.token);
                    });
                } else {
                    return false;
                }
            });
        },
        goResetPassword: function goResetPassword(formName) {
            var _this5 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this5.$http.post(urls.urltest + "/personal/checkPhoneCode.json", {
                        code: _this5.setNewPassword.sendSecond,
                        phone: _this5.setNewPassword.userTel
                    }).then(function (res) {
                        if (res.body) {
                            this.isLoginContent = false;
                            this.isRegForm = false;
                            this.isForgotPassword = false;
                            this.isNewPassword = true;
                        } else {
                            this.$message({
                                message: '验证码输入不正确',
                                type: 'error'
                            });
                            return false;
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        getNewPwd: function getNewPwd(formName) {
            var _this6 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this6.$http.post(urls.urltest + "/personal/changePassword.json", {
                        phone: _this6.setNewPassword.userTel,
                        password: _this6.ruleForm2.checkPass
                    }).then(function (res) {
                        this.isAlert = false;
                        this.isWelcome = true;
                        this.isLoginRegList = false;
                        localStorage.setItem("token", res.body.token);
                        this.$message({
                            message: '密码修改成功',
                            type: 'success'
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        changeIndex: function changeIndex(index) {
            console.log(index + "gxj");
            if (index == 0) {
                this.$store.dispatch("changeIndex", index);
                this.$router.replace('/');
            } else {
                if (localStorage.getItem("token")) {
                    this.$store.dispatch("changeIndex", index);
                    this.$router.replace('/pmybaogao');
                } else {
                    this.goLoginOrReg(0);
                }
            }
        },
        getMoreInfo: function getMoreInfo() {
            if (localStorage.getItem("token")) {
                console.log(this.isDropdowns);
                this.isDropdowns = !this.isDropdowns;
                console.log(this.isDropdowns);
            } else {
                this.goLoginOrReg(0);
            }
        },
        goSetInfo: function goSetInfo() {
            this.$router.replace('/psetinfo');
            this.isDropdowns = false;
            this.$store.dispatch("changeIndex", -1);
        },
        goOrdErmanagement: function goOrdErmanagement() {
            this.$router.replace('pordermanagement');
            this.isDropdowns = false;
            this.$store.dispatch("changeIndex", -1);
        },
        setExit: function setExit() {
            this.$http.post(urls.urltest + '/personal/loginout.json', {
                token: localStorage.getItem('token')
            }).then(function (res) {
                localStorage.clear();
                this.isLoginRegList = true;
                this.isWelcome = false;
                this.isDropdowns = false;
                this.$router.replace('/');
                this.$store.dispatch("changeIndex", 0);
            });
        },
        regPhone: function regPhone() {
            this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
                phone: this.registered.userTel
            }).then(function (res) {
                if (res.body == "1") {
                    this.$message({
                        message: '手机号码已经注册',
                        type: 'error'
                    });
                }
            });
        },
        setregPhone: function setregPhone() {
            this.$http.post(urls.urltest + "/personal/checkUserExist.json", {
                phone: this.setNewPassword.userTel
            }).then(function (res) {
                if (res.body == "0") {
                    this.$message({
                        message: '用户不存在',
                        type: 'error'
                    });
                    return false;
                }
            });
        },
        getRegCode: function getRegCode() {
            console.log(0);
            if (this.registered.userTel == '') {
                this.$message({
                    message: '请填写手机号码',
                    type: 'error'
                });
            } else if (!this.registered.userTel == '') {
                this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
                    phone: this.registered.userTel
                }).then(function (res) {
                    if (res.body == "1") {
                        this.$message({
                            message: '手机号码已经注册',
                            type: 'error'
                        });
                    } else {
                        var _this = this;
                        this.isSecond = true;
                        this.dis = false;
                        this.$http.post(urls.urltest + "/personal/getRegistCheckCode.json", {
                            phone: this.registered.userTel
                        }).then(function (res) {
                            console.log(res.body);
                            var timer = null;
                            var sT = this.secondText * 1;
                            timer = setInterval(function () {
                                if (sT > 0) {
                                    _this.dis = true;
                                    sT--;
                                }
                                _this.secondText = sT;
                                if (_this.secondText <= 0) {
                                    _this.dis = false;
                                    clearInterval(timer);
                                    _this.isSecond = false;
                                    _this.secondText = 120;
                                }
                            }, 1000);
                        });
                    }
                });
            }
        },
        getRegNumber: function getRegNumber() {
            if (this.setNewPassword.userTel == '') {
                this.$message({
                    message: '请填写手机号码',
                    type: 'error'
                });
            } else if (!this.setNewPassword.userTel == '') {
                this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
                    phone: this.setNewPassword.userTel
                }).then(function (res) {
                    if (res.body == "0") {
                        this.$message({
                            message: '用户不存在',
                            type: 'error'
                        });
                    } else {
                        var _this = this;
                        this.isSecondT = true;
                        this.disab = false;
                        this.$http.post(urls.urltest + "/personal/getChangePassWordCode.json", {
                            phone: this.setNewPassword.userTel
                        }).then(function (res) {
                            console.log(res.body);
                            var timer = null;
                            var sT = this.secondTextT * 1;
                            timer = setInterval(function () {
                                if (sT > 0) {
                                    _this.disab = true;
                                    sT--;
                                }
                                _this.secondTextT = sT;
                                if (_this.secondTextT <= 0) {
                                    clearInterval(timer);
                                    _this.disab = false;
                                    _this.isSecondT = false;
                                    _this.secondTextT = 120;
                                }
                            }, 1000);
                        });
                    }
                });
            }
        }
    },
    created: function created() {
        if (localStorage.getItem("token")) {
            this.isWelcome = true;
            this.isLoginRegList = false;
            this.userName = localStorage.getItem("userName");
            this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
        }
    },

    store: __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['ind']))
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(41);





/* harmony default export */ __webpack_exports__["default"] = ({
	store: __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */],
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['ind']))
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__);



var components = {
  myheader: __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
  components: components,
  data: function data() {
    return {
      myIScroll: null
    };
  },
  created: function created() {
    var _this = this;
    setTimeout(function () {
      _this.myIScroll = new IScroll(".report-wrap", {
        prevenDefault: true
      });
    });
  },

  methods: {},
  updated: function updated() {
    this.myIScroll.refresh();
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader__);



var components = {
	myheader: __WEBPACK_IMPORTED_MODULE_0__phonecomponents_pheader___default.a
};
/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	data: function data() {
		var checkBirthday = function checkBirthday(rule, value, callback) {
			setTimeout(function () {
				if (!value) {
					return callback(new Error('日期不能为空'));
				} else {
					callback();
				}
			}, 1000);
		};
		var isIDCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
		var checkCard = function checkCard(rule, value, callback) {
			if (!value) {
				return callback(new Error('身份证号不能为空'));
			}
			setTimeout(function () {
				if (!isIDCard.test(value)) {
					callback(new Error('身份证号格式错误'));
				} else {
					callback();
				}
			}, 1000);
		};
		return {
			myIScroll: null,
			userName: null,
			userInfomation: {
				userName: '',
				userCard: '',
				userBirthday: '',
				userEducation: '',
				userLives: '',
				userJobs: ''
			},
			rules: {
				userName: [{
					required: true,
					message: '请输入姓名',
					trigger: 'change'
				}],
				userCard: [{
					required: true,
					validator: checkCard,
					trigger: 'blur'
				}],
				userBirthday: [{
					required: true,
					validator: checkBirthday,
					trigger: 'change'
				}],
				userJobs: [{
					type: 'number',
					required: true,
					message: '请选择职业',
					trigger: 'blur'
				}],
				userEducation: [{
					type: 'number',
					required: 'true',
					message: '请选择教育程度',
					trigger: 'blur'
				}],
				userLives: [{
					type: 'number',
					required: true,
					message: '请选择居住地址',
					trigger: 'blur'
				}]
			},
			pickerOptions0: {
				disabledDate: function disabledDate(time) {
					return time.getTime() > new Date('2000,12,12,00:00:00').getTime() || time.getTime() < new Date('1899,12,12,00:00:00').getTime();;
				}
			},
			userSex: 0,
			loadUserHealthList: null,
			userHealth: [],
			userHealthStr: '',
			loadUserEducationList: null,
			loadUserProfessional: null,
			loadUserLiveList: null,
			isShowInput: false,
			qita: ''
		};
	},

	methods: {
		dataFormt: function dataFormt(val) {
			this.userInfomation.userBirthday = val;
		},
		getSex: function getSex(ind) {
			this.userSex = ind;
			console.log(this.userSex);
		},
		currentClass: function currentClass(content, style) {
			for (var j = 1; j < content.children.length; j++) {
				content.children[j].className = style;
			}
		},
		check: function check(ind, ev) {
			var active = ev.getAttribute('data-num');
			var content = document.querySelector('#content');
			var inp = document.querySelector('#inp');
			var disStyle = -1;
			if (+active === 1) {
				if (ev.className === 'blue') {
					ev.className = 'ospan';
					this.currentClass(content, 'ospan');
				} else {
					ev.className = 'blue';
					inp.className = 'isnone';
					this.currentClass(content, 'ospan');
				}
			}
			if (+active !== 1) {
				if (ev.className === 'blue') {
					ev.className = 'ospan';
					if (+active === 10) {
						inp.className = 'isnone';
					}
					for (var j = 1; j < content.children.length; j++) {
						if (content.children[j].className === 'blue') {
							disStyle = 1;
						}
					}
					if (disStyle !== 1) {
						content.children[0].className = 'ospan';
					}
				} else {
					ev.className = 'blue';
					if (+active === 10) {
						inp.className = 'isblock';
					}
					content.children[0].className = 'ospan';
				}
			}
		},
		submit: function submit() {
			var content = document.querySelector('#content');
			var str = '';
			for (var j = 0; j < content.children.length; j++) {
				if (content.children[j].className === 'blue') {
					str += content.children[j].getAttribute('data-num') + ',';
				}
			}
			var reg = /,$/;
			str = str.replace(reg, '');
			this.userHealthStr = str;
		},
		saveInfo: function saveInfo(formName) {
			var _this2 = this;

			this.submit();
			console.log(this.userHealthStr);
			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this2.$http.post(urls.urltest + "/personal/updateMyInfo", {
						token: localStorage.getItem('token'),
						name: _this2.userInfomation.userName,
						sex: _this2.userSex,
						cardnumber: _this2.userInfomation.userCard,
						birthday: _this2.userInfomation.userBirthday,
						professional: _this2.userInfomation.userJobs,
						education: _this2.userInfomation.userEducation,
						live: _this2.userInfomation.userLives,
						health: _this2.userHealthStr,
						id: localStorage.getItem('userID')
					}).then(function (res) {
						localStorage.setItem("userName", this.userInfomation.userName);
						if (res.body = 1) {
							console.log(res.body);
							this.userName = this.userInfomation.userName;
							this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName;
							this.$message({
								message: '修改成功',
								type: 'success'
							});
						} else {
							this.$message({
								message: '修改失败',
								type: 'error'
							});
						}
					});
				} else {
					_this2.$message({
						message: '请填写基本信息',
						type: 'error'
					});
					return false;
				}
			});
		}
	}, created: function created() {
		var _this = this;
		setTimeout(function () {
			_this.$http.post(urls.urltest + "/personal/getUserInfo.json", {
				token: localStorage.getItem('token')
			}).then(function (res) {
				console.log(res.body);
				_this.userInfomation.userName = res.body.object.username;
				localStorage.setItem("userID", res.body.object.id);
				_this.userSex = res.body.object.sex;
				_this.userInfomation.userCard = res.body.object.cardnumber;
				_this.userInfomation.userJobs = res.body.object.professional;
				_this.userInfomation.userBirthday = res.body.object.birthday;
				_this.userInfomation.userEducation = res.body.object.education;
				_this.userInfomation.userLives = res.body.object.live;
				_this.userHealthStr = res.body.object.health;
				console.log(_this.userHealthStr);
				var content = document.querySelector('#content');
				for (var j = 0; j < content.children.length; j++) {
					for (var i = 0; i < _this.userHealthStr.length; i++) {
						if (_this.userHealthStr[i] == content.children[j].getAttribute('data-num')) {
							content.children[j].className = 'blue';
						}
					}
				}
			});
		});

		this.$http.post(urls.urltest + "/api/loadUserProfessional.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.loadUserProfessional = res.body;
		});

		this.$http.post(urls.urltest + "/api/loadUserEducationList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.loadUserEducationList = res.body;
		});

		this.$http.post(urls.urltest + "/api/loadUserLiveList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.loadUserLiveList = res.body;
		});

		this.$http.post(urls.urltest + "/api/loadUserHealthList.json", {
			token: localStorage.getItem('token')
		}).then(function (res) {
			this.loadUserHealthList = res.body;
		});
	},
	mounted: function mounted() {
		var _this = this;
		setTimeout(function () {
			_this.myIScroll = new IScroll(".psetinfo", {
				prevenDefault: true
			});
		});
	},
	updated: function updated() {
		var _this = this;
		setTimeout(function () {
			_this.myIScroll.refresh();
		});
	}
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mock_mock__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_urls_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_urlLogin_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_swiper__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_iscroll__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_iscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_iscroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_default_index_css__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_default_index_css__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_12_echarts___default.a;


global.urls = __WEBPACK_IMPORTED_MODULE_5__scripts_urls_js__["a" /* default */];
global.urlLogin = __WEBPACK_IMPORTED_MODULE_6__scripts_urlLogin_js__["a" /* default */];
global.$ = __WEBPACK_IMPORTED_MODULE_9_jquery___default.a;
global.Swiper = __WEBPACK_IMPORTED_MODULE_10_swiper___default.a;
global.IScroll = __WEBPACK_IMPORTED_MODULE_11_iscroll___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

document.addEventListener('touchmove', function (e) {
  e.preventDefault();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_8_element_ui__["Button"].name, __WEBPACK_IMPORTED_MODULE_8_element_ui__["Button"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_8_element_ui__["Select"].name, __WEBPACK_IMPORTED_MODULE_8_element_ui__["Select"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_8_element_ui__["Dialog"].name, __WEBPACK_IMPORTED_MODULE_8_element_ui__["Dialog"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_8_element_ui__["Form"].name, __WEBPACK_IMPORTED_MODULE_8_element_ui__["Checkbox"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_8_element_ui__["Form"].name, __WEBPACK_IMPORTED_MODULE_8_element_ui__["Form"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateHTTP = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  http: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  request.method = 'POST';
  next(function (response) {
    if (response.body.code == 500) {
      location.href = "/#/";
      localStorage.clear();
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(66)))

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ind", function() { return ind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tyleInd", function() { return tyleInd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comboInd", function() { return comboInd; });
var ind = function ind(state) {
	return state.navCount;
};
var tyleInd = function tyleInd(state) {
	return state.tyleCount;
};
var comboInd = function comboInd(state) {
	return state.comboCount;
};


/***/ }),
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.39526d8.png";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.a13e0a4.png";

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAAXNSR0IArs4c6QAAASZJREFUGBljmDlz5rSFCxcKM0ABkN80d+5cdRgfRjNxcHC0/vjxYzpQAT9IkJOTs/Pv378N8+bNU4IpAtFM8fHxT5mZmUsZGRlnrVq1iicuLu4rFxdX+p8/f9qBimVhihlhjDlz5qj8+/ev+f///8np6enfli5dKvjly5eZQPl8IP85XCFIA9B6DaDJNTIyMsleXl4/gXwRIH86CwtLFhPMRBAN1HkD6Izux48fT4Hy37CysuYCnTEHRSFIEuiRSCC1AcQGAaAiP6Bz9kJ4UHLWrFmNQBwME5w9e3Yc0PoyGB9MAwWrgIJRMEGghjAgvxbGB9NAwSIgToIJAjX5AxW1wvhgGiiYDVSUBRMEBpMHUFEPjA+ngYJucA6QAdToCnQ8SrCB5AGDZX6F0QBQ2AAAAABJRU5ErkJggg=="

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner2.af6810b.png";

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner3.cbe2ea6.png";

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner6.0b5fe9a.png";

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/childTitle-one.479af6f.png";

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/childTitle-two.c0f6253.png";

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guide1.da5313f.png";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guide2.bd418c7.png";

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guide3.51e0d10.png";

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guide4.174c698.png";

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/report.2305e70.png";

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sanjiao.0c48c92.png";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/weChatLogo.1b42728.png";

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(768),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(749),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(760),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(752),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(755),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(767),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(763),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(761),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(764),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(753),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(758),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(766),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(765),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  null,
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(774),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(772),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(670)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(746),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(669)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(745),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(750),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(759),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(762),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(770),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(751),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(756),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(747),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(769),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(672)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(748),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "startTest-wrap"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "setInfo-content"
  }, [_c('div', {
    staticClass: "myfrom"
  }, [_c('h3', [_vm._v("提示:您是首次进行脑能力检测的用户,为了检测的结果更加准确,请您完善以下基本信息 !")]), _vm._v(" "), _c('el-form', {
    ref: "userInfomation",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.userInfomation,
      "rules": _vm.rules,
      "label-width": "90px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名：",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 10,
      "value": _vm.userInfomation.userName
    },
    model: {
      value: (_vm.userInfomation.userName),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userName", $$v)
      },
      expression: "userInfomation.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.userSex),
      callback: function($$v) {
        _vm.userSex = $$v
      },
      expression: "userSex"
    }
  }, _vm._l((_vm.userSexList), function(item, index, key) {
    return _c('el-radio-button', {
      key: key,
      attrs: {
        "label": key,
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号：",
      "prop": "userCard"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 18,
      "value": _vm.userInfomation.userCard
    },
    on: {
      "change": _vm.regCarNum
    },
    model: {
      value: (_vm.userInfomation.userCard),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userCard", $$v)
      },
      expression: "userInfomation.userCard"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出生年月：",
      "prop": "userBirthday"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "placeholder": "选择日期",
      "default-value": "1990",
      "picker-options": _vm.pickerOptions0
    },
    on: {
      "change": _vm.dataFormt
    },
    model: {
      value: (_vm.userInfomation.userBirthday),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userBirthday", $$v)
      },
      expression: "userInfomation.userBirthday"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('p', [_vm._v("温馨提示：身份证信息将帮助您可以对比查看多年检测报告"), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(272),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "行业",
      "prop": "userJobs"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.getclassification(_vm.userInfomation.userJobs)
      }
    },
    model: {
      value: (_vm.userInfomation.userJobs),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userJobs", $$v)
      },
      expression: "userInfomation.userJobs"
    }
  }, _vm._l((_vm.loadUserProfessional), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类：",
      "prop": "classification"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.classification),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "classification", $$v)
      },
      expression: "userInfomation.classification"
    }
  }, _vm._l((_vm.loadclassificationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现居住地",
      "prop": "userLives"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.userLives),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userLives", $$v)
      },
      expression: "userInfomation.userLives"
    }
  }, _vm._l((_vm.loadUserLiveList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教育程度",
      "prop": "userEducation"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.userEducation),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userEducation", $$v)
      },
      expression: "userInfomation.userEducation"
    }
  }, _vm._l((_vm.loadUserEducationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "healthList-wrap",
    attrs: {
      "label": "健康状况"
    }
  }, [_c('div', {
    staticClass: "healthList",
    attrs: {
      "id": "content"
    }
  }, _vm._l((_vm.loadUserHealthList), function(item, index) {
    return _c('span', {
      attrs: {
        "data-num": index + 1
      },
      on: {
        "click": function($event) {
          _vm.check(index, $event.target)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('input', {
    staticClass: "isnone",
    attrs: {
      "type": "text",
      "id": "inp"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "button-content"
  }, [_c('el-button', {
    staticClass: "buttons",
    on: {
      "click": function($event) {
        _vm.saveInfo('userInfomation')
      }
    }
  }, [_vm._v("开始检测")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('cIndex', {
    ref: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "setpassword-content"
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.ruleForm2.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "oldPassword", $$v)
      },
      expression: "ruleForm2.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "pass", $$v)
      },
      expression: "ruleForm2.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "再次输入密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "setpassword-button"
  }, [_c('a', {
    staticClass: "fanhui",
    attrs: {
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.back(-1)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('a', {
    staticClass: "submits",
    attrs: {
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm2')
      }
    }
  }, [_vm._v("提交")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pindex"
  }, [_c('section', {
    staticClass: "container"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "psetinfo"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "height": ".3rem"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "psetinfo-from"
  }, [_c('el-form', {
    ref: "userInfomation",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.userInfomation,
      "rules": _vm.rules,
      "label-width": "90px",
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "姓名：",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 10,
      "value": _vm.userInfomation.userName
    },
    model: {
      value: (_vm.userInfomation.userName),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userName", $$v)
      },
      expression: "userInfomation.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "性别："
    }
  }, [_c('div', {
    staticClass: "sexlist"
  }, [_c('span', {
    class: _vm.userSex == 0 ? 'isActive' : '',
    on: {
      "touchend": function($event) {
        _vm.getSex(0)
      }
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('span', {
    class: _vm.userSex == 1 ? 'isActive' : '',
    on: {
      "touchend": function($event) {
        _vm.getSex(1)
      }
    }
  }, [_vm._v("女")])])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "身份证号：",
      "prop": "userCard"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 18,
      "value": _vm.userInfomation.userCard
    },
    model: {
      value: (_vm.userInfomation.userCard),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userCard", $$v)
      },
      expression: "userInfomation.userCard"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "出生年月：",
      "prop": "userBirthday"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "placeholder": "选择日期",
      "default-value": "1990",
      "picker-options": _vm.pickerOptions0
    },
    on: {
      "change": _vm.dataFormt
    },
    model: {
      value: (_vm.userInfomation.userBirthday),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userBirthday", $$v)
      },
      expression: "userInfomation.userBirthday"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "职业：",
      "prop": "userJobs"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.userJobs),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userJobs", $$v)
      },
      expression: "userInfomation.userJobs"
    }
  }, _vm._l((_vm.loadUserProfessional), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "教育程度",
      "prop": "userEducation"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.userEducation),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userEducation", $$v)
      },
      expression: "userInfomation.userEducation"
    }
  }, _vm._l((_vm.loadUserEducationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "现居住地",
      "prop": "userLives"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.userLives),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userLives", $$v)
      },
      expression: "userInfomation.userLives"
    }
  }, _vm._l((_vm.loadUserLiveList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "健康状况"
    }
  }, [_c('div', {
    staticClass: "healthList",
    attrs: {
      "id": "content"
    }
  }, _vm._l((_vm.loadUserHealthList), function(item, index) {
    return _c('span', {
      attrs: {
        "data-num": index + 1
      },
      on: {
        "touchend": function($event) {
          _vm.check(index, $event.target)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('input', {
    staticClass: "isnone",
    attrs: {
      "type": "text",
      "id": "inp"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "buttons",
    on: {
      "click": function($event) {
        _vm.saveInfo('userInfomation')
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".7rem"
    }
  })]), _vm._v(" "), _c('myheader', {
    ref: "pheader",
    attrs: {
      "name": _vm.userName
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "psetinfo-title"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t提示：您是首次进行脑能力检测用户，为了检测的结果更加准确，请您完善以下基本信息！\n\t\t\t\t")])])
}]}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "myfroms"
    }
  })])
}]}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "successfulpayment"
  }, [_c('h3', [_vm._v("支付成功")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(105),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("支付成功！")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', [_vm._v("2s后跳转到 ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/startTest"
    }
  }, [_vm._v("脑检测页面")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pordermanagement"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowOrderList),
      expression: "isShowOrderList"
    }]
  }, [_c('div', {
    staticStyle: {
      "height": ".3rem"
    }
  }), _vm._v(" "), _vm._l((_vm.getOrserList), function(item) {
    return _c('div', {
      staticClass: "order"
    }, [_c('ul', {
      staticClass: "order-title"
    }, [_c('li', [_c('b', [_vm._v("订单号 ：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.ordernumber) + "5")])]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(item.zfzt) + "\n                    ")])]), _vm._v(" "), _c('ul', {
      staticClass: "order-center"
    }, [_c('li', [_c('b', [_vm._v("订单日期 ：")]), _c('span', [_vm._v(_vm._s(item.createtime))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("姓名 ：")]), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("套餐类型 ：")]), _c('span', [_vm._v(_vm._s(item.tc))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("检测状态 ：")]), _c('span', [_vm._v(_vm._s(item.cpzt))])])]), _vm._v(" "), _c('div', {
      staticClass: "order-footer"
    }, [_c('span', [_vm._v("\n                        ¥" + _vm._s(item.tcprice) + "\n                    ")]), _vm._v(" "), (item.zfzt === '已取消') ? _c('button', {
      staticClass: "button-cancel",
      on: {
        "click": _vm.buttonCancel
      }
    }, [_vm._v("再次购买")]) : _vm._e(), _vm._v(" "), (item.zfzt === '未支付') ? _c('button', {
      staticClass: "button-noOrder",
      on: {
        "click": function($event) {
          _vm.buttonOrder(item.ordernumber)
        }
      }
    }, [_vm._v("继续支付")]) : _vm._e(), _vm._v(" "), (item.zfzt === '已支付' && item.cpzt === '已检测') ? _c('button', {
      staticClass: "button-order"
    }, [_vm._v("查看报告")]) : _vm._e(), _vm._v(" "), (item.zfzt === '已支付' && item.cpzt === '未检测') ? _c('button', {
      staticClass: "button-evaluation"
    }, [_vm._v("前往检测")]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".7rem"
    }
  })], 2), _vm._v(" "), _c('myheader', {
    ref: "pheader"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNull),
      expression: "isShowNull"
    }],
    staticClass: "order-null"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(236)
    }
  }), _vm._v(" "), _c('h5', [_vm._v("\n                暂无订单\n            ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gameover_game"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "gameover"
  }, [_c('div', {
    staticClass: "gameover-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "gameover-button"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/gamelist',
        query: {
          id: 1
        }
      }
    }
  }, [_vm._v("返回首页测试")]), _vm._v(" "), _c('a', {
    staticClass: "gameover-button-on",
    on: {
      "click": _vm.carryGame
    }
  }, [_vm._v("继续测试")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "myfroms"
    }
  })])
}]}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pheader-wrap"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginRegList),
      expression: "isLoginRegList"
    }]
  }, [_c('li', {
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(0)
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('li', {
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(1)
      }
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isWelcome),
      expression: "isWelcome"
    }]
  }, [_c('span', [_vm._v("欢迎你")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.name ? _vm.name : _vm.userName)
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAlert),
      expression: "isAlert"
    }],
    staticClass: "alertMark"
  }, [_c('div', {
    staticClass: "alert-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.myFromList.title)), _c('img', {
    attrs: {
      "src": __webpack_require__(148)
    },
    on: {
      "touchend": _vm.goHome
    }
  })]), _vm._v(" "), _c('ul', [_c('li', {
    class: _vm.current == 0 ? 'active' : '',
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(0)
      }
    }
  }, [_c('p', [_vm._v("登录")])]), _vm._v(" "), _c('li', {
    class: _vm.current == 1 ? 'active' : '',
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(1)
      }
    }
  }, [_c('p', [_vm._v("注册")])])]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginContent),
      expression: "isLoginContent"
    }],
    ref: "ruleLogin",
    attrs: {
      "model": _vm.ruleLogin,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 11,
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.ruleLogin.userTel),
      callback: function($$v) {
        _vm.$set(_vm.ruleLogin, "userTel", _vm._n($$v))
      },
      expression: "ruleLogin.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "userPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.ruleLogin.userPwd),
      callback: function($$v) {
        _vm.$set(_vm.ruleLogin, "userPwd", $$v)
      },
      expression: "ruleLogin.userPwd"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "forgotPassword",
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(2)
      }
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('span', {
    staticClass: "myfrom-buttons",
    on: {
      "touchend": function($event) {
        _vm.getOperation('ruleLogin')
      }
    }
  }, [_vm._v("登 录")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRegForm),
      expression: "isRegForm"
    }],
    ref: "registered",
    attrs: {
      "label-position": "top",
      "model": _vm.registered,
      "rules": _vm.registeredRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 11,
      "placeholder": "请输入手机号"
    },
    on: {
      "blur": _vm.regPhone
    },
    model: {
      value: (_vm.registered.userTel),
      callback: function($$v) {
        _vm.$set(_vm.registered, "userTel", _vm._n($$v))
      },
      expression: "registered.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "zcuserPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入6-16位数字或字母"
    },
    model: {
      value: (_vm.registered.zcuserPwd),
      callback: function($$v) {
        _vm.$set(_vm.registered, "zcuserPwd", $$v)
      },
      expression: "registered.zcuserPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "regCodeFrom",
    attrs: {
      "label": "验证码",
      "prop": "sendSecond"
    }
  }, [_c('el-input', {
    staticClass: "regCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": 6
    },
    model: {
      value: (_vm.registered.sendSecond),
      callback: function($$v) {
        _vm.$set(_vm.registered, "sendSecond", $$v)
      },
      expression: "registered.sendSecond"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "codebutton",
    attrs: {
      "disabled": _vm.dis
    },
    on: {
      "click": _vm.getRegCode
    }
  }, [_vm._v("获取验证码"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecond),
      expression: "isSecond"
    }]
  }, [_vm._v(" " + _vm._s(_vm.secondText) + "s")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "myfrom-buttons",
    on: {
      "touchend": function($event) {
        _vm.getRegInfo('registered')
      }
    }
  }, [_vm._v("注 册")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isForgotPassword),
      expression: "isForgotPassword"
    }],
    ref: "setNewPassword",
    attrs: {
      "label-position": "top",
      "model": _vm.setNewPassword,
      "rules": _vm.newPas
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 11,
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    on: {
      "blur": _vm.setregPhone
    },
    model: {
      value: (_vm.setNewPassword.userTel),
      callback: function($$v) {
        _vm.$set(_vm.setNewPassword, "userTel", _vm._n($$v))
      },
      expression: "setNewPassword.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "regCodeFrom",
    attrs: {
      "label": "验证码",
      "prop": "sendSecond"
    }
  }, [_c('el-input', {
    staticClass: "regCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": 6
    },
    model: {
      value: (_vm.setNewPassword.sendSecond),
      callback: function($$v) {
        _vm.$set(_vm.setNewPassword, "sendSecond", $$v)
      },
      expression: "setNewPassword.sendSecond"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "codebutton",
    attrs: {
      "disabled": _vm.disab
    },
    on: {
      "click": _vm.getRegNumber
    }
  }, [_vm._v("获取验证码"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecondT),
      expression: "isSecondT"
    }]
  }, [_vm._v(" " + _vm._s(_vm.secondTextT) + "s")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "myfrom-buttons",
    on: {
      "touchend": function($event) {
        _vm.goResetPassword('setNewPassword')
      }
    }
  }, [_vm._v("下 一 步")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNewPassword),
      expression: "isNewPassword"
    }],
    ref: "ruleForm2",
    attrs: {
      "label-position": "top",
      "model": _vm.ruleForm2,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入6-16位数字或字母",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "pass", $$v)
      },
      expression: "ruleForm2.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请确认登录密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入6-16位数字或字母",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "myfrom-buttons",
    on: {
      "touchend": function($event) {
        _vm.getNewPwd('ruleForm2')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('ul', [_c('li', [_c('p', {
    class: _vm.ind == 0 ? 'active' : '',
    on: {
      "touchend": function($event) {
        _vm.changeIndex(0)
      }
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('p', {
    class: _vm.ind == 1 ? 'active' : '',
    on: {
      "touchend": function($event) {
        _vm.changeIndex(1)
      }
    }
  }, [_vm._v("我的报告")])]), _vm._v(" "), _c('li', [_c('p', {
    on: {
      "touchend": _vm.getMoreInfo
    }
  }, [_vm._v("更多")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDropdowns),
      expression: "isDropdowns"
    }],
    staticClass: "dropdowns"
  }, [_c('ul', [_c('li', [_c('span', {
    on: {
      "click": _vm.goSetInfo
    }
  }, [_vm._v("个人设置")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": _vm.goOrdErmanagement
    }
  }, [_vm._v("订单管理")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "touchend": _vm.setExit
    }
  }, [_vm._v("退出系统")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(716)
    }
  })])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-div"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "edition"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.goPayment(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(710),
      "alt": "图片"
    }
  }), _c('span', [_vm._v("青年版（17-44周岁）")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goPayment(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(711),
      "alt": "图片"
    }
  }), _c('span', [_vm._v("中年版（45-60周岁）")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goPayment(3)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(712),
      "alt": "图片"
    }
  }), _c('span', [_vm._v("老年版（60周岁以上）")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goPayment(4)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(713),
      "alt": "图片"
    }
  }), _c('span', [_vm._v("儿童版（5-16周岁）")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(707)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(705)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(706)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-button"
  })])])
}]}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ppayment"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "height": ".3rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ppayment-top"
  }, [_c('h4', [_vm._v("选择类型")]), _vm._v(" "), _c('div', _vm._l((_vm.typeList), function(item, index) {
    return _c('span', {
      class: _vm.current == index + 1 ? 'on' : '',
      on: {
        "touchend": function($event) {
          _vm.getCurrentTyle(index + 1)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('h4', [_vm._v("选择套餐")]), _vm._v(" "), _c('div', _vm._l((_vm.comboList), function(item, index) {
    return _c('span', {
      class: _vm.comboCurrent == index + 1 ? 'on' : '',
      on: {
        "touchend": function($event) {
          _vm.getCurrentCombo(index + 1)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": ".25rem",
      "border-bottom": "1px dashed #999",
      "margin": "0 .15rem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ppayment-center"
  }, [_c('div', {
    staticClass: "ppayment-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.introduceList.imgUrl,
      "alt": "图片"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.introduceList.packageVal) + " —"), _c('span', [_vm._v(_vm._s(_vm.introduceList.name))])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.introduceList.introduce) + "\n\t\t\t")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1.3rem"
    }
  })]), _vm._v(" "), _c('myheader', {
    ref: "pheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "ppayment-mark"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("应付")]), _vm._v(" "), _c('i', [_vm._v("¥" + _vm._s(_vm.introduceList.price))])]), _vm._v(" "), _c('li', [_c('p', {
    on: {
      "touchend": _vm.goPayment
    }
  }, [_vm._v("\n\t\t\t\t\t立即支付\n\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPaymentShow),
      expression: "isPaymentShow"
    }],
    staticClass: "payment-alert"
  }, [_c('div', {
    staticClass: "payment-alert-content"
  }, [_c('h4', [_vm._v("线上支付提示")]), _vm._v(" "), _c('p', [_vm._v("支付完成前，请不要关闭此支付验证窗口")]), _vm._v(" "), _c('p', [_vm._v("完成支付后，请根据您的支付的情况点击下面按钮")]), _vm._v(" "), _c('div', [_c('span', {
    on: {
      "click": _vm.getPaymentSuccess
    }
  }, [_vm._v("支付遇到问题")]), _vm._v(" "), _c('span', {
    staticClass: "blue",
    on: {
      "click": _vm.getPaymentSuccess
    }
  }, [_vm._v("支付完成")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ppayment-bottom"
  }, [_c('h4', [_vm._v("支付方式")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "on"
  }, [_vm._v("\n\t\t\t\t\t支付宝\n\t\t\t\t")])])])
}]}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payQuest-wrap"
  }, [_c('cIndex', {
    ref: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "payQuest-content"
  }, [_c('div', {
    staticClass: "payQuest-zf"
  }, [_c('ul', {
    staticClass: "payQuest-left-indent"
  }, [_c('li', [_vm._v("订单号"), _c('span', [_vm._v(_vm._s(_vm.ordernumberpay))])]), _vm._v(" "), _c('li', [_vm._v("检测套餐"), _c('span', [_vm._v(_vm._s(_vm.orderpaypac))])])]), _vm._v(" "), _c('h4', [_vm._v("支付方式")]), _vm._v(" "), _c('ul', {
    staticClass: "payQuest-left-zf"
  }, _vm._l((_vm.imgList), function(item, index) {
    return _c('li', {
      class: _vm.payCurrent == index + 1 ? 'on' : '',
      on: {
        "click": function($event) {
          _vm.getCurrentpay(index + 1)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(item.payimg) + "\n\t\t\t\t\t")])
  })), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payNextInput),
      expression: "payNextInput"
    }],
    staticClass: "payMoneyInput"
  }, [_c('el-form-item', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardnumRoll),
      expression: "cardnumRoll"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入电子卡10位密码"
    },
    domProps: {
      "value": (_vm.cardnumRoll)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardnumRoll = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payMoneyMess),
      expression: "payMoneyMess"
    }],
    staticClass: "payMoneyMess"
  }, [_vm._v("请输入正确的电子卡密码")])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goPayEnter
    }
  }, [_vm._v("确认")])], 1), _vm._v(" "), _c('b'), _vm._v(" "), _c('div', {
    staticClass: "payment-button"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNullMoney),
      expression: "isNullMoney"
    }]
  }, [_vm._v("原价 "), _c('span', {
    staticClass: "oldMoney"
  }, [_vm._v("￥" + _vm._s(_vm.Originalprice))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNullMoney),
      expression: "isNullMoney"
    }]
  }, [_vm._v("支付卡减免 "), _c('span', {
    staticClass: "oldMoney"
  }, [_vm._v("-￥" + _vm._s(_vm.Discount))])]), _vm._v(" "), _c('p', [_vm._v("应付金额 "), _c('span', [_vm._v("￥" + _vm._s(_vm.ordertcprice))])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.goPaymentQuest
    }
  }, [_vm._v("立即支付")])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPaymentShow),
      expression: "isPaymentShow"
    }],
    staticClass: "payment-mark"
  }, [_c('div', {
    staticClass: "mark-content"
  }, [_c('h4', [_vm._v("线上支付提示")]), _vm._v(" "), _c('p', [_vm._v("支付完成前，请不要关闭此支付验证窗口")]), _vm._v(" "), _c('p', [_vm._v("完成支付后，请根据您的支付的情况点击下面按钮")]), _vm._v(" "), _c('div', [_c('span', {
    on: {
      "click": _vm.getPaymentProblem
    }
  }, [_vm._v("支付遇到问题")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "width": ".3rem"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.getPaymentSuccess
    }
  }, [_vm._v("支付完成")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewreport_game"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "viewreport"
  }, [_c('h4', [_vm._v("脑健康体检报告")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(105),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_c('span', [_vm._v(_vm._s(_vm.gameReport.name))]), _vm._v("您好，您已完成本次脑体检测试")]), _vm._v(" "), _c('li', [_vm._v("测试套餐为"), _c('span', [_vm._v(_vm._s(_vm.gameReport.tc))]), _vm._v("," + _vm._s(_vm.gameReport.nengli) + "。")]), _vm._v(" "), _c('li', [_vm._v("您的综合各项脑能力表现"), _c('span', [_vm._v(_vm._s(_vm.gameReport.renzhi))])])]), _vm._v(" "), _c('p', {
    staticClass: "viewreport-buttons"
  }, [_c('a', {
    staticClass: "reportpage-button",
    on: {
      "click": function($event) {
        _vm.reportpage(_vm.gameReport)
      }
    }
  }, [_vm._v("查看完整报告")]), _vm._v(" "), _c('b'), _vm._v(" "), _c('a', {
    staticClass: "reportpage-button button-over",
    on: {
      "click": function($event) {
        _vm.endReportpage()
      }
    }
  }, [_vm._v("结束检测")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gamelist-withe"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "gamelist"
  }, [_c('div', {
    staticClass: "gamelist-container"
  }, [_c('div', {
    staticClass: "user-content"
  }, [_c('h5', [_c('b', [_vm._v(_vm._s(this.usergame))]), _vm._v("，您好：\n\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t点击测试内容，进行您的脑健康测试吧！\n\t\t\t")])]), _vm._v(" "), _c('ul', _vm._l((_vm.gameListInfo), function(item, key, index) {
    return _c('li', {
      staticClass: "gameTitle-button",
      on: {
        "click": function($event) {
          _vm.imgIcon(item.gameUrl, item.id)
        }
      }
    }, [_c('dl', [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": "图片"
      }
    }), _vm._v(" "), (item.status == 1) ? _c('p', {
      staticClass: "game"
    }, [_c('b', [_vm._v("已测试")])]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.brainCapacity))])])
  }))]), _vm._v(" "), (this.gameStatus == 1) ? _c('div', {
    staticClass: "gamelist-footer"
  }, [_c('p', [_vm._v("是否结束本次检测？如果确认结束，请点击确认按钮，完成检测，并可查看检测报告")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": "/viewreport",
      "tag": "span"
    }
  }, [_vm._v("确认")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mybg-wrap"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "mybaogao"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNull),
      expression: "isNull"
    }],
    staticClass: "null-list"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(701),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无检测报告数据")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("造成没有检测报告的原因可能是：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1.未填写正确的身份证号,无法关联查询出检测报告 ; "), _c('router-link', {
    attrs: {
      "to": "/setinfo",
      "tag": "i"
    }
  }, [_vm._v("立即完善")])], 1), _vm._v(" "), _c('li', [_vm._v("2.还没有进行过脑能力检测 ; "), _c('router-link', {
    attrs: {
      "to": {
        path: '/payment',
        query: {
          pID: 1
        }
      },
      "tag": "i"
    }
  }, [_vm._v("立即检测")])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isList),
      expression: "isList"
    }],
    staticClass: "baogao-list"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.getReportList), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(item.username))])]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rezhi))]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cpTime))]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tc))]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', {
      staticClass: "lookReport",
      on: {
        "click": function($event) {
          _vm.lookREport(item.id, item.packageid, item.bid)
        }
      }
    }, [_vm._v("查看")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "el-pagination__total"
  }, [_vm._v("共 "), _c('span', [_vm._v(_vm._s(_vm.getPages))]), _vm._v(" 页")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "total": _vm.getTotal,
      "layout": "prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("确定")])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("检测人")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("检测结果")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("检测时间")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("检测套餐")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', {
    staticClass: "update-right"
  }, [_vm._v("操作")])])
}]}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-wrap"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "height": ".4rem"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "package-sorting"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "touchstart": function($event) {
        _vm.goPpayment(1)
      }
    }
  }, [_c('b', [_vm._v("青年版 (17-44周岁)")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "touchstart": function($event) {
        _vm.goPpayment(2)
      }
    }
  }, [_c('b', [_vm._v("中年版 (45-60周岁)")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "touchstart": function($event) {
        _vm.goPpayment(3)
      }
    }
  }, [_c('b', [_vm._v("老年版 (60周岁以上)")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".59rem"
    }
  })])]), _vm._v(" "), _c('myheader')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v("1111")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v("2222")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v("3333")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v("4444")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])])
}]}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printing-wrap"
  }, [_c('div', {
    staticClass: "printing"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "report-age-sex"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.name))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPrintPageFirst.userSex == 1 ? '女' : '男')
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.userAge))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.createtime))])])]), _vm._v(" "), _c('div', {
    staticClass: "report-mumber"
  }, [_c('p', [_vm._v("报告单号："), _c('b', [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))])])])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(4), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "read-guid"
  }, [_c('p', [_vm._v("脑功能检测从描述静态结构转变为探讨动态脑功能网络，为您的脑功能进行精准分析，提供脑功能图谱及优劣势解读，及专业的个性化提升方案，为您的脑效率和脑健康保驾护航。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "read-guid"
  }, [_c('p', [_vm._v("10-16岁是大脑发育的重要阶段，此阶段孩子正处于从具体运算阶段（具体思维）到形式运算阶段（抽象思维）的关键阶段，脑功能检测可以探讨动态脑功能网络。本报告将根据检测结果，对您孩子的脑功能进行精准分析，提供脑功能图谱的优劣势解读和专业个性化提升方案，为孩子的脑效率和脑健康保驾护航。")])]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "read-prin"
  }, [_c('p', {
    staticClass: "read-prin-bot"
  }, [_vm._v("首先，检测结果受环境和个人状态影响，越安静的环境、越良好的状态，检测结果和您的实际情况越符合。")]), _vm._v(" "), _c('p', [_vm._v("其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "read-prin"
  }, [_c('p', {
    staticClass: "read-prin-bot"
  }, [_vm._v("首先，检测结果受环境、大脑发育状态、个人状态影响。越安静的环境、发育越好的大脑、越良好的状态，检测结果和您孩子的实际情况越符合。值得注意的是，在10-16岁这一阶段，儿童大脑发育较快，且发育过程中不同脑功能发展的先后顺序存在个体差异，因此本报告中呈现的脑功能检测结果和分析，只是您孩子这一段时间内的状态，建议您从发展的角度看待孩子的脑功能状态，不要形成刻板印象。")]), _vm._v(" "), _c('p', [_vm._v("其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您孩子的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。")])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "sore-table-title"
  }, [_vm._v("表 得分与脑功能表现、人数占比对应表")]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "read-table-bot"
  }, [_c('p', [_vm._v("最后，本报告包含了3个检测项目的结果，并提供整合分析和单项分析，可阅读综合检测结果和分项检测结果。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "read-table-bot"
  }, [_c('p', [_vm._v("最后，本报告包含了3个脑功能检测项目的结果，并根据孩子的结果提供综合分析和单项分析。您可按照顺序先阅读综合脑功能结果与解读，再阅读单项脑功能结果与解读。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "toc-mulu"
  }, [_c('div', {
    staticClass: "zonghe-res"
  }, [_c('ul', [(_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin"
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin-two"
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin Single"
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin Single"
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.1执行功能")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1执行功能")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('li', [(_vm.getshuzibijiao.brainEfficiency == '良好' || _vm.getshuzibijiao.brainEfficiency == '中等' || _vm.getshuzibijiao.brainEfficiency == '欠佳') ? _c('p', [_vm._v("2.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '出色') ? _c('p', [_vm._v("2.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势?")]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('li', [(_vm.getshuzibijiao.brainEfficiency == '良好' || _vm.getshuzibijiao.brainEfficiency == '中等' || _vm.getshuzibijiao.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.singleReport.status == 0) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '出色') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.singleReport.status == 0) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势?")]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                            ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.qinjingjiyi.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.2情景记忆")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.qinjingjiyi.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('li', [(_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t2.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t2.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.luojituili.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.2图形推理")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.luojituili.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('li', [(_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("2.2.3提升方案\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '出色') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("2.2.3如何发挥优势？\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                            ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1图形推理")])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('li', [(_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '出色') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.2图形推理")])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('li', [(_vm.luojituili.brainEfficiency == '出色') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("1.2.3如何发挥优势？\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("1.2.3提升方案\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                              ...............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1情景记忆")])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('li', [(_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.1.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.1.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.2情景记忆")])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('li', [(_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0 && _vm.jagongsport.status == 1 && _vm.luojituili.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1加工速度")])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0 && _vm.jagongsport.status == 1 && _vm.luojituili.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('li', [(_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v(":提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                           ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.2加工速度")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('li', [(_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.2.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v(":提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('p', [_vm._v("1.2.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                            ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.jagongsport.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.3加工速度")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.jagongsport.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('li', [(_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('p', [_vm._v("2.3.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('p', [_vm._v("2.3.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .....................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin know-now"
  }, [_vm._m(35)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "interesting"
  }, [_vm._m(36)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin know-now"
  }, [_vm._m(37)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "interesting"
  }, [_vm._m(38)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin last"
  }, [_vm._m(39)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin last"
  }, [_vm._m(40)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('p', {
    staticClass: "score-Introduction"
  }, [_vm._v("\n\t\t\t\t您孩子的综合得分为"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.exceed) + "%")]), _vm._v("的人，处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.health))]), _vm._v("状态，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平。以下是各项脑功能检测结果具体情况:\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('p', {
    staticClass: "score-Introduction"
  }, [_vm._v("\n\t\t\t\t您的综合得分为"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.exceed) + "%")]), _vm._v("的人，处于\n\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.health))]), _vm._v("状态，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平。以下是各项脑功能检测结果具体情况:\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表1 脑功能检测结果表\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "printing-table"
  }, [_c('table', [_vm._m(44), _vm._v(" "), _vm._l((_vm.getscoreList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.gameName))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctNum))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctRate) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.exceed) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainFunction))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainEfficiency))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainHealth))])])
  })], 2)]), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("系数解读:")]), _vm._v(" a. 反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您的该项脑功能处于不健康状态，蓝色字体表示您的该项脑功能处于亚健康状态。\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("系数解读:")]), _vm._v(" a.反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您孩子的该项脑功能处于不健康状态，蓝色字体表示您孩子的该项脑功能处于亚健康状态。\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._m(45), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('p', {
    staticClass: "brain-bot"
  }, [_vm._v("\n\t\t\t\t根据对您的数字比较任务、人物情景任务、数字符号转换任务这三项任务表现的综合分析，您的脑功能模式属于"), _c('span', [_vm._v(_vm._s(this.brainsuggest.brainType))]), _vm._v("。见图1:\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('p', {
    staticClass: "brain-bot"
  }, [_vm._v("\n\t\t\t\t根据对您孩子的数字比较任务、图形推理任务、数字符号转换任务这三项任务表现的综合分析，您孩子的脑功能模式属于"), _c('span', [_vm._v(_vm._s(this.brainsuggest.brainType))]), _vm._v("。见图1:\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "echart-barin"
  }, [_c('div', {
    style: ({
      width: '400px',
      height: '400px'
    }),
    attrs: {
      "id": "radarChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brain-img-bot"
  }, [_vm._v("\n\t\t\t\t图1 脑功能图谱\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(47), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("图谱解读")]), _vm._v(" "), _c('div', {
    staticClass: "map-inter"
  }, [_c('p', [_vm._v(_vm._s(_vm.brainsuggest.unscramble))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.reason))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "Synthesis-mind"
  }, [_c('p', [_vm._v("根据您的综合得分和脑功能图谱综合分析的结果，您的脑功能处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平。")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.advice))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.prewarning))])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "Synthesis-mind"
  }, [_c('p', [_vm._v("根据孩子的综合得分和脑功能图谱综合分析的结果，他／她的综合脑功能处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.advice))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.prewarning))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "Summarized"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t本次检测包含执行功能、逻辑推理和加工速度三项脑功能项目，以下是对您孩子的各项脑功能的测评结果及详细解读。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "Summarized"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t本次检测包含执行功能、加工速度和情景记忆三项脑功能项目，以下是您的各项脑功能的测评结果及详细解读。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('h3', {
    staticClass: "Summarized-Features"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(240),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h3', {
    staticClass: "Summarized-Features"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(277),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('div', {
    staticClass: "Summarized-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e()]), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "Summarized-Synthesis"
  }, [_c('p', [_vm._v("在数字比较任务中，我们设置了4个难度等级，如表"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("。难度等级越高，表明需要您孩子投入的认知资源越多。")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "Summarized-Synthesis"
  }, [_c('p', [_vm._v("在数字比较任务中，我们设置了4个难度等级，如表"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("。难度等级越高，表明需要您投入的认知资源越多。")])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" 数字比较任务难度等级表\n\t\t\t")]), _vm._v(" "), _vm._m(53), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "tableindex"
  }, [_c('p', [_vm._v("通过各项指标计算，您孩子的执行功能得分为"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.agegroup))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.exceed))]), _vm._v("%\n\t\t\t\t的人，孩子的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainHealth))]), _vm._v("，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainEfficiency))]), _vm._v("水平。在正确率和反应时上的具体表现如下:")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "tableindex"
  }, [_c('p', [_vm._v("通过各项指标计算，您的执行功能得分为"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.agegroup))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.exceed))]), _vm._v("%\n\t\t\t\t的人，您的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainHealth))]), _vm._v("，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainEfficiency))]), _vm._v("水平。在正确率和反应时上的具体表现如下:")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('a', {
    staticClass: "page-num carried1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-one"
  }, [_c('p', [_vm._v("（1）反应时上的表现。（图"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-one",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "histogram"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图 "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("各难度等级的反应时")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-two"
  }, [_c('p', [_vm._v("（2）正确率上的表现。（图"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-two",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "hisRight"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图 "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" 各难度等级的正确率")])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(55), _vm._v(" "), _c('a', {
    staticClass: "page-num carried2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nerve"
  }, [(_vm.getshuzibijiao.isboy == 1) ? _c('p', [_vm._v("\n\t\t\t\t大量神经科学和临床研究表明，参与执行功能的脑区，主要包含双侧的背外侧前额叶、前扣带回等脑区，这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络。根据您孩子在数字比较任务中的成绩可推测出孩子的执行功能脑网络状态" + _vm._s(_vm.getshuzibijiao.brainEfficiency) + "，如图\n\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("。\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('p', [_vm._v("\n\t\t\t\t\t大量神经科学和临床研究表明，参与执行功能的脑区，主要包含双侧的背外侧前额叶、前扣带回等脑区，这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络。根据您在数字比较任务中的成绩可推测出您执行控制网络状态" + _vm._s(_vm.getshuzibijiao.brainEfficiency) + "，如图\n\t\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("。\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "brain-figure"
  }, [(_vm.getshuzibijiao.cid == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(259),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.cid == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(260),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.cid == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(261),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.cid == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(262),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "brain-des"
  }, [_vm._v("图"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("执行功能脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "six-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.2六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.2六六脑解读")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-effec"
  }, [_vm._v("执行功能与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "nao-hel"
  }, [_c('p', [_vm._v(_vm._s(_vm.getshuzibijiao.efficiency))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(56), _vm._v(" "), _c('a', {
    staticClass: "page-num carried3"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "carried-out"
  }, [_vm._v("影响执行功能的因素")]), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "carried-sport"
  }, [_c('p', [_vm._v("缺乏运动、睡眠不足、不良生活习惯、脑疲劳或脑损伤等都是导致个体执行功能不好的原因。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了执行功能的下降；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。《美国医学会杂志》曾刊载过一项研究，大脑在25岁发育达到顶峰，30岁后大脑便开始逐渐衰老，每年缩小0.3%，人体新陈代谢也随之逐渐变缓。而长期睡眠不足、用脑习惯不好，学习、工作压力过大，都会导致大脑的疲劳，导致执行功能降低。此外，脑损伤、脑疾病、躯体问题等任何引起大脑皮层功能和结构异常的因素均会引起执行功能的下降。执行功能障碍常见于额叶-皮质下环路受损，执行功能良好的基础是大脑皮层的正常功能，躯体疾病和脑疾病会引起神经活动的异常，损伤大脑结构和功能，造成执行功能的下降。")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "carried-sport"
  }, [_c('p', [_vm._v("缺乏运动、睡眠不足、不良生活习惯、脑疲劳或大脑发育不良等都是导致个体执行功能不好的原因。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了执行功能的下降。Friedman等研究者们对916名双胞胎进行随访研究，结果发现儿童的睡眠问题与青春期的执行控制功能相关，孩子对睡眠的生理需要量多余成人，睡眠不足对孩子执行功能的损害尤为突出，具体表现为计划性差、思维僵化、注意力不足、多动、冲动和情绪多变；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。此外，与执行功能相对应的执行控制网络，在整个儿童和青少年时期都是不断发展的，各种原因引起的神经系统发育不良，尤其是执行控制网络对应大脑皮层功能和结构发育不良，会导致执行功能上的表现较差。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(57), _vm._v(" "), _c('a', {
    staticClass: "page-num carried4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "enhance-pro"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '良好' || _vm.getshuzibijiao.brainEfficiency == '中等' || _vm.getshuzibijiao.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3 提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.getshuzibijiao.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.shuzibijiaoList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(265),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.jagongsport.status == 0 && _vm.singleReport.status == 0) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(264),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(263),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('div', {
    staticClass: "scene-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.1 检测结果")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("本检测项目通过回忆人像与地点、事件的联结记忆考察情景记忆，共进行两次学习-回忆。")]), _vm._v(" "), _c('p', [_vm._v("通过两次记忆核算，您的情景记忆得分为"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.exceed))]), _vm._v("%的人，您的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.brainHealth))]), _vm._v("，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.brainEfficiency))]), _vm._v("水平。两次记忆情况具体如下:")])]), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t情景记忆检测结果\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "Detection-table"
  }, [_c('table', [_vm._m(60), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rowspan-td",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("第一次")]), _vm._v(" "), _c('td', [_vm._v("人像地点联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate1) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate2) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像地点事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate3) + "%")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rowspan-td",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("第二次")]), _vm._v(" "), _c('td', [_vm._v("人像地点联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta4))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate4) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta5))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate5) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像地点事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta6))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate6) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('a', {
    staticClass: "page-num scene1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nerv-show"
  }, [_c('p', [_vm._v("大量神经科学和临床研究表明，参与情景记忆的脑区，主要包含内侧前额叶、后扣带/楔前叶、角回、海马等。根据您在人物情景中的成绩可推测出您情景记忆网络状态"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.brainEfficiency))]), _vm._v("，如图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v("。")])]), _vm._v(" "), _c('div', {
    staticClass: "nao-memory"
  }, [(_vm.qinjingjiyi.cid == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(255),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.cid == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(256),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.cid == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(257),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.cid == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(258),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-memory-bot"
  }, [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" 情景记忆脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "enhance-pro"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.2 检测结果")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-enhance"
  }, [_vm._v("情景记忆与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "memory-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.qinjingjiyi.efficiency))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(62), _vm._v(" "), _c('a', {
    staticClass: "page-num scene2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("影响情景记忆的因素")]), _vm._v(" "), _vm._m(63), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(64), _vm._v(" "), _c('a', {
    staticClass: "page-num scene3"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3 提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.qinjingjiyi.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sanjaio-bot"
  }), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.renwuqingjign), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(65), _vm._v(" "), _c('a', {
    staticClass: "page-num scene4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(244),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(270),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.singleReport.status == 0 && _vm.getshuzibijiao.status == 1) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(269),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(66), _vm._v(" "), _c('div', {
    staticClass: "scene-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.1 检测结果")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Summarized-Synthesis"
  }, [_c('p', [_vm._v("在图形推理任务中，我们设置了5个难度等级。难度等级越高，表明需要您孩子投入的认知资源越多，表\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("。")])]), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("图形推理任务各难度等级测试结果\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "Rating-table-luoji"
  }, [_c('table', [_vm._m(67), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("知识辨别")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right1) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("类同比较")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right2) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("比较推理")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right3) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("系列关系")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right4) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("抽象推理")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right5) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("通过各项指标计算，您孩子的逻辑推理得分为"), _c('span', [_vm._v(_vm._s(_vm.luojituili.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.luojituili.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.luojituili.exceed))]), _vm._v("%的人，孩子的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.luojituili.brainHealth))]), _vm._v("，脑效率处"), _c('span', [_vm._v(_vm._s(_vm.luojituili.brainEfficiency))]), _vm._v("水平。在正确率和反应时的具体表现如下：")])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-one"
  }, [_c('p', [_vm._v("（1）反应时上的表现。（图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-one",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "Graphics"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" 各难度等级的反应时")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-two"
  }, [_c('p', [_vm._v("（2）正确率上的表现。（图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-two",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "reasoning"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" 各难度等级的正确率")])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(69), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nerve"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t逻辑推理涉及的脑网络为额顶整合网络（parieto-frontal integration theory, P-FIT），在个体中，逻辑推理能力涉及脑区为背外侧前额叶、后顶叶、前扣带、脑岛等。这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络、注意网络和外显网络。根据您孩子在图形推理任务中的成绩可推测出孩子的逻辑推理脑网络状态"), _c('span', [_vm._v(_vm._s(_vm.luojituili.brainEfficiency))]), _vm._v("，如图7。\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "brain-figure"
  }, [(_vm.luojituili.cid == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(251),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.luojituili.cid == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(252),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.luojituili.cid == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(253),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.luojituili.cid == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(254),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "brain-des"
  }, [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("7")]) : _vm._e(), _vm._v(" 逻辑推理脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "six-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.2六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.2六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.2 六六脑解读")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-effec"
  }, [_vm._v("逻辑推理与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "nao-hel"
  }, [_c('p', [_vm._v(_vm._s(_vm.luojituili.efficiency))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(70), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic3"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "carried-out"
  }, [_vm._v("影响逻辑推理的因素")]), _vm._v(" "), _vm._m(71), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(72), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3提升方案")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.luojituili.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [(this.tuxintuiliList.length <= 4) ? _c('table', _vm._l((_vm.tuxintuiliList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e(), _vm._v(" "), (this.tuxintuiliList.length > 4) ? _c('table', _vm._l((_vm.luojituiliList1), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(73), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic5"
  })])]) : _vm._e(), _vm._v(" "), (this.tuxintuiliList.length > 4) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.luojituiliList2), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(74), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(266),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('div', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(242),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('div', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(241),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 0) ? _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("加工速度（Processing speed）是指人脑对信息的获取、存储、加工和使用的过程所需的时间。它实质上反应了认知过程的内部心理机制的变化过程。")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 1) ? _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("加工速度（Processing speed）是指个体吸收信息、处理信息、记忆信息和提取信息的快慢。加工速度主要涉及的脑网络是感觉运动网络（包括中央前回和中央后回等脑区）和注意网络（包含后顶叶等脑区）。它实质上反应了认知过程的内部心理机制的变化过程。例如，在接触新事物和学习新知识时，加工速度好的人，能很快适应新事物，找到学习的关键点，给人以“聪明灵敏”的感觉。数字符号转换 （Digital Symbol Substitution）选自韦氏智力测验的分测验（Wechsler, 1958），通过计算数字和特殊符号匹配的反应时和正确率来检测个体的速度，被广泛地用于个体加工速度的评估。该范式被广泛地应用于很多神经心理测验中作为评估个体心理发展水平的重要工具。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv",
    staticStyle: {
      "margin-top": "0.33rem"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e()]), _vm._v(" "), (_vm.jagongsport.isboy == 0) ? _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("通过各项指标计算，您的加工速度得分为"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.jagongsport.exceed))]), _vm._v("%的人，您的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainHealth))]), _vm._v("，脑效率处"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("水平。")]), _vm._v(" "), _c('p', [_vm._v("大量神经科学和临床研究表明，参与加工速度的脑区，主要包含中央前回，中央后回、后顶叶等。根据您在数字符号转换任务中的成绩可推测出您加工速度脑网络"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("。如图6。")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 1) ? _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("在数字符号转换任务中，孩子在一定时间内答对测试题目的个数越多，即孩子反应速度越快，得分越高，在反应时上的具体表现如表1。通过各项指标计算，您的孩子加工速度得分为"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.jagongsport.exceed))]), _vm._v("%的人，孩子的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainHealth))]), _vm._v("，脑效率处"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("水平.")]), _vm._v(" "), _c('p', [_vm._v("大量神经科学和临床研究表明，参与加工速度的脑区，主要包含中央前回、中央后回、后顶叶等。这些脑区以及它们之间的功能和结构连接被科学家们称作感觉运动网络和注意网络。根据您孩子在数字符号转换任务中的成绩可推测出孩子加工速度脑网络状态"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("。如图\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.luojituili.status == 0 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("8")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.getshuzibijiao.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), _vm._v("。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nao-memory"
  }, [(_vm.jagongsport.cid == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(247),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jagongsport.cid == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(248),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jagongsport.cid == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(249),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jagongsport.cid == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(250),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-memory-bot"
  }, [_vm._v("图\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.luojituili.status == 0 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("8")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.getshuzibijiao.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), _vm._v("\n\t\t\t\t加工速度脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(75), _vm._v(" "), _c('a', {
    staticClass: "page-num processing1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "enhance-pro"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.2 六六脑解读")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-enhance"
  }, [_vm._v("加工速度与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "memory-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.jagongsport.efficiency))])]), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("影响加工速度的因素")]), _vm._v(" "), (_vm.jagongsport.isboy == 1) ? _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v("神经脉冲速度、个体精神和情绪状态、知识和兴趣等都会影响个体加工速度。研究表明，人的思维是一种脉冲，它沿着人体的神经纤维运行，速度大约是每小时250公里，但是每一个人的神经系统在传送信号脉冲时，都有速度的差别，这就是为什么有些人反应快，有些人反应慢。同时，反应快慢还与人的精神状态有关系，如果心情愉快，放松，人体处于舒服的状态，自然就反应很快。最近发表在Intensive Care Med的一项研究结果表明，值夜班后，医生的信息处理速度会有所下降，因此，睡眠充足也是保证反应灵敏的重要生理基础。此外，反应的敏捷与否，是可以通过心理调适来改变的。一般来说，人们对于兴趣浓厚的事物，往往容易引起敏捷反应，同样是学习新课程，你感兴趣的科目，学习的效率会更高；同样是一份作业，孩子感兴趣的作业，投入的注意力更集中，做的效率会更高。")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 0) ? _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v("神经脉冲速度（生理因素）、个体精神和情绪状态、知识和兴趣等都会影响个体加工速度。研究表明，人的思维是一种脉冲，它沿着人体的神经纤维运行，速度大约是每小时250公里，但是每一个人的神经系统在传送信号脉冲时，都有速度的差别，这就是为什么有些人反应快，有些人反应慢。同时，反应快慢还与人的精神状态有关系，如果心情愉快，放松，人体处于舒服的状态，自然就反应很快。最近发表在Intensive Care Med的一项研究结果表明，值夜班后，医生的信息处理速度会有所下降，因此，睡眠充足也是保证反应灵敏的重要生理基础。此外，反应的敏捷与否，是可以通过心理调适来改变的。一般来说，人们对于兴趣浓厚的事物，往往容易引起敏捷反应，同样是学习新课程，你感兴趣的科目，学习的效率会更高；同样是一份工作，您感兴趣的工作，投入的注意力更集中，做的效率会更高。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(76), _vm._v(" "), _c('a', {
    staticClass: "page-num processing2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.3 提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.3 如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.3 如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.jagongsport.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sanjaio-bot"
  }), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [(this.jiagongsuduList.length <= 4) ? _c('table', _vm._l((_vm.jiagongsuduList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e(), _vm._v(" "), (this.jiagongsuduList.length > 4) ? _c('table', _vm._l((_vm.jiagongsuduList1), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(77), _vm._v(" "), _c('a', {
    staticClass: "page-num processing3"
  })])]) : _vm._e(), _vm._v(" "), (this.jiagongsuduList.length > 4) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.jiagongsuduList2), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(78), _vm._v(" "), _c('a', {
    staticClass: "page-num processing3"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(274),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(275),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [(_vm.getTalentyou.id == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(246)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getTalentyou.id == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(245)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getTalentyou.id == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(243)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getTalentyou.id == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(273)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "memory-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getTalentyou.userUrl,
      "alt": "图片"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v(_vm._s(_vm.getTalentyou.introduction))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(79), _vm._v(" "), _c('a', {
    staticClass: "page-num know"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(151),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(150),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.isboy == 0) ? _c('div', {
    staticClass: "Follow-up"
  }, [_c('p', [_vm._v("1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价您的脑功能，但科学检测是深入了解脑功能的一扇门。")]), _vm._v(" "), _c('p', [_vm._v("2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使您的结果更真实。")]), _vm._v(" "), _c('p', [_vm._v("3、本检测主要用于评估您的基础脑功能，如果您想用于评价个人能力和职业发展，建议结合职业、性格等测试。此外，越全面的脑功能用于评价个人能力和职业发展的效度越高。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.isboy == 1) ? _c('div', {
    staticClass: "Follow-up"
  }, [_c('p', [_vm._v("1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价孩子的脑功能，但科学检测是深入了解脑功能的一扇门。")]), _vm._v(" "), _c('p', [_vm._v("2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使孩子的结果更真实。")]), _vm._v(" "), _c('p', [_vm._v("3、儿童和青少年时期处于脑功能发展的关键阶段，孩子的脑功能水平会随着年龄的增长而不断变化。因此，本次脑功能检测，只代表孩子现在所处年龄段的水平，建议您持续关注孩子的脑健康和脑效率。")]), _vm._v(" "), _c('p', [_vm._v("4、本检测主要用于评估孩子的基础脑功能，如果您想用于评价孩子的个人能力和学业能力发展，建议结合专业的人格、成就等测试。此外，越全面的脑功能检测，用于评价个人能力和学业能力发展的效度越高。")])]) : _vm._e(), _vm._v(" "), _vm._m(80), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(81), _vm._v(" "), _c('a', {
    staticClass: "page-num postscript"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "closePrint",
    attrs: {
      "href": "javascript:;",
      "title": "打印"
    },
    on: {
      "click": function($event) {
        _vm.print_page()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "closePage",
    attrs: {
      "href": "javascript:;",
      "title": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.print_close()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "moveUp",
    attrs: {
      "href": "javascript:;",
      "title": "回到顶部"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-corver"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(155),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-dete"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(156),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-naologo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(154),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("姓名:")]), _vm._v(" "), _c('li', [_vm._v("性别:")]), _vm._v(" "), _c('li', [_vm._v("年龄:")]), _vm._v(" "), _c('li', [_vm._v("日期:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(152),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(153),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "read-table"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("脑健康")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("人数占比")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[75~100"), _c('span', {
    staticClass: "numjia"
  }, [_vm._v("＋")])]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("出色")]), _vm._v(" "), _c('td', [_vm._v("6%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[60~75)")]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("良好")]), _vm._v(" "), _c('td', [_vm._v("24%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[25-60)")]), _vm._v(" "), _c('td', [_vm._v("亚健康")]), _vm._v(" "), _c('td', [_vm._v("中等")]), _vm._v(" "), _c('td', [_vm._v("64%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[0-25)")]), _vm._v(" "), _c('td', [_vm._v("不健康")]), _vm._v(" "), _c('td', [_vm._v("欠佳")]), _vm._v(" "), _c('td', [_vm._v("6%")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(267),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("1.综合脑功能结果与解读\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..............................................................")]), _vm._v(" "), _c('span', [_vm._v("03")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_vm._v("1.1检测结果全貌\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t ..........................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', [_vm._v("03")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1.2脑功能图谱：分析脑功能特点、优劣势及在生活的表现\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...........................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', [_vm._v("03")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1.3综合建议：解读如何根据脑功能特点扬长避短\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .........................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', [_vm._v("05")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("2.单项脑功能结果与解读\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("...............................................................")]), _vm._v(" "), _c('span', {
    staticClass: "out1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("1.单项脑功能结果与解读\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("...............................................................")]), _vm._v(" "), _c('span', {
    staticClass: "out1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t....................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                                 .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.2六六脑解读:分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.3.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  .....................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.3.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ........................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("3.您知道吗？\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("有趣案例：分析名人某项优势脑功能\n\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t                             ...............................................................................\n\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("2.您知道吗？\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("有趣案例：分析名人某项优势脑功能\n\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t                             ................................................................................\n\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("4.后记\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v(".............................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "lastpostscript"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("3.后记\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..............................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "lastpostscript"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(268),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("检测项目")]), _vm._v(" "), _c('th', [_vm._v("题目数")]), _vm._v(" "), _c('th', [_vm._v("正确数")]), _vm._v(" "), _c('th', [_vm._v("正确率")]), _vm._v(" "), _c('th', [_vm._v("反应时")]), _vm._v(" "), _c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("超过")]), _vm._v(" "), _c('th', [_vm._v("脑功能")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("脑健康")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-map"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(238),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-map"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(237),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Summarized-fea"
  }, [_c('p', [_vm._v("执行功能（executive function）指个体计划、面对诱惑的反应抑制能力、自我调节及监控等能力，执行功能涉及背外侧前额叶、前扣带回等。在日常学习、工作与生活中，做饭、开车、学习及工作规划等都会用到此功能。例如，出去旅游时，我们事先需要在网上或通过朋友介绍来搜集信息做乘车线路、旅游景点先后顺序等各种攻略，但是计划赶不上变化，我们有时会因为各种原因不能按原计划的线路去游玩，这时候就需要灵活调整自己的计划，以选择最有利的出游线路，这种旅游时做计划、灵活调整计划的能力就是我们讲的执行功能。数字比较测评任务\n\t\t\t\t（NumericComparison）是根据任务切换（Task-Switch）范式（Logan et al., 2003）改编的，通过计算从一个任务切换到另一个任务的反应时和正确率来检测个体的执行功能。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Rating-table"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("难度等级")]), _vm._v(" "), _c('th', [_vm._v("条件")]), _vm._v(" "), _c('th', [_vm._v("认知资源")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小匹配，判断大小")]), _vm._v(" "), _c('td', [_vm._v("任务切换，知觉加工")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小匹配，判断多少")]), _vm._v(" "), _c('td', [_vm._v("任务切换，抽象加工")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小不匹配，判断多少")]), _vm._v(" "), _c('td', [_vm._v("任务切换和冲突抑制，知觉加工")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小不匹配，判断大小")]), _vm._v(" "), _c('td', [_vm._v("任务切换和冲突抑制，抽象加工")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("情景记忆（Episodic Memory）是指对个人亲身经历的、发生在一定时间和地点的事件（情景）的记忆。比如，对昨天在公园里会见一位朋友的记忆就是情景记忆。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("总数")]), _vm._v(" "), _c('th', [_vm._v("正确数")]), _vm._v(" "), _c('th', {
    staticClass: "bordernone-right"
  }, [_vm._v("正确率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v("年龄是影响情景记忆的重要因素，记忆能力随着年龄增加出现衰退。近年来利用fMRI研究青年人和老年人情景记忆的差异，认为老年人记忆力的下降在一定程度上是因为对中颞叶的利用下降，记忆衰退和海马区的激活有相关性，Cabeza 的研究小组发现在平均70岁的老年人组海马区在情景提取过程比平均年龄23岁的年轻人激活减低。缺乏运动、睡眠不足、不良生活习惯、脑疲劳或脑损伤等都会导致情景记忆减退。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了记忆力的下降；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。此外，在事物间多进行形象化深度加工，可以有助于情景记忆的增强。例如，记忆一张老爷爷图片、地点：深圳、事件：跳舞这些信息时，可以通过联结一名时髦的老爷爷在繁华的深圳广场上跳广场舞，十分开心。总之，良好的联结记忆策略可以帮助增强情景记忆。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("逻辑推理（Logical Reasoning）是指一种根据周围环境和活动找出其内在的逻辑关系从而推理出符合逻辑关系的结论的能力，逻辑推理涉及背外侧前额叶、后顶叶、前扣带、脑岛等。在日常学习和生活中，经常需要用到此能力。比如，日常生活中一个人做事或说话是否有条理，就需要逻辑推理能力。逻辑推理是智力的一般因素，是与人的问题解决、清晰知觉、思维，发现和利用自己所需信息以及有效地适应社会生活的能力有关。图形推理测评任务（Figure reasoning task）选自著名的瑞文推理测验（Standard Progressive Matrices，SPM），是英国心理学家瑞文(Raven)于1938年设计的一种非文字智力测验，通过计算个体在一定时间内理性判断的正确数来检测个体的逻辑推理能力，被广泛应用于人才选拨、学业成就、智商、大脑发育水平的预测和评估中。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("难度等级")]), _vm._v(" "), _c('th', [_vm._v("认知资源")]), _vm._v(" "), _c('th', [_vm._v("总题目数")]), _vm._v(" "), _c('th', [_vm._v("正确率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carried-sport"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t深刻理解与灵活运用基础知识的能力、想象力、语言能力、情绪状态、脑疲劳或脑损伤、脑发育不良等是逻辑推理的影响因素。逻辑推理需要雄厚的知识积累，这样才能为每一步推理提供充分的依据。例如“为什么乱切的萝卜比切得整齐规则的萝卜更好煮烂、口味更好？”这个问题对一个初中生来说不知道该如何回答，而他的母亲却解释得很好。显然是因为母亲对日常生活知识的理解运用要远远强于中学生。因此，深刻理解与灵活运用基础知识的能力是个体逻辑推理能力的基础。逻辑推理有较强的灵活性和开发性，发挥想象对逻辑推理能力的提高有很大的促进作用。从多角度观察认识事物，全面地认识事物的内部与外部之间、某事物同其他事物之间的多种多样的联系，拓展自己的想象力。语言能力的好坏不仅直接影响想象力的发展，而且逻辑推理依赖于严谨的语言表达和正确的书面表达。因此，重视个体的语言培养，尤其是数学语言和几何语言的培养对个体逻辑推理能力的形成是不可或缺的关键一环。心理学研究揭示，不良的情绪会影响逻辑推理的速度和准确程度。暴怒与痛哭，持续的忧郁、烦恼与恐惧，都会对推理产生不良影响。所以，个体保持平静、轻松的情绪对逻辑推理有着重要的作用。此外，逻辑推理能力高低是由背外侧前额叶皮层、顶叶、前扣带皮层和特定的颞顶叶皮层区域的沟通效率所导致的。脑疲劳或脑损伤、脑发育不良等会引起神经活动的异常，损伤大脑皮层功能和结构，造成逻辑推理能力的不好。\n\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QR-code"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(149),
      "alt": "六六脑官方微信"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "QR-we"
  }, [_vm._v("六六脑官方微信")]), _vm._v(" "), _c('p', {
    staticClass: "QR-we",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("更多脑能力测评请登录"), _c('a', {
    attrs: {
      "target": "_Blank",
      "href": "http://cp.66nao.com"
    }
  }, [_vm._v("cp.66nao.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
}]}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ordermanagement-wrap"
  }, [_c('cIndex', {
    ref: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "ordermanagement"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNull),
      expression: "isShowNull"
    }],
    staticClass: "ordermanagement-null"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(236),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无订单")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowOrderList),
      expression: "isShowOrderList"
    }],
    staticClass: "ordermanagement-list"
  }, [_c('div', {
    staticStyle: {
      "height": ".3rem"
    }
  }), _vm._v(" "), _vm._l((_vm.getOrserList), function(item, index) {
    return _c('div', {
      staticClass: "list-content"
    }, [_c('div', {
      staticClass: "div"
    }, [_c('h4', [_c('b', [_vm._v("套餐类型 : ")]), _c('span', [_vm._v(_vm._s(item.tc))])]), _vm._v(" "), _c('div', [(item.orderstatus == 1) ? _c('em', [_c('b', [_vm._v("订单状态 ：")]), _vm._v("待付款")]) : _vm._e(), _vm._v(" "), (item.orderstatus == 2) ? _c('em', [_c('b', [_vm._v("订单状态 ：")]), _vm._v("已支付")]) : _vm._e(), _vm._v(" "), (item.orderstatus == 3) ? _c('em', [_c('b', [_vm._v("订单状态 ：")]), _vm._v("已取消")]) : _vm._e(), _vm._v(" "), (item.orderstatus == 4) ? _c('em', [_c('b', [_vm._v("订单状态 ：")]), _vm._v("已删除")]) : _vm._e(), _vm._v(" "), (item.orderstatus == '3' && item.cpstatus == '0') ? _c('p', {
      staticClass: "button-cancel",
      on: {
        "click": function($event) {
          _vm.buttonCancel(item.tc)
        }
      }
    }, [_vm._v("再次购买")]) : _vm._e(), _vm._v(" "), (item.orderstatus == '1' && item.cpstatus == '0') ? _c('p', {
      staticClass: "button-noOrder",
      on: {
        "click": function($event) {
          _vm.buttonOrder(item.ordernumber, item.id)
        }
      }
    }, [_vm._v("立即支付")]) : _vm._e(), _vm._v(" "), ((item.orderstatus == '2' || item.orderstatus == '3') && item.cpstatus > '0') ? _c('p', {
      staticClass: "button-order",
      on: {
        "click": function($event) {
          _vm.buttonLook(item.id, item.pid, item.bid)
        }
      }
    }, [_vm._v("查看报告")]) : _vm._e(), _vm._v(" "), (item.orderstatus == '2' && item.cpstatus == '0') ? _c('p', {
      staticClass: "button-evaluation",
      on: {
        "click": function($event) {
          _vm.buttonEvaluation(item.id)
        }
      }
    }, [_vm._v("继续检测")]) : _vm._e()])]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("订单日期 : ")]), _c('span', [_vm._v(_vm._s(item.createtime))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("订单号 : ")]), _c('span', [_vm._v(_vm._s(item.ordernumber))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("检测状态 : ")]), (item.cpstatus == '0') ? _c('span', [_vm._v("未检测")]) : _vm._e(), (item.cpstatus > '0') ? _c('span', [_vm._v("已检测")]) : _vm._e()]), _vm._v(" "), (item.orderstatus == 2 || item.orderstatus == 4) ? _c('li', [_c('b', [_vm._v("支付方式 : ")]), (item.payType == 1) ? _c('span', [_vm._v("支付宝")]) : _vm._e(), (item.payType == '2') ? _c('span', [_vm._v("微信")]) : _vm._e(), _vm._v(" "), (item.payType == '3') ? _c('span', [_vm._v("电子卡")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.orderstatus == 2 && (item.payType == 1 || item.payType == 2)) ? _c('li', [_c('b', [_vm._v("实际支付价格 : ")]), _c('em', [_vm._v("￥" + _vm._s(item.tcprice))])]) : _vm._e(), _vm._v(" "), (item.orderstatus == 1) ? _c('li', [_c('b', [_vm._v("需付款: ")]), _c('em', [_vm._v("￥" + _vm._s(item.tcprice))])]) : _vm._e(), _vm._v(" "), (item.orderstatus == 3) ? _c('li', [_c('b', [_vm._v("需付款: ")]), _c('em', [_vm._v("￥" + _vm._s(item.tcprice))])]) : _vm._e(), _vm._v(" "), (item.orderstatus == 4) ? _c('li', [_c('b', [_vm._v("需付款: ")]), _c('em', [_vm._v("￥" + _vm._s(item.tcprice))])]) : _vm._e(), _vm._v(" "), (item.orderstatus == 2 && item.payType == 3) ? _c('li', [_c('b', [_vm._v("实际支付价格: ")]), _c('em', [_vm._v("￥0.00")])]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "el-pagination__total"
  }, [_vm._v("共 "), _c('span', [_vm._v(_vm._s(_vm.getPages))]), _vm._v(" 页")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "total": _vm.getTotal,
      "layout": "prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("确定")])], 1)], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "myfroms"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-wrap"
  }, [_c('div', {
    attrs: {
      "id": "myfroms"
    }
  }), _vm._v(" "), _c('cIndex', {
    ref: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "payment-left"
  }, [_c('div', {
    staticClass: "combo-option"
  }, [_c('h4', [_vm._v("选择类型")]), _vm._v(" "), _c('ul', _vm._l((_vm.typeList), function(item, index) {
    return _c('li', {
      class: _vm.current == index + 1 ? 'on' : '',
      on: {
        "click": function($event) {
          _vm.getCurrentTyle(index + 1)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('h4', [_vm._v("选择套餐")]), _vm._v(" "), _c('ul', _vm._l((_vm.comboList), function(item, index) {
    return _c('option', {
      class: _vm.comboCurrent == index + 1 ? 'on' : '',
      attrs: {
        "disabled": item.disabled
      },
      on: {
        "click": function($event) {
          _vm.getCurrentCombo(index + 1)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.label) + "\n\t\t\t\t\t")])
  })), _vm._v(" "), _c('h4', [_vm._v("支付方式")]), _vm._v(" "), _c('ul', {
    staticClass: "zfb"
  }, _vm._l((_vm.imgList), function(item, index) {
    return _c('li', {
      class: _vm.payCurrent == index + 1 ? 'on' : '',
      on: {
        "click": function($event) {
          _vm.getCurrentpay(index + 1)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(item.payimg) + "\n\t\t\t\t\t")])
  })), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payInput),
      expression: "payInput"
    }],
    ref: "userInfomationpay",
    staticClass: "payMoneyInput",
    attrs: {
      "model": _vm.userInfomationpay,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cardnumRoll"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfomationpay.cardnumRoll),
      expression: "userInfomationpay.cardnumRoll"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入电子卡10位密码"
    },
    domProps: {
      "value": (_vm.userInfomationpay.cardnumRoll)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfomationpay, "cardnumRoll", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payMoneyMess),
      expression: "payMoneyMess"
    }]
  }, [_vm._v("请输入正确的电子卡密码")])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goPayEnter('userInfomationpay')
      }
    }
  }, [_vm._v("确认")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "payment-button"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNullMoney),
      expression: "isNullMoney"
    }]
  }, [_vm._v("原价 "), _c('span', {
    staticClass: "oldMoney"
  }, [_vm._v("￥" + _vm._s(_vm.Originalprice))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNullMoney),
      expression: "isNullMoney"
    }]
  }, [_vm._v("支付卡减免 "), _c('span', {
    staticClass: "oldMoney"
  }, [_vm._v("-￥" + _vm._s(_vm.Discount))])]), _vm._v(" "), _c('p', [_vm._v("应付金额 "), _c('span', [_vm._v("￥" + _vm._s(_vm.introduceList.price))])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.goPayment('userInfomationpay')
      }
    }
  }, [_vm._v("立即支付")])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-right"
  }, [_c('div', {
    staticClass: "payment-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.introduceList.imgUrl,
      "alt": "图片"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "padding-introduce"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.introduceList.packageVal) + " — ")]), _vm._v(_vm._s(_vm.introduceList.name))]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.introduceList.introduce) + "\n\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPaymentShow),
      expression: "isPaymentShow"
    }],
    staticClass: "payment-mark"
  }, [_c('div', {
    staticClass: "mark-content"
  }, [_c('h4', [_vm._v("线上支付提示")]), _vm._v(" "), _c('p', [_vm._v("支付完成前，请不要关闭此支付验证窗口")]), _vm._v(" "), _c('p', [_vm._v("完成支付后，请根据您的支付的情况点击下面按钮")]), _vm._v(" "), _c('div', [_c('span', {
    on: {
      "click": _vm.getPaymentProblem
    }
  }, [_vm._v("支付遇到问题")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "width": ".3rem"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.getPaymentSuccess
    }
  }, [_vm._v("支付完成")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wechat-wrap"
  }, [_c('cIndex', {
    ref: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "payWeChat-content"
  }, [_c('h2', [_vm._v("正在使用即时交易，30分钟后交易关闭")]), _vm._v(" "), _c('ul', {
    staticClass: "payWechat-transaction"
  }, [_c('li', [_vm._v("脑能力测评订单-"), _c('b', [_vm._v(_vm._s(_vm.payName))]), _vm._v("，共"), _c('b', [_vm._v(_vm._s(_vm.payPprice))]), _vm._v("元 ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_vm._v("订单号："), _c('b', [_vm._v(_vm._s(_vm.ordernumberpay))])])]), _vm._v(" "), _c('p', [_vm._v("应付金额"), _c('span', {
    staticClass: "payMoneyY"
  }, [_vm._v(_vm._s(_vm.payPprice))]), _vm._v("元")]), _vm._v(" "), _c('ul', {
    staticClass: "wechart-money"
  }, [_c('li', [_c('div', {
    staticClass: "wechat-border"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })]), _c('span', {
    staticClass: "wechat-Message"
  }, [_vm._v("请使用微信扫一扫，扫描二维码支付")])]), _vm._v(" "), _vm._m(1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("收款方："), _c('b', [_vm._v("北京智精灵科技有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('img', {
    staticClass: "phonelOGO",
    attrs: {
      "src": __webpack_require__(717)
    }
  })])
}]}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printing-wrap"
  }, [_c('div', {
    staticClass: "printing"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "report-age-sex"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.name))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPrintPageFirst.userSex == 1 ? '女' : '男')
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.userAge))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.createtime))])])]), _vm._v(" "), _c('div', {
    staticClass: "report-mumber"
  }, [_c('p', [_vm._v("报告单号："), _c('b', [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))])])])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "read-guid"
  }, [_c('p', [_vm._v("5-9岁是大脑发育的重要阶段，此阶段孩子正处于从前具体运算阶段（表象思维）到具体运算阶段（出现逻辑思维）的关键阶段，脑功能检测可以探讨动态脑功能网络。本报告将根据检测结果，对您孩子的脑功能进行精准分析，提供\n\t\t\t\t "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('span', [_vm._v("脑功能图谱的优劣势解读和")]) : _vm._e(), _vm._v(" 专业个性化提升方案，为孩子的脑效率和脑健康保驾护航。")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h6', {
    staticClass: "sore-table-title"
  }, [_vm._v("表 得分与脑功能表现、人数占比对应表")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "read-table-bot"
  }, [_c('p', [_vm._v("最后，本报告包含了"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.gameCount))]), _vm._v("个脑功能检测项目的结果，并根据孩子的结果提供"), (_vm.getPrintPageFirst.gameCount == 4) ? _c('span', [_vm._v("综合解读和")]) : _vm._e(), _vm._v("单项脑功能提升方案。\n\t\t\t\t"), (_vm.getPrintPageFirst.gameCount == 4) ? _c('span', [_vm._v("您可按照顺序先阅读综合脑功能结果与解读，再阅读各单项脑功能的提升方案。")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "score-Introduction"
  }, [_vm._v("\n\t\t\t\t本次检测包含" + _vm._s(_vm.getPrintPageFirst.gameNames) + "任务脑功能项目。"), (_vm.getPrintPageFirst.gameCount > 1) ? _c('span', [_vm._v("您孩子脑功能的综合得分为"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.score))]), _vm._v("超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.agegroup) + _vm._s(_vm.getPrintPageFirst.exceed) + "%")]), _vm._v("的人，处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.health))]), _vm._v("状态，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.efficiency))]), _vm._v("水平。")]) : _vm._e(), _vm._v("以下是各项脑功能检测结果具体情况:\n\t\t\t")]), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表1 脑功能检测结果表\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "printing-table"
  }, [_c('table', [_vm._m(10), _vm._v(" "), _vm._l((_vm.getscoreList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.gameName))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctNum))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctRate) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.exceed) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainFunction))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainEfficiency))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainHealth))])])
  })], 2)]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("脑功能解读:")]), _vm._l((_vm.brainVosList), function(item, index) {
    return _c('span', [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "brain-bot"
  }, [_vm._v("\n\t\t\t\t根据对您孩子的数字比较任务、图形推理任务、数字倒背任务、瞬数圆点任务这四项任务表现的综合分析，您孩子的脑功能模式属于"), _c('span', [_vm._v(_vm._s(this.brainsuggest.brainType))]), _vm._v("。见图1:\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "echart-barin"
  }, [_c('div', {
    style: ({
      width: '400px',
      height: '400px'
    }),
    attrs: {
      "id": "radarChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brain-img-bot"
  }, [_vm._v("\n\t\t\t\t图1 脑功能图谱\n\t\t\t")]), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("图谱解读")]), _vm._v(" "), _c('div', {
    staticClass: "map-inter"
  }, [_c('p', [_vm._v(_vm._s(_vm.brainsuggest.unscramble))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.reason))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(79),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(78),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.brainsuggest.advice))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.getshuzibijiao.brainCapacity)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.getshuzibijiao.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [(this.shuzibijiaoList.length <= 3) ? _c('table', _vm._l((_vm.shuzibijiaoList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e(), _vm._v(" "), (this.shuzibijiaoList.length > 3) ? _c('table', _vm._l((_vm.shuzibijiaoList1), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (this.shuzibijiaoList.length > 3 && _vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(79),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(78),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.getshuzibijiao.brainCapacity)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.shuzibijiaoList2), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getluojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(79),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(78),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.getluojituili.brainCapacity)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.getluojituili.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.luojituiliList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getgongzuojiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(79),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(78),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.getgongzuojiyi.brainCapacity)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.getgongzuojiyi.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.gongzuojiyiList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.zhuyiguangdu.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(79),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(78),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.zhuyiguangdu.brainCapacity)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.zhuyiguangdu.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.zhuyiguangduList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(151),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(150),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('a', {
    staticClass: "page-num postscript"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "closePrint",
    attrs: {
      "href": "javascript:;",
      "title": "打印"
    },
    on: {
      "click": function($event) {
        _vm.print_page()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "closePage",
    attrs: {
      "href": "javascript:;",
      "title": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.print_close()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "moveUp",
    attrs: {
      "href": "javascript:;",
      "title": "回到顶部"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-corver"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(155),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-dete"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(156),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-naologo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(154),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("姓名:")]), _vm._v(" "), _c('li', [_vm._v("性别:")]), _vm._v(" "), _c('li', [_vm._v("年龄:")]), _vm._v(" "), _c('li', [_vm._v("日期:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(152),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(153),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "read-prin"
  }, [_c('p', {
    staticClass: "read-prin-bot"
  }, [_vm._v("首先，检测结果受环境、大脑发育状态、个人状态影响。越安静的环境、发育越好的大脑、越良好的状态，检测结果和您孩子的实际情况越符合。值得注意的是，在5-9岁这一阶段，儿童大脑发育较快，且发育过程中不同脑功能发展的先后顺序存在个体差异，因此本报告中呈现的脑功能检测结果和分析，只是您孩子这一段时间内的状态，建议您从发展的角度看待孩子的脑功能状态，不要形成刻板印象。")]), _vm._v(" "), _c('p', [_vm._v("其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您孩子的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "read-table"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("脑健康")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("人数占比")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[75~100"), _c('span', {
    staticClass: "numjia"
  }, [_vm._v("＋")])]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("出色")]), _vm._v(" "), _c('td', [_vm._v("6%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[60~75)")]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("良好")]), _vm._v(" "), _c('td', [_vm._v("24%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[25-60)")]), _vm._v(" "), _c('td', [_vm._v("亚健康")]), _vm._v(" "), _c('td', [_vm._v("中等")]), _vm._v(" "), _c('td', [_vm._v("64%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[0-25)")]), _vm._v(" "), _c('td', [_vm._v("不健康")]), _vm._v(" "), _c('td', [_vm._v("欠佳")]), _vm._v(" "), _c('td', [_vm._v("6%")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(708),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("检测项目")]), _vm._v(" "), _c('th', [_vm._v("题目数")]), _vm._v(" "), _c('th', [_vm._v("正确数")]), _vm._v(" "), _c('th', [_vm._v("正确率")]), _vm._v(" "), _c('th', [_vm._v("反应时")]), _vm._v(" "), _c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("超过")]), _vm._v(" "), _c('th', [_vm._v("脑功能")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("脑健康")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("系数解读:")]), _vm._v(" a. 反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您孩子的该项脑功能处于不健康状态，蓝色字体表示您孩子的该项脑功能处于亚健康状态。\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(709),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Follow-up"
  }, [_c('p', [_vm._v("1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价孩子的脑功能，但科学检测是深入了解脑功能的一扇门。")]), _vm._v(" "), _c('p', [_vm._v("2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使孩子的结果更真实。")]), _vm._v(" "), _c('p', [_vm._v("3、儿童和青少年时期处于脑功能发展的关键阶段，孩子的脑功能水平会随着年龄的增长而不断变化。因此，本次脑功能检测，只代表孩子现在所处年龄段的水平，建议您持续关注孩子的脑健康和脑效率。")]), _vm._v(" "), _c('p', [_vm._v("4、本检测主要用于评估孩子的基础脑功能，如果您想用于评价孩子的个人能力和学业能力发展，建议结合专业的人格、成就等测试。此外，越全面的脑功能检测，用于评价个人能力和学业能力发展的效度越高。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QR-code"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(149),
      "alt": "六六脑官方微信"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "QR-we"
  }, [_vm._v("六六脑官方微信")]), _vm._v(" "), _c('p', {
    staticClass: "QR-we",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("更多脑能力测评请登录"), _c('a', {
    attrs: {
      "target": "_Blank",
      "href": "http://cp.66nao.com"
    }
  }, [_vm._v("cp.66nao.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
}]}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "successfulpayment"
  }, [_c('h3', [_vm._v("支付成功")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(105),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("支付成功！")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', [_vm._v("2s后跳转到 ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/startTest"
    }
  }, [_vm._v("脑检测页面")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('myheader')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": ".6rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-content"
  }, [_c('div', {
    staticClass: "report-title"
  }, [_c('p', {
    staticClass: "regcode"
  }, [_vm._v("检测单号："), _c('span', [_vm._v("15242525263625555")])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(715)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "report-reginfo"
  }, [_c('h4', [_vm._v("\n                    检测基本信息\n                ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("姓名 : "), _c('b', [_vm._v("张天翼")])]), _vm._v(" "), _c('span', [_vm._v("性别 : "), _c('b', [_vm._v("女")])]), _vm._v(" "), _c('span', [_vm._v("年龄 : "), _c('b', [_vm._v("57岁")])])])]), _vm._v(" "), _c('div', {
    staticClass: "results"
  }, [_c('h4', [_vm._v("评估成绩")]), _vm._v(" "), _c('p', {
    staticClass: "first-p"
  }, [_c('span', [_vm._v("脑力值")]), _vm._v(" "), _c('span', [_vm._v("超过同龄人")]), _vm._v(" "), _c('span', [_vm._v("与同龄人相比")])]), _vm._v(" "), _c('p', {
    staticClass: "two-p"
  }, [_c('b', [_vm._v("62/100")]), _vm._v(" "), _c('b', [_vm._v("75%")]), _vm._v(" "), _c('b', [_vm._v("表现良好")])]), _vm._v(" "), _c('div', {
    staticClass: "results-img"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(702)
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(703)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "jiedu-list"
  }, [_c('h4', [_vm._v("成绩解读")]), _vm._v(" "), _c('ul', [_c('li', [_c('h6', [_vm._v("检测基本信息")]), _vm._v(" "), _c('p', [_vm._v("\n                            您的综合能力表现良好，超过了70%的同龄人，请注意扬长避短，发挥优势，通过适当的认知训练保持优势的能力，提升弥补能力，保持大脑健康。\n                        ")])]), _vm._v(" "), _c('li', [_c('h6', [_vm._v("强弱项分析")]), _vm._v(" "), _c('p', [_vm._v("\n                            您的综合能力表现良好，超过了70%的同龄人，请注意扬长避短，发挥优势，通过适当的认知训练保持优势的能力，提升弥补能力，保持大脑健康。\n                        ")])]), _vm._v(" "), _c('li', [_c('h6', [_vm._v("专家建议")]), _vm._v(" "), _c('p', [_vm._v("\n                            您的综合能力表现良好，超过了70%的同龄人，请注意扬长避短，发挥优势，通过适当的认知训练保持优势的能力，提升弥补能力，保持大脑健康。\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "report-footer"
  }, [_c('p', [_vm._v("检测日期 : "), _c('span', [_vm._v("2017年3月21日 ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    六六脑 脑能力检测系统\n                ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".7rem"
    }
  })])
}]}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pmybaogao-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBaoGao),
      expression: "isBaoGao"
    }],
    staticClass: "baoGaoList"
  }, [_c('div', {
    staticStyle: {
      "height": ".4rem"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".56rem"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNull),
      expression: "isNull"
    }],
    staticClass: "mybaogao-null"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(714)
    }
  }), _vm._v(" "), _c('h5', [_vm._v("\n\t\t\t如果想查询报告，请先完善信息\n\t\t")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('myheader')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-content"
  }, [_c('div', [_c('p', [_c('b', [_vm._v("检测人 : ")]), _vm._v(" "), _c('span', [_vm._v("陆大鸟")])]), _vm._v(" "), _c('p', [_c('i', [_vm._v("查看")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("检测结果 : ")]), _vm._v(" "), _c('span', [_vm._v("良好")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("检测时间 : ")]), _vm._v(" "), _c('span', [_vm._v("2017-05-25")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("检测套餐 : ")]), _vm._v(" "), _c('span', [_vm._v("青年版-VIP套餐")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("因涉及个人数据隐私")]), _vm._v(" "), _c('span', [_vm._v("查询数据前请务必注册信息或进行微信绑定")])])
}]}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapindex"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setinfo-wrap"
  }, [_c('cIndex', {
    ref: "header",
    attrs: {
      "name": _vm.userName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setInfo-content"
  }, [_c('div', {
    staticClass: "myfrom"
  }, [_c('h3', [_vm._v("基本信息")]), _vm._v(" "), _c('el-form', {
    ref: "userInfomation",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.userInfomation,
      "rules": _vm.rules,
      "label-width": "90px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名：",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 10,
      "value": _vm.userInfomation.userName
    },
    model: {
      value: (_vm.userInfomation.userName),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userName", $$v)
      },
      expression: "userInfomation.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.userSex),
      callback: function($$v) {
        _vm.userSex = $$v
      },
      expression: "userSex"
    }
  }, _vm._l((_vm.userSexList), function(item, index, key) {
    return _c('el-radio-button', {
      key: key,
      attrs: {
        "label": key,
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号：",
      "prop": "userCard"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 18,
      "value": _vm.userInfomation.userCard
    },
    on: {
      "change": _vm.regCarNum
    },
    model: {
      value: (_vm.userInfomation.userCard),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userCard", $$v)
      },
      expression: "userInfomation.userCard"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出生年月：",
      "prop": "userBirthday"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "placeholder": "选择日期",
      "default-value": "1990",
      "picker-options": _vm.pickerOptions0
    },
    on: {
      "change": _vm.dataFormt
    },
    model: {
      value: (_vm.userInfomation.userBirthday),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userBirthday", $$v)
      },
      expression: "userInfomation.userBirthday"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('p', [_vm._v("温馨提示：身份证信息将帮助您可以对比查看多年检测报告"), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(272),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "行业",
      "prop": "userJobs"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.getclassification(_vm.userInfomation.userJobs)
      }
    },
    model: {
      value: (_vm.userInfomation.userJobs),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userJobs", $$v)
      },
      expression: "userInfomation.userJobs"
    }
  }, _vm._l((_vm.loadUserProfessional), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类：",
      "prop": "classification"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.classification),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "classification", $$v)
      },
      expression: "userInfomation.classification"
    }
  }, _vm._l((_vm.loadclassificationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现居住地",
      "prop": "userLives"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.userLives),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userLives", $$v)
      },
      expression: "userInfomation.userLives"
    }
  }, _vm._l((_vm.loadUserLiveList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教育程度",
      "prop": "userEducation"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userInfomation.userEducation),
      callback: function($$v) {
        _vm.$set(_vm.userInfomation, "userEducation", $$v)
      },
      expression: "userInfomation.userEducation"
    }
  }, _vm._l((_vm.loadUserEducationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "healthList-wrap",
    attrs: {
      "label": "健康状况"
    }
  }, [_c('div', {
    staticClass: "healthList",
    attrs: {
      "id": "content"
    }
  }, _vm._l((_vm.loadUserHealthList), function(item, index) {
    return _c('span', {
      attrs: {
        "data-num": index + 1
      },
      on: {
        "click": function($event) {
          _vm.check(index, $event.target)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('input', {
    staticClass: "isnone",
    attrs: {
      "type": "text",
      "id": "inp"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "button-content"
  }, [_c('el-button', {
    staticClass: "buttons",
    on: {
      "click": function($event) {
        _vm.saveInfo('userInfomation')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-conten"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, _vm._l((_vm.loginList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.setLoginOrRegister(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDrop),
      expression: "isDrop"
    }],
    staticClass: "dropdowns"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('h4', [_c('span', [_vm._v("欢迎你")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.name ? _vm.name : _vm.userName)
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": "/setinfo",
      "tag": "p"
    }
  }, [_vm._v("个人设置")])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": "/ordermanagement",
      "tag": "p"
    }
  }, [_vm._v("订单管理")])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": "/setpassword",
      "tag": "p"
    }
  }, [_vm._v("修改密码")])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('p', {
    on: {
      "click": _vm.setExit
    }
  }, [_vm._v("退出系统")])])], 1)], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "router-nav"
  }, [_c('ul', [_c('li', [_c('p', {
    class: _vm.ind == 0 ? 'router-link-exact-active' : '',
    on: {
      "click": function($event) {
        _vm.changeIndex(0)
      }
    }
  }, [_vm._v("在线检测")])]), _vm._v(" "), _c('li', [_c('p', {
    class: _vm.ind == 1 ? 'router-link-exact-active' : '',
    on: {
      "click": function($event) {
        _vm.changeIndex(1)
      }
    }
  }, [_vm._v("我的报告")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMark),
      expression: "isMark"
    }],
    staticClass: "mark"
  }, [_c('div', {
    staticClass: "mark-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.markList.title)), _c('img', {
    staticClass: "guanbi",
    attrs: {
      "src": __webpack_require__(148),
      "alt": ""
    },
    on: {
      "click": _vm.shutDown
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "myfrom"
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginFrorm),
      expression: "isLoginFrorm"
    }],
    ref: "ruleLogin",
    attrs: {
      "model": _vm.ruleLogin,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 11,
      "placeholder": "请输入手机号",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.getOperation('ruleLogin')
      }
    },
    model: {
      value: (_vm.ruleLogin.userTel),
      callback: function($$v) {
        _vm.$set(_vm.ruleLogin, "userTel", _vm._n($$v))
      },
      expression: "ruleLogin.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "userPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "off",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.getOperation('ruleLogin')
      }
    },
    model: {
      value: (_vm.ruleLogin.userPwd),
      callback: function($$v) {
        _vm.$set(_vm.ruleLogin, "userPwd", $$v)
      },
      expression: "ruleLogin.userPwd"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "forgotPassword",
    on: {
      "click": function($event) {
        _vm.setLoginOrRegister(2)
      }
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('el-button', {
    staticClass: "myfrom-buttons",
    on: {
      "click": function($event) {
        _vm.getOperation('ruleLogin')
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRegForm),
      expression: "isRegForm"
    }],
    ref: "registered",
    attrs: {
      "label-position": "top",
      "model": _vm.registered,
      "rules": _vm.registeredRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 11,
      "placeholder": "请输入手机号"
    },
    on: {
      "blur": _vm.regPhone
    },
    model: {
      value: (_vm.registered.userTel),
      callback: function($$v) {
        _vm.$set(_vm.registered, "userTel", _vm._n($$v))
      },
      expression: "registered.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "zcuserPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "off",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.registered.zcuserPwd),
      callback: function($$v) {
        _vm.$set(_vm.registered, "zcuserPwd", $$v)
      },
      expression: "registered.zcuserPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "reg-text",
    attrs: {
      "label": "验证码",
      "prop": "sendSecond"
    }
  }, [_c('el-input', {
    staticClass: "regCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": 6,
      "auto-complete": "off",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.registered.sendSecond),
      callback: function($$v) {
        _vm.$set(_vm.registered, "sendSecond", $$v)
      },
      expression: "registered.sendSecond"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "but",
    attrs: {
      "disabled": _vm.dis
    },
    on: {
      "click": _vm.getRegCode
    }
  }, [_vm._v("获取验证码"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecond),
      expression: "isSecond"
    }]
  }, [_vm._v(" " + _vm._s(_vm.secondText) + "s")])])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "myfrom-buttons",
    on: {
      "click": function($event) {
        _vm.getOperation('registered')
      }
    }
  }, [_vm._v("注册")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isResetPassword),
      expression: "isResetPassword"
    }],
    ref: "setNewPassword",
    attrs: {
      "label-position": "top",
      "model": _vm.setNewPassword,
      "rules": _vm.newPas
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 11,
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    on: {
      "blur": _vm.setregPhone
    },
    model: {
      value: (_vm.setNewPassword.userTel),
      callback: function($$v) {
        _vm.$set(_vm.setNewPassword, "userTel", _vm._n($$v))
      },
      expression: "setNewPassword.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "reg-text",
    attrs: {
      "label": "验证码",
      "prop": "sendSecond"
    }
  }, [_c('el-input', {
    staticClass: "regCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": 6
    },
    model: {
      value: (_vm.setNewPassword.sendSecond),
      callback: function($$v) {
        _vm.$set(_vm.setNewPassword, "sendSecond", $$v)
      },
      expression: "setNewPassword.sendSecond"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "but",
    attrs: {
      "disabled": _vm.disab
    },
    on: {
      "click": _vm.getRegNumber
    }
  }, [_vm._v("获取验证码"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecondT),
      expression: "isSecondT"
    }]
  }, [_vm._v(" " + _vm._s(_vm.secondTextT) + "s")])])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "myfrom-buttons",
    on: {
      "click": function($event) {
        _vm.getOperation('setNewPassword')
      }
    }
  }, [_vm._v("下一步")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNewPassword),
      expression: "isNewPassword"
    }],
    ref: "ruleForm2",
    attrs: {
      "label-position": "top",
      "model": _vm.ruleForm2,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "pass", $$v)
      },
      expression: "ruleForm2.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请确认登录密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "myfrom-buttons",
    on: {
      "click": function($event) {
        _vm.getOperation('ruleForm2')
      }
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginFrorm),
      expression: "isLoginFrorm"
    }],
    staticClass: "myfrom-footer",
    on: {
      "click": function($event) {
        _vm.setLoginOrRegister(1)
      }
    }
  }, [_vm._v("立即注册")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginBack),
      expression: "isLoginBack"
    }],
    staticClass: "myfrom-footer",
    on: {
      "click": function($event) {
        _vm.setLoginOrRegister(0)
      }
    }
  }, [_vm._v("返回登录"), _c('img', {
    attrs: {
      "src": __webpack_require__(704),
      "alt": ""
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNull),
      expression: "isNull"
    }],
    staticClass: "nullMark"
  }, [_c('div', {
    staticClass: "null-content"
  }, [_c('h3', [_vm._v("提示"), _c('img', {
    staticClass: "guanbi",
    attrs: {
      "src": __webpack_require__(148),
      "alt": ""
    },
    on: {
      "click": _vm.shutDown
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(105),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("登录脑健康检测系统，健康信息立即掌握")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("立即登录")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('img', {
    attrs: {
      "src": __webpack_require__(700),
      "alt": ""
    }
  }), _vm._v("脑功能检测训练系统")])
}]}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printing-wrap"
  }, [_c('div', {
    staticClass: "printing"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "report-age-sex"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.name))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPrintPageFirst.userSex == 1 ? '女' : '男')
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.userAge))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.createtime))])])]), _vm._v(" "), _c('div', {
    staticClass: "report-mumber"
  }, [_c('p', [_vm._v("报告单号："), _c('b', [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))])])])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(4), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "read-guid"
  }, [_c('p', [_vm._v("脑功能检测从描述静态结构转变为探讨动态脑功能网络，为您的脑功能进行精准分析，提供脑功能图谱及优劣势解读，及专业的个性化提升方案，为您的脑效率和脑健康保驾护航。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "read-guid"
  }, [_c('p', [_vm._v("10-16岁是大脑发育的重要阶段，此阶段孩子正处于从具体运算阶段（具体思维）到形式运算阶段（抽象思维）的关键阶段，脑功能检测可以探讨动态脑功能网络。本报告将根据检测结果，对您孩子的脑功能进行精准分析，提供脑功能图谱的优劣势解读和专业个性化提升方案，为孩子的脑效率和脑健康保驾护航。")])]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "read-prin"
  }, [_c('p', {
    staticClass: "read-prin-bot"
  }, [_vm._v("首先，检测结果受环境和个人状态影响，越安静的环境、越良好的状态，检测结果和您的实际情况越符合。")]), _vm._v(" "), _c('p', [_vm._v("其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "read-prin"
  }, [_c('p', {
    staticClass: "read-prin-bot"
  }, [_vm._v("首先，检测结果受环境、大脑发育状态、个人状态影响。越安静的环境、发育越好的大脑、越良好的状态，检测结果和您孩子的实际情况越符合。值得注意的是，在10-16岁这一阶段，儿童大脑发育较快，且发育过程中不同脑功能发展的先后顺序存在个体差异，因此本报告中呈现的脑功能检测结果和分析，只是您孩子这一段时间内的状态，建议您从发展的角度看待孩子的脑功能状态，不要形成刻板印象。")]), _vm._v(" "), _c('p', [_vm._v("其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您孩子的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。")])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "sore-table-title"
  }, [_vm._v("表 得分与脑功能表现、人数占比对应表")]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "read-table-bot"
  }, [_c('p', [_vm._v("最后，本报告包含了3个检测项目的结果，并提供整合分析和单项分析，可阅读综合检测结果和分项检测结果。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "read-table-bot"
  }, [_c('p', [_vm._v("最后，本报告包含了3个脑功能检测项目的结果，并根据孩子的结果提供综合分析和单项分析。您可按照顺序先阅读综合脑功能结果与解读，再阅读单项脑功能结果与解读。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "toc-mulu"
  }, [_c('div', {
    staticClass: "zonghe-res"
  }, [_c('ul', [(_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin"
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin-two"
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin Single"
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin Single"
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.1执行功能")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1执行功能")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('li', [(_vm.getshuzibijiao.brainEfficiency == '良好' || _vm.getshuzibijiao.brainEfficiency == '中等' || _vm.getshuzibijiao.brainEfficiency == '欠佳') ? _c('p', [_vm._v("2.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '出色') ? _c('p', [_vm._v("2.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势?")]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('li', [(_vm.getshuzibijiao.brainEfficiency == '良好' || _vm.getshuzibijiao.brainEfficiency == '中等' || _vm.getshuzibijiao.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.singleReport.status == 0) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '出色') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.singleReport.status == 0) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势?")]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                            ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.qinjingjiyi.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.2情景记忆")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.qinjingjiyi.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('li', [(_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t2.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t2.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.luojituili.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.2图形推理")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.luojituili.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('li', [(_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("2.2.3提升方案\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '出色') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("2.2.3如何发挥优势？\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                            ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1图形推理")])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('li', [(_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '出色') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.2图形推理")])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('li', [(_vm.luojituili.brainEfficiency == '出色') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("1.2.3如何发挥优势？\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("1.2.3提升方案\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                              ...............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1情景记忆")])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('li', [(_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.1.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.1.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.2情景记忆")])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('li', [(_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0 && _vm.jagongsport.status == 1 && _vm.luojituili.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1加工速度")])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0 && _vm.jagongsport.status == 1 && _vm.luojituili.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('li', [(_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v(":提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                           ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.2加工速度")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('li', [(_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.2.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v(":提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('p', [_vm._v("1.2.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                            ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.jagongsport.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.3加工速度")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.jagongsport.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('li', [(_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('p', [_vm._v("2.3.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('p', [_vm._v("2.3.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .....................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin know-now"
  }, [_vm._m(35)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "interesting"
  }, [_vm._m(36)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin know-now"
  }, [_vm._m(37)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "interesting"
  }, [_vm._m(38)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin last"
  }, [_vm._m(39)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin last"
  }, [_vm._m(40)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('p', {
    staticClass: "score-Introduction"
  }, [_vm._v("\n\t\t\t\t您孩子的综合得分为"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.exceed) + "%")]), _vm._v("的人，处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.health))]), _vm._v("状态，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平。以下是各项脑功能检测结果具体情况:\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('p', {
    staticClass: "score-Introduction"
  }, [_vm._v("\n\t\t\t\t您的综合得分为"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.exceed) + "%")]), _vm._v("的人，处于\n\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.health))]), _vm._v("状态，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平。以下是各项脑功能检测结果具体情况:\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表1 脑功能检测结果表\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "printing-table"
  }, [_c('table', [_vm._m(44), _vm._v(" "), _vm._l((_vm.getscoreList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.gameName))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctNum))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctRate) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.exceed) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainFunction))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainEfficiency))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainHealth))])])
  })], 2)]), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("系数解读:")]), _vm._v(" a. 反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您的该项脑功能处于不健康状态，蓝色字体表示您的该项脑功能处于亚健康状态。\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("系数解读:")]), _vm._v(" a.反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您孩子的该项脑功能处于不健康状态，蓝色字体表示您孩子的该项脑功能处于亚健康状态。\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._m(45), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('p', {
    staticClass: "brain-bot"
  }, [_vm._v("\n\t\t\t\t根据对您的数字比较任务、人物情景任务、数字符号转换任务这三项任务表现的综合分析，您的脑功能模式属于"), _c('span', [_vm._v(_vm._s(this.brainsuggest.brainType))]), _vm._v("。见图1:\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('p', {
    staticClass: "brain-bot"
  }, [_vm._v("\n\t\t\t\t根据对您孩子的数字比较任务、图形推理任务、数字符号转换任务这三项任务表现的综合分析，您孩子的脑功能模式属于"), _c('span', [_vm._v(_vm._s(this.brainsuggest.brainType))]), _vm._v("。见图1:\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "echart-barin"
  }, [_c('div', {
    style: ({
      width: '400px',
      height: '400px'
    }),
    attrs: {
      "id": "radarChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brain-img-bot"
  }, [_vm._v("\n\t\t\t\t图1 脑功能图谱\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(47), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("图谱解读")]), _vm._v(" "), _c('div', {
    staticClass: "map-inter"
  }, [_c('p', [_vm._v(_vm._s(_vm.brainsuggest.unscramble))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.reason))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "Synthesis-mind"
  }, [_c('p', [_vm._v("根据您的综合得分和脑功能图谱综合分析的结果，您的脑功能处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平。")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.advice))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.prewarning))])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "Synthesis-mind"
  }, [_c('p', [_vm._v("根据孩子的综合得分和脑功能图谱综合分析的结果，他／她的综合脑功能处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.advice))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.prewarning))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "Summarized"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t本次检测包含执行功能、逻辑推理和加工速度三项脑功能项目，以下是对您孩子的各项脑功能的测评结果及详细解读。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "Summarized"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t本次检测包含执行功能、加工速度和情景记忆三项脑功能项目，以下是您的各项脑功能的测评结果及详细解读。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('h3', {
    staticClass: "Summarized-Features"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(240),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h3', {
    staticClass: "Summarized-Features"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(277),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('div', {
    staticClass: "Summarized-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e()]), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "Summarized-Synthesis"
  }, [_c('p', [_vm._v("在数字比较任务中，我们设置了4个难度等级，如表"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("。难度等级越高，表明需要您孩子投入的认知资源越多。")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "Summarized-Synthesis"
  }, [_c('p', [_vm._v("在数字比较任务中，我们设置了4个难度等级，如表"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("。难度等级越高，表明需要您投入的认知资源越多。")])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" 数字比较任务难度等级表\n\t\t\t")]), _vm._v(" "), _vm._m(53), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "tableindex"
  }, [_c('p', [_vm._v("通过各项指标计算，您孩子的执行功能得分为"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.agegroup))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.exceed))]), _vm._v("%\n\t\t\t\t的人，孩子的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainHealth))]), _vm._v("，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainEfficiency))]), _vm._v("水平。在正确率和反应时上的具体表现如下:")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "tableindex"
  }, [_c('p', [_vm._v("通过各项指标计算，您的执行功能得分为"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.agegroup))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.exceed))]), _vm._v("%\n\t\t\t\t的人，您的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainHealth))]), _vm._v("，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainEfficiency))]), _vm._v("水平。在正确率和反应时上的具体表现如下:")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('a', {
    staticClass: "page-num carried1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-one"
  }, [_c('p', [_vm._v("（1）反应时上的表现。（图"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-one",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "histogram"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图 "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("各难度等级的反应时")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-two"
  }, [_c('p', [_vm._v("（2）正确率上的表现。（图"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-two",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "hisRight"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图 "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" 各难度等级的正确率")])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(55), _vm._v(" "), _c('a', {
    staticClass: "page-num carried2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nerve"
  }, [(_vm.getshuzibijiao.isboy == 1) ? _c('p', [_vm._v("\n\t\t\t\t大量神经科学和临床研究表明，参与执行功能的脑区，主要包含双侧的背外侧前额叶、前扣带回等脑区，这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络。根据您孩子在数字比较任务中的成绩可推测出孩子的执行功能脑网络状态" + _vm._s(_vm.getshuzibijiao.brainEfficiency) + "，如图\n\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("。\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('p', [_vm._v("\n\t\t\t\t\t大量神经科学和临床研究表明，参与执行功能的脑区，主要包含双侧的背外侧前额叶、前扣带回等脑区，这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络。根据您在数字比较任务中的成绩可推测出您执行控制网络状态" + _vm._s(_vm.getshuzibijiao.brainEfficiency) + "，如图\n\t\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("。\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "brain-figure"
  }, [(_vm.getshuzibijiao.cid == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(259),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.cid == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(260),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.cid == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(261),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.cid == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(262),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "brain-des"
  }, [_vm._v("图"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("执行功能脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "six-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.2六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.2六六脑解读")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-effec"
  }, [_vm._v("执行功能与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "nao-hel"
  }, [_c('p', [_vm._v(_vm._s(_vm.getshuzibijiao.efficiency))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(56), _vm._v(" "), _c('a', {
    staticClass: "page-num carried3"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "carried-out"
  }, [_vm._v("影响执行功能的因素")]), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "carried-sport"
  }, [_c('p', [_vm._v("缺乏运动、睡眠不足、不良生活习惯、脑疲劳或脑损伤等都是导致个体执行功能不好的原因。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了执行功能的下降；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。《美国医学会杂志》曾刊载过一项研究，大脑在25岁发育达到顶峰，30岁后大脑便开始逐渐衰老，每年缩小0.3%，人体新陈代谢也随之逐渐变缓。而长期睡眠不足、用脑习惯不好，学习、工作压力过大，都会导致大脑的疲劳，导致执行功能降低。此外，脑损伤、脑疾病、躯体问题等任何引起大脑皮层功能和结构异常的因素均会引起执行功能的下降。执行功能障碍常见于额叶-皮质下环路受损，执行功能良好的基础是大脑皮层的正常功能，躯体疾病和脑疾病会引起神经活动的异常，损伤大脑结构和功能，造成执行功能的下降。")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "carried-sport"
  }, [_c('p', [_vm._v("缺乏运动、睡眠不足、不良生活习惯、脑疲劳或大脑发育不良等都是导致个体执行功能不好的原因。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了执行功能的下降。Friedman等研究者们对916名双胞胎进行随访研究，结果发现儿童的睡眠问题与青春期的执行控制功能相关，孩子对睡眠的生理需要量多余成人，睡眠不足对孩子执行功能的损害尤为突出，具体表现为计划性差、思维僵化、注意力不足、多动、冲动和情绪多变；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。此外，与执行功能相对应的执行控制网络，在整个儿童和青少年时期都是不断发展的，各种原因引起的神经系统发育不良，尤其是执行控制网络对应大脑皮层功能和结构发育不良，会导致执行功能上的表现较差。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(57), _vm._v(" "), _c('a', {
    staticClass: "page-num carried4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "enhance-pro"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '良好' || _vm.getshuzibijiao.brainEfficiency == '中等' || _vm.getshuzibijiao.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3 提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.getshuzibijiao.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.shuzibijiaoList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(265),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.jagongsport.status == 0 && _vm.singleReport.status == 0) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(264),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(263),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('div', {
    staticClass: "scene-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.1 检测结果")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("本检测项目通过回忆人像与地点、事件的联结记忆考察情景记忆，共进行两次学习-回忆。")]), _vm._v(" "), _c('p', [_vm._v("通过两次记忆核算，您的情景记忆得分为"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.exceed))]), _vm._v("%的人，您的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.brainHealth))]), _vm._v("，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.brainEfficiency))]), _vm._v("水平。两次记忆情况具体如下:")])]), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t情景记忆检测结果\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "Detection-table"
  }, [_c('table', [_vm._m(60), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rowspan-td",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("第一次")]), _vm._v(" "), _c('td', [_vm._v("人像地点联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate1) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate2) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像地点事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate3) + "%")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rowspan-td",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("第二次")]), _vm._v(" "), _c('td', [_vm._v("人像地点联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta4))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate4) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta5))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate5) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像地点事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta6))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate6) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('a', {
    staticClass: "page-num scene1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nerv-show"
  }, [_c('p', [_vm._v("大量神经科学和临床研究表明，参与情景记忆的脑区，主要包含内侧前额叶、后扣带/楔前叶、角回、海马等。根据您在人物情景中的成绩可推测出您情景记忆网络状态"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.brainEfficiency))]), _vm._v("，如图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v("。")])]), _vm._v(" "), _c('div', {
    staticClass: "nao-memory"
  }, [(_vm.qinjingjiyi.cid == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(255),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.cid == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(256),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.cid == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(257),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.cid == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(258),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-memory-bot"
  }, [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" 情景记忆脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "enhance-pro"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.2 检测结果")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-enhance"
  }, [_vm._v("情景记忆与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "memory-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.qinjingjiyi.efficiency))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(62), _vm._v(" "), _c('a', {
    staticClass: "page-num scene2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("影响情景记忆的因素")]), _vm._v(" "), _vm._m(63), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(64), _vm._v(" "), _c('a', {
    staticClass: "page-num scene3"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3 提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.qinjingjiyi.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sanjaio-bot"
  }), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.renwuqingjign), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(65), _vm._v(" "), _c('a', {
    staticClass: "page-num scene4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(244),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(270),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.singleReport.status == 0 && _vm.getshuzibijiao.status == 1) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(269),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(66), _vm._v(" "), _c('div', {
    staticClass: "scene-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.1 检测结果")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Summarized-Synthesis"
  }, [_c('p', [_vm._v("在图形推理任务中，我们设置了5个难度等级。难度等级越高，表明需要您孩子投入的认知资源越多，表\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("。")])]), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("图形推理任务各难度等级测试结果\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "Rating-table-luoji"
  }, [_c('table', [_vm._m(67), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("知识辨别")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right1) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("类同比较")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right2) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("比较推理")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right3) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("系列关系")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right4) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("抽象推理")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right5) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("通过各项指标计算，您孩子的逻辑推理得分为"), _c('span', [_vm._v(_vm._s(_vm.luojituili.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.luojituili.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.luojituili.exceed))]), _vm._v("%的人，孩子的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.luojituili.brainHealth))]), _vm._v("，脑效率处"), _c('span', [_vm._v(_vm._s(_vm.luojituili.brainEfficiency))]), _vm._v("水平。在正确率和反应时的具体表现如下：")])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-one"
  }, [_c('p', [_vm._v("（1）反应时上的表现。（图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-one",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "Graphics"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" 各难度等级的反应时")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-two"
  }, [_c('p', [_vm._v("（2）正确率上的表现。（图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-two",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "reasoning"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" 各难度等级的正确率")])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(69), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nerve"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t逻辑推理涉及的脑网络为额顶整合网络（parieto-frontal integration theory, P-FIT），在个体中，逻辑推理能力涉及脑区为背外侧前额叶、后顶叶、前扣带、脑岛等。这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络、注意网络和外显网络。根据您孩子在图形推理任务中的成绩可推测出孩子的逻辑推理脑网络状态"), _c('span', [_vm._v(_vm._s(_vm.luojituili.brainEfficiency))]), _vm._v("，如图7。\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "brain-figure"
  }, [(_vm.luojituili.cid == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(251),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.luojituili.cid == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(252),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.luojituili.cid == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(253),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.luojituili.cid == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(254),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "brain-des"
  }, [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("7")]) : _vm._e(), _vm._v(" 逻辑推理脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "six-res"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.2六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.2六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.2 六六脑解读")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-effec"
  }, [_vm._v("逻辑推理与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "nao-hel"
  }, [_c('p', [_vm._v(_vm._s(_vm.luojituili.efficiency))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(70), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic3"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "carried-out"
  }, [_vm._v("影响逻辑推理的因素")]), _vm._v(" "), _vm._m(71), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(72), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3提升方案")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.luojituili.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [(this.tuxintuiliList.length <= 4) ? _c('table', _vm._l((_vm.tuxintuiliList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e(), _vm._v(" "), (this.tuxintuiliList.length > 4) ? _c('table', _vm._l((_vm.luojituiliList1), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(73), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic5"
  })])]) : _vm._e(), _vm._v(" "), (this.tuxintuiliList.length > 4) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.luojituiliList2), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(74), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(266),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('div', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(242),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('div', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(241),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 0) ? _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("加工速度（Processing speed）是指人脑对信息的获取、存储、加工和使用的过程所需的时间。它实质上反应了认知过程的内部心理机制的变化过程。")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 1) ? _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("加工速度（Processing speed）是指个体吸收信息、处理信息、记忆信息和提取信息的快慢。加工速度主要涉及的脑网络是感觉运动网络（包括中央前回和中央后回等脑区）和注意网络（包含后顶叶等脑区）。它实质上反应了认知过程的内部心理机制的变化过程。例如，在接触新事物和学习新知识时，加工速度好的人，能很快适应新事物，找到学习的关键点，给人以“聪明灵敏”的感觉。数字符号转换 （Digital Symbol Substitution）选自韦氏智力测验的分测验（Wechsler, 1958），通过计算数字和特殊符号匹配的反应时和正确率来检测个体的速度，被广泛地用于个体加工速度的评估。该范式被广泛地应用于很多神经心理测验中作为评估个体心理发展水平的重要工具。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e()]), _vm._v(" "), (_vm.jagongsport.isboy == 0) ? _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("通过各项指标计算，您的加工速度得分为"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.jagongsport.exceed))]), _vm._v("%的人，您的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainHealth))]), _vm._v("，脑效率处"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("水平。")]), _vm._v(" "), _c('p', [_vm._v("大量神经科学和临床研究表明，参与加工速度的脑区，主要包含中央前回，中央后回、后顶叶等。根据您在数字符号转换任务中的成绩可推测出您加工速度脑网络"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("。如图6。")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 1) ? _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("在数字符号转换任务中，孩子在一定时间内答对测试题目的个数越多，即孩子反应速度越快，得分越高，在反应时上的具体表现如表1。通过各项指标计算，您的孩子加工速度得分为"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.jagongsport.exceed))]), _vm._v("%的人，孩子的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainHealth))]), _vm._v("，脑效率处"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("水平.")]), _vm._v(" "), _c('p', [_vm._v("大量神经科学和临床研究表明，参与加工速度的脑区，主要包含中央前回、中央后回、后顶叶等。这些脑区以及它们之间的功能和结构连接被科学家们称作感觉运动网络和注意网络。根据您孩子在数字符号转换任务中的成绩可推测出孩子加工速度脑网络状态"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("。如图\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.luojituili.status == 0 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("8")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.getshuzibijiao.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), _vm._v("。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nao-memory"
  }, [(_vm.jagongsport.cid == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(247),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jagongsport.cid == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(248),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jagongsport.cid == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(249),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jagongsport.cid == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(250),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-memory-bot"
  }, [_vm._v("图\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.luojituili.status == 0 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("8")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.getshuzibijiao.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), _vm._v("\n\t\t\t\t加工速度脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(75), _vm._v(" "), _c('a', {
    staticClass: "page-num processing1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "enhance-pro"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.2 六六脑解读")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-enhance"
  }, [_vm._v("加工速度与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "memory-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.jagongsport.efficiency))])]), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("影响加工速度的因素")]), _vm._v(" "), (_vm.jagongsport.isboy == 1) ? _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v("神经脉冲速度、个体精神和情绪状态、知识和兴趣等都会影响个体加工速度。研究表明，人的思维是一种脉冲，它沿着人体的神经纤维运行，速度大约是每小时250公里，但是每一个人的神经系统在传送信号脉冲时，都有速度的差别，这就是为什么有些人反应快，有些人反应慢。同时，反应快慢还与人的精神状态有关系，如果心情愉快，放松，人体处于舒服的状态，自然就反应很快。最近发表在Intensive Care Med的一项研究结果表明，值夜班后，医生的信息处理速度会有所下降，因此，睡眠充足也是保证反应灵敏的重要生理基础。此外，反应的敏捷与否，是可以通过心理调适来改变的。一般来说，人们对于兴趣浓厚的事物，往往容易引起敏捷反应，同样是学习新课程，你感兴趣的科目，学习的效率会更高；同样是一份作业，孩子感兴趣的作业，投入的注意力更集中，做的效率会更高。")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 0) ? _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v("神经脉冲速度（生理因素）、个体精神和情绪状态、知识和兴趣等都会影响个体加工速度。研究表明，人的思维是一种脉冲，它沿着人体的神经纤维运行，速度大约是每小时250公里，但是每一个人的神经系统在传送信号脉冲时，都有速度的差别，这就是为什么有些人反应快，有些人反应慢。同时，反应快慢还与人的精神状态有关系，如果心情愉快，放松，人体处于舒服的状态，自然就反应很快。最近发表在Intensive Care Med的一项研究结果表明，值夜班后，医生的信息处理速度会有所下降，因此，睡眠充足也是保证反应灵敏的重要生理基础。此外，反应的敏捷与否，是可以通过心理调适来改变的。一般来说，人们对于兴趣浓厚的事物，往往容易引起敏捷反应，同样是学习新课程，你感兴趣的科目，学习的效率会更高；同样是一份工作，您感兴趣的工作，投入的注意力更集中，做的效率会更高。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(76), _vm._v(" "), _c('a', {
    staticClass: "page-num processing2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.3 提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.3 如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.3 如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.jagongsport.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sanjaio-bot"
  }), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [(this.jiagongsuduList.length <= 4) ? _c('table', _vm._l((_vm.jiagongsuduList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e(), _vm._v(" "), (this.jiagongsuduList.length > 4) ? _c('table', _vm._l((_vm.jiagongsuduList1), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(77), _vm._v(" "), _c('a', {
    staticClass: "page-num processing3"
  })])]) : _vm._e(), _vm._v(" "), (this.jiagongsuduList.length > 4) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.jiagongsuduList2), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(78), _vm._v(" "), _c('a', {
    staticClass: "page-num processing3"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(274),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(275),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [(_vm.getTalentyou.id == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(246)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getTalentyou.id == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(245)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getTalentyou.id == 3) ? _c('img', {
    attrs: {
      "src": __webpack_require__(243)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getTalentyou.id == 4) ? _c('img', {
    attrs: {
      "src": __webpack_require__(273)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "memory-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getTalentyou.userUrl,
      "alt": "图片"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v(_vm._s(_vm.getTalentyou.introduction))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(79), _vm._v(" "), _c('a', {
    staticClass: "page-num know"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(151),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(150),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.isboy == 0) ? _c('div', {
    staticClass: "Follow-up"
  }, [_c('p', [_vm._v("1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价您的脑功能，但科学检测是深入了解脑功能的一扇门。")]), _vm._v(" "), _c('p', [_vm._v("2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使您的结果更真实。")]), _vm._v(" "), _c('p', [_vm._v("3、本检测主要用于评估您的基础脑功能，如果您想用于评价个人能力和职业发展，建议结合职业、性格等测试。此外，越全面的脑功能用于评价个人能力和职业发展的效度越高。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.isboy == 1) ? _c('div', {
    staticClass: "Follow-up"
  }, [_c('p', [_vm._v("1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价孩子的脑功能，但科学检测是深入了解脑功能的一扇门。")]), _vm._v(" "), _c('p', [_vm._v("2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使孩子的结果更真实。")]), _vm._v(" "), _c('p', [_vm._v("3、儿童和青少年时期处于脑功能发展的关键阶段，孩子的脑功能水平会随着年龄的增长而不断变化。因此，本次脑功能检测，只代表孩子现在所处年龄段的水平，建议您持续关注孩子的脑健康和脑效率。")]), _vm._v(" "), _c('p', [_vm._v("4、本检测主要用于评估孩子的基础脑功能，如果您想用于评价孩子的个人能力和学业能力发展，建议结合专业的人格、成就等测试。此外，越全面的脑功能检测，用于评价个人能力和学业能力发展的效度越高。")])]) : _vm._e(), _vm._v(" "), _vm._m(80), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(81), _vm._v(" "), _c('a', {
    staticClass: "page-num postscript"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "closePrint",
    attrs: {
      "href": "javascript:;",
      "title": "打印"
    },
    on: {
      "click": function($event) {
        _vm.print_page()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "closePage",
    attrs: {
      "href": "javascript:;",
      "title": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.print_close()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "moveUp",
    attrs: {
      "href": "javascript:;",
      "title": "回到顶部"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-corver"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(155),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-dete"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(156),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-naologo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(154),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("姓名:")]), _vm._v(" "), _c('li', [_vm._v("性别:")]), _vm._v(" "), _c('li', [_vm._v("年龄:")]), _vm._v(" "), _c('li', [_vm._v("日期:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(152),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(153),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "read-table"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("脑健康")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("人数占比")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[75~100"), _c('span', {
    staticClass: "numjia"
  }, [_vm._v("＋")])]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("出色")]), _vm._v(" "), _c('td', [_vm._v("6%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[60~75)")]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("良好")]), _vm._v(" "), _c('td', [_vm._v("24%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[25-60)")]), _vm._v(" "), _c('td', [_vm._v("亚健康")]), _vm._v(" "), _c('td', [_vm._v("中等")]), _vm._v(" "), _c('td', [_vm._v("64%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[0-25)")]), _vm._v(" "), _c('td', [_vm._v("不健康")]), _vm._v(" "), _c('td', [_vm._v("欠佳")]), _vm._v(" "), _c('td', [_vm._v("6%")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(267),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("1.综合脑功能结果与解读\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..............................................................")]), _vm._v(" "), _c('span', [_vm._v("03")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_vm._v("1.1检测结果全貌\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t ..........................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', [_vm._v("03")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1.2脑功能图谱：分析脑功能特点、优劣势及在生活的表现\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...........................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', [_vm._v("03")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1.3综合建议：解读如何根据脑功能特点扬长避短\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .........................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', [_vm._v("05")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("2.单项脑功能结果与解读\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("...............................................................")]), _vm._v(" "), _c('span', {
    staticClass: "out1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("1.单项脑功能结果与解读\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("...............................................................")]), _vm._v(" "), _c('span', {
    staticClass: "out1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t....................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                                 .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.2六六脑解读:分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.3.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  .....................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.3.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ........................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("3.您知道吗？\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("有趣案例：分析名人某项优势脑功能\n\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t                             ...............................................................................\n\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("2.您知道吗？\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("有趣案例：分析名人某项优势脑功能\n\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t                             ................................................................................\n\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("4.后记\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v(".............................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "lastpostscript"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("3.后记\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..............................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "lastpostscript"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(268),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("检测项目")]), _vm._v(" "), _c('th', [_vm._v("题目数")]), _vm._v(" "), _c('th', [_vm._v("正确数")]), _vm._v(" "), _c('th', [_vm._v("正确率")]), _vm._v(" "), _c('th', [_vm._v("反应时")]), _vm._v(" "), _c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("超过")]), _vm._v(" "), _c('th', [_vm._v("脑功能")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("脑健康")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-map"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(238),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-map"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(237),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Summarized-fea"
  }, [_c('p', [_vm._v("执行功能（executive function）指个体计划、面对诱惑的反应抑制能力、自我调节及监控等能力，执行功能涉及背外侧前额叶、前扣带回等。在日常学习、工作与生活中，做饭、开车、学习及工作规划等都会用到此功能。例如，出去旅游时，我们事先需要在网上或通过朋友介绍来搜集信息做乘车线路、旅游景点先后顺序等各种攻略，但是计划赶不上变化，我们有时会因为各种原因不能按原计划的线路去游玩，这时候就需要灵活调整自己的计划，以选择最有利的出游线路，这种旅游时做计划、灵活调整计划的能力就是我们讲的执行功能。数字比较测评任务\n\t\t\t\t（NumericComparison）是根据任务切换（Task-Switch）范式（Logan et al., 2003）改编的，通过计算从一个任务切换到另一个任务的反应时和正确率来检测个体的执行功能。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Rating-table"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("难度等级")]), _vm._v(" "), _c('th', [_vm._v("条件")]), _vm._v(" "), _c('th', [_vm._v("认知资源")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小匹配，判断大小")]), _vm._v(" "), _c('td', [_vm._v("任务切换，知觉加工")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小匹配，判断多少")]), _vm._v(" "), _c('td', [_vm._v("任务切换，抽象加工")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小不匹配，判断多少")]), _vm._v(" "), _c('td', [_vm._v("任务切换和冲突抑制，知觉加工")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小不匹配，判断大小")]), _vm._v(" "), _c('td', [_vm._v("任务切换和冲突抑制，抽象加工")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("情景记忆（Episodic Memory）是指对个人亲身经历的、发生在一定时间和地点的事件（情景）的记忆。比如，对昨天在公园里会见一位朋友的记忆就是情景记忆。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("总数")]), _vm._v(" "), _c('th', [_vm._v("正确数")]), _vm._v(" "), _c('th', {
    staticClass: "bordernone-right"
  }, [_vm._v("正确率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v("年龄是影响情景记忆的重要因素，记忆能力随着年龄增加出现衰退。近年来利用fMRI研究青年人和老年人情景记忆的差异，认为老年人记忆力的下降在一定程度上是因为对中颞叶的利用下降，记忆衰退和海马区的激活有相关性，Cabeza 的研究小组发现在平均70岁的老年人组海马区在情景提取过程比平均年龄23岁的年轻人激活减低。缺乏运动、睡眠不足、不良生活习惯、脑疲劳或脑损伤等都会导致情景记忆减退。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了记忆力的下降；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。此外，在事物间多进行形象化深度加工，可以有助于情景记忆的增强。例如，记忆一张老爷爷图片、地点：深圳、事件：跳舞这些信息时，可以通过联结一名时髦的老爷爷在繁华的深圳广场上跳广场舞，十分开心。总之，良好的联结记忆策略可以帮助增强情景记忆。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("逻辑推理（Logical Reasoning）是指一种根据周围环境和活动找出其内在的逻辑关系从而推理出符合逻辑关系的结论的能力，逻辑推理涉及背外侧前额叶、后顶叶、前扣带、脑岛等。在日常学习和生活中，经常需要用到此能力。比如，日常生活中一个人做事或说话是否有条理，就需要逻辑推理能力。逻辑推理是智力的一般因素，是与人的问题解决、清晰知觉、思维，发现和利用自己所需信息以及有效地适应社会生活的能力有关。图形推理测评任务（Figure reasoning task）选自著名的瑞文推理测验（Standard Progressive Matrices，SPM），是英国心理学家瑞文(Raven)于1938年设计的一种非文字智力测验，通过计算个体在一定时间内理性判断的正确数来检测个体的逻辑推理能力，被广泛应用于人才选拨、学业成就、智商、大脑发育水平的预测和评估中。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("难度等级")]), _vm._v(" "), _c('th', [_vm._v("认知资源")]), _vm._v(" "), _c('th', [_vm._v("总题目数")]), _vm._v(" "), _c('th', [_vm._v("正确率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carried-sport"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t深刻理解与灵活运用基础知识的能力、想象力、语言能力、情绪状态、脑疲劳或脑损伤、脑发育不良等是逻辑推理的影响因素。逻辑推理需要雄厚的知识积累，这样才能为每一步推理提供充分的依据。例如“为什么乱切的萝卜比切得整齐规则的萝卜更好煮烂、口味更好？”这个问题对一个初中生来说不知道该如何回答，而他的母亲却解释得很好。显然是因为母亲对日常生活知识的理解运用要远远强于中学生。因此，深刻理解与灵活运用基础知识的能力是个体逻辑推理能力的基础。逻辑推理有较强的灵活性和开发性，发挥想象对逻辑推理能力的提高有很大的促进作用。从多角度观察认识事物，全面地认识事物的内部与外部之间、某事物同其他事物之间的多种多样的联系，拓展自己的想象力。语言能力的好坏不仅直接影响想象力的发展，而且逻辑推理依赖于严谨的语言表达和正确的书面表达。因此，重视个体的语言培养，尤其是数学语言和几何语言的培养对个体逻辑推理能力的形成是不可或缺的关键一环。心理学研究揭示，不良的情绪会影响逻辑推理的速度和准确程度。暴怒与痛哭，持续的忧郁、烦恼与恐惧，都会对推理产生不良影响。所以，个体保持平静、轻松的情绪对逻辑推理有着重要的作用。此外，逻辑推理能力高低是由背外侧前额叶皮层、顶叶、前扣带皮层和特定的颞顶叶皮层区域的沟通效率所导致的。脑疲劳或脑损伤、脑发育不良等会引起神经活动的异常，损伤大脑皮层功能和结构，造成逻辑推理能力的不好。\n\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QR-code"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(149),
      "alt": "六六脑官方微信"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "QR-we"
  }, [_vm._v("六六脑官方微信")]), _vm._v(" "), _c('p', {
    staticClass: "QR-we",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("更多脑能力测评请登录"), _c('a', {
    attrs: {
      "target": "_Blank",
      "href": "http://cp.66nao.com"
    }
  }, [_vm._v("cp.66nao.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3),
      "alt": "图片"
    }
  })])
}]}

/***/ }),
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[361]);


// WEBPACK FOOTER //
// static/js/app.ed53148732aba96355b2.js